var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/theme/stitches.config.ts
import { createStitches, defaultThemeMap } from "@stitches/react";

// src/theme/theme-files/empty-theme-definition.js
var emptyThemeDefinition = {
  colors: {
    surfaceBackgroundPrimary: "",
    surfaceBackgroundSecondary: "",
    surfaceBackgroundTertiary: "",
    surfaceCardPrimary: "",
    surfaceCardSecondary: "",
    surfaceCardDisabled: "",
    surfaceScreenHeaderBackground: "",
    surfaceSkeletonShimmerBackground: "",
    surfaceSkeletonShimmerOverlay: "",
    onSurfaceTextPrimary: "",
    onSurfaceTextSubdued: "",
    onSurfaceTextCritical: "",
    onSurfaceTextSuccess: "",
    onSurfaceTextWarning: "",
    onSurfaceTextReversed: "",
    onSurfaceBorderSubdued: "",
    onSurfaceBorderDefault: "",
    onSurfaceIconPrimary: "",
    interactiveActionPrimary: "",
    interactiveActionHovered: "",
    interactiveActionPressed: "",
    interactiveActionSubdued: "",
    interactiveActionDisabled: "",
    interactiveBackgroundDefault: "",
    interactiveBackgroundDisabled: "",
    interactiveBackgroundHovered: "",
    interactiveBackgroundPressed: "",
    interactiveBorderDefault: "",
    interactiveBorderHovered: "",
    interactiveBorderDisabled: "",
    interactiveBorderCriticalDefault: "",
    interactiveFocusInner: "",
    interactiveFocusOuter: "",
    interactiveIconDefault: "",
    interactiveIconDisabled: "",
    criticalBackgroundSubdued: "",
    criticalBackgroundSecondary: "",
    criticalBorderDefault: "",
    criticalIcon: "",
    warningBackgroundSubdued: "",
    warningBackgroundSecondary: "",
    warningBorderDefault: "",
    warningIcon: "",
    successBackgroundSubdued: "",
    successBackgroundSecondary: "",
    successBorderDefault: "",
    successIcon: "",
    highlightBackgroundSubdued: "",
    highlightBackgroundSecondary: "",
    highlightBorderDefault: "",
    highlightIcon: "",
    decorativeBrandPrimaryDarkest: "",
    decorativeBrandPrimaryDark: "",
    decorativeBrandPrimaryDefault: "",
    decorativeBrandPrimaryBright: "",
    decorativeBrandPrimaryBrightest: "",
    decorativeBrandPrimaryPastel: "",
    decorativeBrandSecondaryDarkest: "",
    decorativeBrandSecondaryDark: "",
    decorativeBrandSecondaryDefault: "",
    decorativeBrandSecondaryBright: "",
    decorativeBrandSecondaryBrightest: "",
    decorativeBrandSecondaryPastel: "",
    decorativeBrandTertiaryDarkest: "",
    decorativeBrandTertiaryDark: "",
    decorativeBrandTertiaryDefault: "",
    decorativeBrandTertiaryBright: "",
    decorativeBrandTertiaryBrightest: "",
    decorativeBrandTertiaryPastel: "",
    primaryBackgroundDefault: "",
    primaryBackgroundHovered: "",
    primaryBackgroundPressed: "",
    primaryTextDefault: "",
    primaryBackgroundCriticalDefault: "",
    primaryBackgroundCriticalHovered: "",
    primaryBackgroundCriticalPressed: "",
    primaryTextCriticalDefault: "",
    secondaryBackgroundDefault: "",
    secondaryBackgroundHovered: "",
    secondaryBackgroundPressed: "",
    secondaryTextDefault: "",
    secondaryTextHovered: "",
    secondaryBorderDefault: "",
    tertiaryBackgroundDefault: "",
    tertiaryBackgroundHovered: "",
    tertiaryBackgroundPressed: "",
    tertiaryTextDefault: "",
    tertiaryTextHovered: "",
    tertiaryBorderDefault: "",
    inputBackgroundDefault: "",
    inputBackgroundDisabled: "",
    inputBackgroundHovered: "",
    inputBackgroundPressed: "",
    inputBorderDefault: "",
    inputBorderHovered: "",
    inputBorderDisabled: "",
    inputBorderCritical: "",
    inputBorderSuccess: "",
    inputBorderWarning: "",
    dataVizInterfaceTrackBorder: "",
    dataVizInterfaceTrackBackground: "",
    dataVizSingleColorBrand: "",
    dataVizSingleColorNeutral: "",
    dataVizStatusCritical: "",
    dataVizStatusWarning: "",
    dataVizStatusSuccess: "",
    dataVizCategoricalOne: "",
    dataVizCategoricalTwo: "",
    dataVizCategoricalThree: "",
    dataVizCategoricalFour: "",
    dataVizCategoricalFive: "",
    dataVizCategoricalSix: "",
    tagCriticalBackgroundBold: "",
    tagCriticalBackgroundSubdued: "",
    tagCriticalBorderBold: "",
    tagCriticalBorderSubdued: "",
    tagCriticalTextBold: "",
    tagCriticalTextSubdued: "",
    tagFourBackgroundBold: "",
    tagFourBackgroundSubdued: "",
    tagFourBorderBold: "",
    tagFourBorderSubdued: "",
    tagFourTextBold: "",
    tagFourTextSubdued: "",
    tagInformationalBackgroundBold: "",
    tagInformationalBackgroundSubdued: "",
    tagInformationalBorderBold: "",
    tagInformationalBorderSubdued: "",
    tagInformationalTextBold: "",
    tagInformationalTextSubdued: "",
    tagNeutralBackgroundBold: "",
    tagNeutralBackgroundSubdued: "",
    tagNeutralBorderBold: "",
    tagNeutralBorderSubdued: "",
    tagNeutralTextBold: "",
    tagNeutralTextSubdued: "",
    tagOneBackgroundBold: "",
    tagOneBackgroundSubdued: "",
    tagOneBorderBold: "",
    tagOneBorderSubdued: "",
    tagOneTextBold: "",
    tagOneTextSubdued: "",
    tagSuccessBackgroundBold: "",
    tagSuccessBackgroundSubdued: "",
    tagSuccessBorderBold: "",
    tagSuccessBorderSubdued: "",
    tagSuccessTextBold: "",
    tagSuccessTextSubdued: "",
    tagThreeBackgroundBold: "",
    tagThreeBackgroundSubdued: "",
    tagThreeBorderBold: "",
    tagThreeBorderSubdued: "",
    tagThreeTextBold: "",
    tagThreeTextSubdued: "",
    tagTwoBackgroundBold: "",
    tagTwoBackgroundSubdued: "",
    tagTwoBorderBold: "",
    tagTwoBorderSubdued: "",
    tagTwoTextBold: "",
    tagTwoTextSubdued: "",
    tagWarningBackgroundBold: "",
    tagWarningBackgroundSubdued: "",
    tagWarningBorderBold: "",
    tagWarningBorderSubdued: "",
    tagWarningTextBold: "",
    tagWarningTextSubdued: ""
  },
  space: {
    none: "",
    eighth: "",
    quarter: "",
    half: "",
    threeQuarters: "",
    one: "",
    oneAndHalf: "",
    two: "",
    twoAndHalf: "",
    three: "",
    four: "",
    five: ""
  },
  sizes: {
    none: "",
    eighth: "",
    quarter: "",
    half: "",
    threeQuarters: "",
    one: "",
    oneAndHalf: "",
    two: "",
    twoAndHalf: "",
    three: "",
    four: "",
    five: ""
  },
  fonts: {
    headings: "",
    body: "",
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    subtitleOne: "",
    subtitleTwo: "",
    bodyOne: "",
    bodyTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  fontSizes: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    subtitleOne: "",
    subtitleTwo: "",
    bodyOne: "",
    bodyTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  fontWeights: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  lineHeights: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    subtitleOne: "",
    subtitleTwo: "",
    bodyOne: "",
    bodyTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  letterSpacings: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  textDecorations: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  textTransforms: {
    headingOne: "",
    headingTwo: "",
    headingThree: "",
    headingFour: "",
    bodyOne: "",
    bodyOneSecondary: "",
    bodyTwo: "",
    bodyTwoSecondary: "",
    subtitleOne: "",
    subtitleTwo: "",
    buttonOne: "",
    buttonTwo: "",
    label: "",
    overline: "",
    caption: "",
    tab: ""
  },
  borderWidths: {
    thin: "",
    thick: "",
    card: ""
  },
  zIndices: {
    default: "",
    sticky: "",
    dropdown: "",
    tooltip: "",
    modal: "",
    toast: ""
  },
  transitions: {
    defaultTime: ""
  },
  radii: {
    none: "",
    thin: "",
    thick: "",
    small: "",
    medium: "",
    large: "",
    extraLarge: "",
    huge: "",
    pill: "",
    circle: "",
    button: "",
    inputField: "",
    card: "",
    progressBar: "",
    tags: ""
  },
  shadows: {
    card: "",
    dropdown: ""
  }
};

// src/theme/utils/typography.ts
var typography = (token) => ({
  fontSize: token,
  fontWeight: token,
  fontFamily: token,
  lineHeight: token,
  letterSpacing: token,
  textTransform: token,
  textDecoration: token
});

// src/theme/utils/margins.ts
var marginX = (value) => ({
  marginInlineStart: value,
  marginInlineEnd: value
});
var marginY = (value) => ({
  marginTop: value,
  marginBottom: value
});

// src/theme/utils/padding.ts
var paddingX = (value) => ({
  paddingInlineStart: value,
  paddingInlineEnd: value
});
var paddingY = (value) => ({
  paddingTop: value,
  paddingBottom: value
});

// src/breakpoints/constants.ts
var breakpoints = {
  mobile: 0,
  mobileLandscape: 641,
  tablet: 768,
  laptop: 1024,
  desktop: 1280
};

// src/breakpoints/media-queries-map.ts
var mediaQueryMap = {
  mobile: `(max-width:${breakpoints.mobileLandscape - 0.01}px)`,
  mobileLandscape: `(min-width:${breakpoints.mobileLandscape}px) and (max-width:${breakpoints.tablet - 0.01}px)`,
  tablet: `(min-width:${breakpoints.tablet}px) and (max-width:${breakpoints.laptop - 0.01}px)`,
  laptop: `(min-width:${breakpoints.laptop}px) and (max-width:${breakpoints.desktop - 0.01}px)`,
  desktop: `(min-width:${breakpoints.desktop}px)`
};

// src/pseudolocalize-string-children.tsx
import { Children } from "react";
var shouldPseudolocalize = typeof window !== "undefined" && window.document.documentElement.lang === "bidi";
var pseudolocalizeChild = (child) => {
  if (typeof child === "string") {
    return `\u202E${child}\u202C`;
  }
  return child;
};
var pseudolocalize = (children) => {
  if (Children.count(children) === 1) {
    return pseudolocalizeChild(children);
  }
  if (Children.count(children) > 1) {
    return Children.map(children, pseudolocalizeChild);
  }
  return children;
};

// src/theme/stitches.config.ts
var themeDefinition = {
  theme: emptyThemeDefinition,
  // Empty theme to be overwritten with a client theme
  media: mediaQueryMap,
  utils: {
    typography,
    marginX,
    marginY,
    paddingX,
    paddingY
  },
  themeMap: __spreadProps(__spreadValues({}, defaultThemeMap), {
    textTransform: "textTransforms",
    textDecoration: "textDecorations",
    marginX: "space",
    marginY: "space",
    paddingX: "space",
    paddingY: "space",
    borderStartStartRadius: "radii",
    borderStartEndRadius: "radii",
    borderEndStartRadius: "radii",
    borderEndEndRadius: "radii",
    borderBlockStartColor: "colors",
    borderBlockEndColor: "colors",
    borderBlockStartWidth: "borderWidths",
    borderBlockEndWidth: "borderWidths",
    borderInlineStartColor: "colors",
    borderInlineEndColor: "colors",
    borderInlineStartWidth: "borderWidths",
    borderInlineEndWidth: "borderWidths"
  }),
  prefix: "GDS"
};
var { styled, theme, createTheme, config, css, keyframes, globalCss } = createStitches(themeDefinition);
var transformingStyled = shouldPseudolocalize ? (...args) => {
  const StyledComponent = styled(...args);
  const originalRender = StyledComponent.render;
  StyledComponent.render = (_a, ref) => {
    var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
    return originalRender(__spreadValues({ children: pseudolocalize(children) }, rest), ref);
  };
  return StyledComponent;
} : styled;

// src/theme/GDSThemeProvider.tsx
import React3, { createContext as createContext2 } from "react";

// src/theme/theme-container.tsx
import React, { forwardRef } from "react";
import * as RadixTooltipPrimitive from "@radix-ui/react-tooltip";

// src/theme/utils/focus-outline.ts
var focusOutlineOuter = {
  outline: "$borderWidths$outerFocus solid $colors$interactiveFocusOuter",
  outlineOffset: "$borderWidths$outerFocus"
};
var focusOutlineInner = {
  boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
  // Visible in Windows high-contrast themes
  outline: "$borderWidths$innerFocus  solid transparent"
};

// src/theme/theme-container.tsx
var ThemeContainerBase = transformingStyled("div", {
  /**
   * Feel free to use this CSS variable to control directionality-dependent
   * transformations in your UI components.
   */
  "--league-is-rtl": "0",
  "&:dir(rtl)": {
    "--league-is-rtl": "1"
  },
  '[class*="GDS"]': {
    "&:focus": __spreadValues({}, focusOutlineOuter),
    "&, *": {
      "&, &:before, &:after": {
        boxSizing: "border-box"
      }
    }
  }
});
var ThemeContainer = forwardRef(
  (_a, ref) => {
    var _b = _a, { theme: theme2, children } = _b, props = __objRest(_b, ["theme", "children"]);
    return /* @__PURE__ */ React.createElement(ThemeContainerBase, __spreadValues({ ref, className: theme2 }, props), /* @__PURE__ */ React.createElement(RadixTooltipPrimitive.Provider, null, children));
  }
);

// src/constants.ts
var EnableGenesisCoreInspector = "ENABLE_GENESIS_CORE_INSPECTOR";

// src/theme/text-directionality-provider.tsx
import React2, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState
} from "react";
import { DirectionProvider } from "@radix-ui/react-direction";
var DIRECTIONALITIES = ["ltr", "rtl"];
var isTextDirectionality = (value) => DIRECTIONALITIES.includes(value);
var DEFAULT_TEXT_DIRECTIONALITY = "ltr";
var TextDirectionalityContext = createContext(
  DEFAULT_TEXT_DIRECTIONALITY
);
var getElementTextDirectionality = (element) => {
  const ourElement = element || typeof window !== "undefined" && window.document.body;
  if (!ourElement) {
    return DEFAULT_TEXT_DIRECTIONALITY;
  }
  let currentElement = ourElement;
  while (currentElement) {
    if (isTextDirectionality(currentElement.dir)) {
      return currentElement.dir;
    }
    currentElement = currentElement.parentElement;
  }
  return DEFAULT_TEXT_DIRECTIONALITY;
};
var TextDirectionalityProvider = ({
  children
}) => {
  const [textDirectionality, setTextDirectionality] = useState(
    getElementTextDirectionality
  );
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      setTextDirectionality(getElementTextDirectionality(ref.current));
    }
  }, []);
  return /* @__PURE__ */ React2.createElement(TextDirectionalityContext.Provider, { value: textDirectionality }, /* @__PURE__ */ React2.createElement(DirectionProvider, { dir: textDirectionality }, children), /* @__PURE__ */ React2.createElement("span", { "aria-hidden": "true", id: "text-directionality-detector", ref }));
};
var useTextDirectionality = () => useContext(TextDirectionalityContext);

// src/theme/GDSThemeProvider.tsx
var ThemeContext = createContext2(void 0);
var getGenesisCoreInspectorStatus = () => window.localStorage.getItem(EnableGenesisCoreInspector) === "true";
var GDSThemeProvider = ({ theme: theme2, children }) => {
  if (theme2 === void 0) {
    throw new Error("GDSThemeProvider requires a theme object.");
  }
  const isGenesisCoreInspectorEnabled = getGenesisCoreInspectorStatus();
  if (isGenesisCoreInspectorEnabled) {
    console.warn(
      "Genesis Core Inspector is enabled. You may experience a layout shift in some block level elements that may appear inline due to the added Genesis Core Inspector styles."
    );
  }
  return /* @__PURE__ */ React3.createElement(TextDirectionalityProvider, null, /* @__PURE__ */ React3.createElement(ThemeContext.Provider, { value: theme2 }, /* @__PURE__ */ React3.createElement(ThemeContainer, { theme: theme2 }, children)));
};

// src/theme/theme-files/archetype-light-theme.ts
var archetypeLightTheme = {
  colors: {
    surface: {
      background: {
        primary: "#FFFFFFFF",
        secondary: "#F2F2F2FF",
        tertiary: "#E8E8E8FF"
      },
      card: {
        primary: "#F2F2F2FF",
        secondary: "#FFFFFFFF",
        disabled: "#D7D7D7FF"
      },
      screenHeader: { background: "#E8E8E8FF" },
      skeleton: {
        shimmer: {
          background: "#E7E7E7FF",
          overlay: "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)"
        }
      }
    },
    onSurface: {
      text: {
        primary: "#1A1A1AFF",
        subdued: "#545454FF",
        reversed: "#FFFFFFFF",
        critical: "#DD0E0EFF",
        success: "#507C03FF",
        warning: "#C94F08FF"
      },
      border: { subdued: "#EFEFEFFF", default: "#C2C2C2FF", card: "#EBEBEBFF" },
      icon: { primary: "#636363FF" }
    },
    interactive: {
      action: {
        primary: "#1A1A1AFF",
        hovered: "#000000FF",
        pressed: "#1A1A1AFF",
        subdued: "#66686BFF",
        disabled: "#D6D6D6FF"
      },
      icon: { default: "#FFFFFFFF", disabled: "#949494FF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      },
      border: {
        default: "#949494FF",
        hovered: "#4E4E4EFF",
        disabled: "#D6D6D6FF",
        critical: { default: "#DD0E0EFF" }
      },
      focus: { inner: "#1A1A1AFF", outer: "#1A1A1AFF" }
    },
    critical: {
      background: { subdued: "#F9E1E2FF", secondary: "#FFFFFFFF" },
      border: { default: "#DD0E0EFF" },
      icon: "#DD0E0EFF"
    },
    warning: {
      background: { subdued: "#FAE8D6FF", secondary: "#FFFFFFFF" },
      border: { default: "#C94F08FF" },
      icon: "#C94F08FF"
    },
    success: {
      background: { subdued: "#F6FCEBFF", secondary: "#FFFFFFFF" },
      border: { default: "#507C03FF" },
      icon: "#507C03FF"
    },
    highlight: {
      background: { subdued: "#EDF8FFFF", secondary: "#FFFFFFFF" },
      border: { default: "#2E5CDFFF" },
      icon: "#2E5CDFFF"
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#1A1A1AFF",
          dark: "#4B4B4BFF",
          default: "#7F7F7FFF",
          bright: "#B9B9B9FF",
          brightest: "#ECECECFF",
          pastel: "#FAFAFAFF"
        },
        secondary: {
          darkest: "#1A1A1AFF",
          dark: "#4B4B4BFF",
          default: "#7F7F7FFF",
          bright: "#B9B9B9FF",
          brightest: "#ECECECFF",
          pastel: "#FAFAFAFF"
        },
        tertiary: {
          darkest: "#1A1A1AFF",
          dark: "#4B4B4BFF",
          default: "#7F7F7FFF",
          bright: "#B9B9B9FF",
          brightest: "#ECECECFF",
          pastel: "#FAFAFAFF"
        }
      }
    },
    primary: {
      background: {
        default: "#1A1A1AFF",
        hovered: "#000000FF",
        pressed: "#1A1A1AFF",
        critical: {
          default: "#DD0E0EFF",
          hovered: "#B51414FF",
          pressed: "#DD0E0EFF"
        }
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } }
    },
    secondary: {
      background: {
        default: "#FFFFFFFF",
        hovered: "#DCDCDCFF",
        pressed: "#F0F0F0FF"
      },
      text: { default: "#1A1A1AFF", hovered: "#1A1A1AFF" },
      border: { default: "#1A1A1AFF" }
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#DCDCDCFF",
        pressed: "#F0F0F0FF"
      },
      text: { default: "#1A1A1AFF", hovered: "#1A1A1AFF" },
      border: { default: "#DCDCDCFF" }
    },
    input: {
      border: {
        success: "#507C03FF",
        warning: "#C94F08FF",
        default: "#949494FF",
        hovered: "#4E4E4EFF",
        disabled: "#D6D6D6FF",
        critical: "#DD0E0EFF"
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      }
    },
    dataViz: {
      interface: { track: { border: "#F5F5F5FF", background: "#F5F5F5FF" } },
      singleColor: { brand: "#1A1A1AFF", neutral: "#959595FF" },
      status: {
        critical: "#DD0E0EFF",
        warning: "#F16501FF",
        success: "#0DA80AFF"
      },
      categorical: {
        one: "#1A1A1AFF",
        two: "#6212E6FF",
        three: "#F0184CFF",
        four: "#2695E6FF",
        five: "#F16501FF",
        six: "#0DA80AFF"
      }
    },
    tag: {
      neutral: {
        background: { bold: "#3B3B3BFF", subdued: "#E9E9E9FF" },
        border: { bold: "#3B3B3BFF", subdued: "#E9E9E9FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      one: {
        background: { bold: "#501CD2FF", subdued: "#EDEAF5FF" },
        border: { bold: "#501CD2FF", subdued: "#EDEAF5FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      two: {
        background: { bold: "#135D03FF", subdued: "#DEEADCFF" },
        border: { bold: "#135D03FF", subdued: "#DEEADCFF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      three: {
        background: { bold: "#994000FF", subdued: "#F2EEE6FF" },
        border: { bold: "#994000FF", subdued: "#F2EEE6FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      four: {
        background: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        border: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#1A1A1AFF" }
      },
      success: {
        background: { bold: "#008A09FF", subdued: "#E3F7F0FF" },
        border: { bold: "#008A09FF", subdued: "#E3F7F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#02692BFF" }
      },
      warning: {
        background: { bold: "#B85B0FFF", subdued: "#FAE8D6FF" },
        border: { bold: "#B85B0FFF", subdued: "#FAE8D6FF" },
        text: { bold: "#FFFFFFFF", subdued: "#9F3703FF" }
      },
      critical: {
        background: { bold: "#DD0E0EFF", subdued: "#F9E1E2FF" },
        border: { bold: "#DD0E0EFF", subdued: "#F9E1E2FF" },
        text: { bold: "#FFFFFFFF", subdued: "#BB1111FF" }
      },
      informational: {
        background: { bold: "#2E5CDFFF", subdued: "#E8F8FFFF" },
        border: { bold: "#2E5CDFFF", subdued: "#E8F8FFFF" },
        text: { bold: "#FFFFFFFF", subdued: "#225ECEFF" }
      }
    }
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: "#00000000" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" }
  },
  typography: {
    headingOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingThree: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingFour: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOneSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwoSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    buttonOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    buttonTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    label: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    overline: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none"
    },
    caption: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    tab: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    }
  },
  spacing: {
    none: 0,
    eighth: 2,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
    progressBar: 9999,
    tags: 4
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4e3,
    tooltip: 5e3,
    modal: 8e3,
    toast: 9e3
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  },
  transitions: { defaultTime: "200ms" }
};

// src/theme/theme-files/archetype-dark-theme.ts
var archetypeDarkTheme = {
  colors: {
    surface: {
      background: {
        primary: "#111111FF",
        secondary: "#333333FF",
        tertiary: "#555555FF"
      },
      card: {
        primary: "#3D3D3DFF",
        secondary: "#000000FF",
        disabled: "#585858FF"
      },
      screenHeader: { background: "#DEF3FCFF" },
      skeleton: {
        shimmer: {
          background: "#E7E7E7FF",
          overlay: "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)"
        }
      }
    },
    onSurface: {
      text: {
        primary: "#F9F9F9FF",
        subdued: "#CECECEFF",
        reversed: "#000000FF",
        critical: "#EF6782FF",
        success: "#BCF5E2FF",
        warning: "#F9F9F9FF"
      },
      border: { subdued: "#515B66FF", default: "#ADADADFF", card: "#959595FF" },
      icon: { primary: "#CACACAFF" }
    },
    interactive: {
      action: {
        primary: "#72D1FEFF",
        hovered: "#99D3EEFF",
        pressed: "#28BBFFFF",
        subdued: "#D3D3D3FF",
        disabled: "#A8A8A8FF"
      },
      icon: { default: "#171717FF", disabled: "#474747FF" },
      background: {
        default: "#000000FF",
        disabled: "#1A1D22FF",
        hovered: "#070707FF",
        pressed: "#101010FF"
      },
      border: {
        default: "#ADADADFF",
        hovered: "#72D1FEFF",
        disabled: "#474747FF",
        critical: { default: "#EF6782FF" }
      },
      focus: { inner: "#A3BDF3FF", outer: "#9AB5EDFF" }
    },
    critical: {
      background: { subdued: "#5E0407FF", secondary: "#000000FF" },
      border: { default: "#F8D7D9FF" },
      icon: "#F491A5FF"
    },
    warning: {
      background: { subdued: "#443D00FF", secondary: "#000000FF" },
      border: { default: "#FFF0A2FF" },
      icon: "#FFF0A2FF"
    },
    success: {
      background: { subdued: "#0E6932FF", secondary: "#000000FF" },
      border: { default: "#9AEFD3FF" },
      icon: "#9AEFD3FF"
    },
    highlight: {
      background: { subdued: "#00374FFF", secondary: "#000000FF" },
      border: { default: "#94ACEFFF" },
      icon: "#C6EAFAFF"
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#F1FAFFFF",
          dark: "#C0E7FFFF",
          default: "#6BC5EFFF",
          bright: "#1C7EBBFF",
          brightest: "#074E7AFF",
          pastel: "#03253AFF"
        },
        secondary: {
          darkest: "#FFF8EAFF",
          dark: "#FFE4B0FF",
          default: "#F5C464FF",
          bright: "#F2A818FF",
          brightest: "#C2891BFF",
          pastel: "#845A09FF"
        },
        tertiary: {
          darkest: "#CCFF9AFF",
          dark: "#56FE64FF",
          default: "#18F2A4FF",
          bright: "#12B67BFF",
          brightest: "#0C7952FF",
          pastel: "#063D29FF"
        }
      }
    },
    primary: {
      background: {
        default: "#0F80B4FF",
        hovered: "#36A7DCFF",
        pressed: "#06A4EFFF",
        critical: {
          default: "#CB2A32FF",
          hovered: "#E13557FF",
          pressed: "#E75A76FF"
        }
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } }
    },
    secondary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#333333FF",
        pressed: "#1B1B1BFF"
      },
      text: { default: "#06A4EFFF", hovered: "#FFFFFFFF" },
      border: { default: "#06A4EFFF" }
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#F0F0F0FF",
        pressed: "#E1E1E1FF"
      },
      text: { default: "#C1C1C1FF", hovered: "#1E1E1EFF" },
      border: { default: "#C1C1C1FF" }
    },
    input: {
      border: {
        success: "#B3CE84FF",
        warning: "#FFF0A2FF",
        default: "#ADADADFF",
        hovered: "#72D1FEFF",
        disabled: "#474747FF",
        critical: "#EF6782FF"
      },
      background: {
        default: "#000000FF",
        disabled: "#1A1D22FF",
        hovered: "#070707FF",
        pressed: "#101010FF"
      }
    },
    dataViz: {
      interface: { track: { border: "#959595FF", background: "#F5F5F5FF" } },
      singleColor: { brand: "#008BCCFF", neutral: "#959595FF" },
      status: {
        critical: "#CB2A32FF",
        warning: "#DE6F12FF",
        success: "#159369FF"
      },
      categorical: {
        one: "#008BCCFF",
        two: "#074664FF",
        three: "#00699AFF",
        four: "#C2891BFF",
        five: "#845A09FF",
        six: "#008B82FF"
      }
    }
  },
  shadows: {
    card: { x: 0, y: 2, blur: 6, spread: 0, color: "#FFFFFF14" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#FFFFFF1A" }
  },
  typography: {
    headingOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingThree: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingFour: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOneSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwoSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    buttonOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    buttonTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    label: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    overline: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none"
    },
    caption: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    tab: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    }
  },
  spacing: {
    none: 0,
    eighth: 2,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4e3,
    tooltip: 5e3,
    modal: 8e3,
    toast: 9e3
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  },
  transitions: { defaultTime: "200ms" }
};

// src/theme/theme-files/league-b2b-theme.ts
var leagueTheme = {
  colors: {
    surface: {
      background: {
        primary: "#FFFFFFFF",
        secondary: "#F8F8F8FF",
        tertiary: "#EAEEFBFF"
      },
      card: {
        primary: "#F8F7F6FF",
        secondary: "#FFFFFFFF",
        disabled: "#D7D7D7FF"
      },
      skeleton: {
        shimmer: {
          background: "#E7E7E7FF",
          overlay: "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)"
        }
      }
    },
    onSurface: {
      text: {
        primary: "#250D53FF",
        subdued: "#66686BFF",
        reversed: "#FFFFFFFF",
        critical: "#BA1B3BFF",
        success: "#00805AFF",
        warning: "#222222FF"
      },
      border: { subdued: "#D6D6D6FF", default: "#66686BFF" },
      icon: { primary: "#66686BFF" }
    },
    interactive: {
      action: {
        primary: "#501CD2FF",
        hovered: "#37209AFF",
        pressed: "#251669FF",
        subdued: "#66686BFF",
        disabled: "#D6D6D6FF"
      },
      icon: { default: "#FFFFFFFF", disabled: "#949494FF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#F0F0F0FF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      },
      border: {
        default: "#949494FF",
        hovered: "#501CD2FF",
        disabled: "#D6D6D6FF",
        critical: { default: "#BA1B3BFF" }
      },
      focus: { inner: "#501CD2FF", outer: "#501CD2FF" }
    },
    critical: {
      background: { subdued: "#F9DEE3FF", secondary: "#FFFFFFFF" },
      border: { default: "#BA1B3BFF" },
      icon: "#BA1B3BFF"
    },
    warning: {
      background: { subdued: "#FFE4BBFF", secondary: "#FFFFFFFF" },
      border: { default: "#CF6902FF" },
      icon: "#CF6902FF"
    },
    success: {
      background: { subdued: "#E5F6F1FF", secondary: "#FFFFFFFF" },
      border: { default: "#00A876FF" },
      icon: "#00A876FF"
    },
    highlight: {
      background: { subdued: "#EAEEFBFF", secondary: "#FFFFFFFF" },
      border: { default: "#2E5CDFFF" },
      icon: "#2E5CDFFF"
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#250D53FF",
          dark: "#3E16A3FF",
          default: "#501CD2FF",
          bright: "#B9A4EDFF",
          brightest: "#DCD2F6FF",
          pastel: "#EDE8FAFF"
        },
        secondary: {
          darkest: "#15846DFF",
          dark: "#00A886FF",
          default: "#01C3A2FF",
          bright: "#A5E7DAFF",
          brightest: "#D2F3ECFF",
          pastel: "#E8F8F5FF"
        },
        tertiary: {
          darkest: "#6E748EFF",
          dark: "#6E748EFF",
          default: "#C4CFFDFF",
          bright: "#D4DCFEFF",
          brightest: "#E4E9FEFF",
          pastel: "#F3F5FFFF"
        }
      }
    },
    primary: {
      background: {
        default: "#501CD2FF",
        hovered: "#37209AFF",
        pressed: "#251669FF",
        critical: {
          default: "#BA1B3BFF",
          hovered: "#A51834FF",
          pressed: "#711124FF"
        }
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } }
    },
    secondary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#37209AFF",
        pressed: "#251669FF"
      },
      text: { default: "#501CD2FF", hovered: "#FFFFFFFF" },
      border: { default: "#501CD2FF" }
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#37209AFF",
        pressed: "#251669FF"
      },
      text: { default: "#66686BFF", hovered: "#FFFFFFFF" },
      border: { default: "#949494FF" }
    },
    input: {
      border: {
        success: "#00A876FF",
        warning: "#CF6902FF",
        default: "#949494FF",
        hovered: "#501CD2FF",
        disabled: "#D6D6D6FF",
        critical: "#BA1B3BFF"
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#F0F0F0FF",
        hovered: "#F8F8F8FF",
        pressed: "#F0F0F0FF"
      }
    }
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: "#00000000" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" }
  },
  typography: {
    headingOne: {
      fontFamily: "Mark Offc Pro",
      fontWeight: 700,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingTwo: {
      fontFamily: "Mark Offc Pro",
      fontWeight: 700,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingThree: {
      fontFamily: "Mark Offc Pro",
      fontWeight: 700,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    headingFour: {
      fontFamily: "Mark Offc Pro",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0.25,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    subtitleTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyOneSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    bodyTwoSecondary: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none"
    },
    buttonOne: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    buttonTwo: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    label: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    overline: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none"
    },
    caption: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    },
    tab: {
      fontFamily: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0.1599999964237213,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none"
    }
  },
  spacing: {
    none: 0,
    eighth: 2,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 3,
    inputField: 6
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4e3,
    tooltip: 5e3,
    modal: 8e3,
    toast: 9e3
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "Mark Offc Pro",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  },
  transitions: { defaultTime: "200ms" }
};

// src/theme/formatters/utils.ts
var lowercaseFirstLetter = (string) => string.slice(0, 1).toLowerCase() + string.slice(1);
var uppercaseFirstLetter = (string) => string.slice(0, 1).toUpperCase() + string.slice(1);
var toUnit = (input, unit2) => {
  const converted = {};
  Object.keys(input).forEach((key) => {
    if (typeof input[key] === "string") {
      const valueAsString = String(input[key]);
      converted[key] = valueAsString.indexOf("$") === 0 ? valueAsString : `${input[key]}${unit2}`;
    } else {
      const valueAsNumber = Number(input[key]);
      converted[key] = valueAsNumber === 0 ? valueAsNumber : `${input[key]}${unit2}`;
    }
  });
  return converted;
};
var toPx = (input) => toUnit(input, "px");
var toRem = (input) => toUnit(input, "rem");
var flattenNestedTokens = (input = {}) => {
  const result = {};
  function getTokenPath(haystack, path = []) {
    Object.keys(haystack).forEach((key) => {
      const value = haystack[key];
      if (typeof value === "string" || Number.isFinite(value)) {
        const nestedKey = [...path, key].map(
          (part, index) => index === 0 ? lowercaseFirstLetter(part) : uppercaseFirstLetter(part)
        ).join("");
        result[nestedKey] = value;
      } else {
        getTokenPath(value, [...path, key]);
      }
    });
  }
  getTokenPath(input);
  return result;
};
var getNegativeSpacing = (spacing) => {
  const negativeSpacing = {};
  Object.keys(spacing).forEach((spacingKey) => {
    const spacingValue = spacing[spacingKey];
    if (spacingValue !== 0 && !`${spacingValue}`.includes("$")) {
      negativeSpacing[`minus${uppercaseFirstLetter(spacingKey)}`] = spacingValue * -1;
    }
  });
  return negativeSpacing;
};
var fontWeightsByName = {
  thin: 100,
  extralight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
  extrablack: 950
};
var fontWeightNameAliases = {
  normal: "regular",
  heavy: "black",
  ultraheavy: "extrablack"
};
var getFontWeightNumberByName = (name) => {
  const formattedName = name.replace(/[^a-zA-Z]*/gi, "").toLowerCase();
  const fontWeightToken = formattedName in fontWeightsByName ? formattedName : fontWeightNameAliases[formattedName];
  return fontWeightsByName[fontWeightToken];
};
var getFontWeightTokenByNumber = (fontWeight) => {
  let fontWeightToken = "regular";
  Object.entries(fontWeightsByName).forEach(
    ([fontWeightKey, fontWeightValue]) => {
      if (fontWeightValue === fontWeight) {
        fontWeightToken = fontWeightKey;
      }
    }
  );
  return fontWeightToken;
};

// src/theme/formatters/format-theme-for-stitches.ts
var getColors = (themeInput) => {
  const result = flattenNestedTokens(themeInput == null ? void 0 : themeInput.colors);
  return result;
};
var getRemSpacing = (rawSpacing, baseSize) => {
  const typedEntries = Object.entries(rawSpacing);
  return typedEntries.reduce(
    (remSpacing, [spacingKey, spacingValue]) => __spreadProps(__spreadValues({}, remSpacing), {
      [spacingKey]: spacingValue !== void 0 ? spacingValue / baseSize : 0
    }),
    {}
  );
};
var getSpacing = ({ spacing: rawSpacing, typography: typography2, rem: { baseSize } }, useRems) => {
  const spacing = useRems ? getRemSpacing(rawSpacing, baseSize) : __spreadValues({}, rawSpacing);
  if (typography2) {
    const themeSpace = __spreadValues({}, spacing);
    Object.entries(typography2).forEach(
      ([typographyKey, { paragraphSpacing }]) => {
        Object.keys(themeSpace).forEach((spacingKey) => {
          if (themeSpace[spacingKey] === paragraphSpacing) {
            spacing[typographyKey] = `$${spacingKey}`;
          }
        });
      }
    );
  }
  return spacing;
};
var getFonts = (themeInput) => {
  const fonts = {};
  if (themeInput == null ? void 0 : themeInput.fonts) {
    Object.entries(themeInput.fonts).forEach(
      ([font, value]) => {
        fonts[font] = value;
      }
    );
  }
  if (themeInput == null ? void 0 : themeInput.typography) {
    const themeFonts = __spreadValues({}, fonts);
    Object.entries(themeInput.typography).forEach(
      ([typographyKey, { fontFamily }]) => {
        Object.keys(themeFonts).forEach((fontKey) => {
          if (themeFonts[fontKey] === fontFamily) {
            fonts[typographyKey] = `$${fontKey}`;
          }
        });
      }
    );
  }
  return fonts;
};
var getRemForProperty = (themeInput, property) => {
  var _a;
  const remValues = {};
  if ((_a = themeInput == null ? void 0 : themeInput.rem) == null ? void 0 : _a[property]) {
    Object.entries(themeInput.rem[property]).forEach(
      ([propertySize, value]) => {
        remValues[propertySize] = value;
      }
    );
  }
  Object.keys(themeInput.typography).forEach((typographyKey) => {
    if (!remValues[typographyKey]) {
      Object.keys(remValues).forEach((propertySizeKey) => {
        if (typographyKey.indexOf(propertySizeKey) > -1) {
          remValues[typographyKey] = `$${propertySizeKey}`;
        }
      });
    }
  });
  return toRem(remValues);
};
var getValuesForProperty = ({ typography: typography2 }, property) => {
  const tokenValues = {};
  if (typography2) {
    Object.entries(typography2).forEach(
      ([typographyKey, typographyToken]) => {
        const tokenValue = typographyToken[property];
        const aliasKey = Object.keys(tokenValues).find(
          (key) => typographyKey.indexOf(key) > -1 && typographyKey.length > key.length
        );
        tokenValues[typographyKey] = aliasKey ? `$${aliasKey}` : tokenValue;
      }
    );
  }
  return tokenValues;
};
var getPxValuesForProperty = (themeInput, property) => toPx(getValuesForProperty(themeInput, property));
var getRemFontSizes = (themeInput) => getRemForProperty(themeInput, "fontSizes");
var getPxFontSizes = (themeInput) => getPxValuesForProperty(themeInput, "fontSize");
var getRemLineHeights = (themeInput) => getRemForProperty(themeInput, "lineHeights");
var getPxLineHeights = (themeInput) => getPxValuesForProperty(themeInput, "lineHeight");
var getLetterSpacings = (themeInput) => getPxValuesForProperty(themeInput, "letterSpacing");
var getFontWeights = (themeInput) => {
  const fontWeights = {};
  if (themeInput == null ? void 0 : themeInput.fontWeights) {
    Object.entries(themeInput.fontWeights).forEach(
      ([font, value]) => {
        fontWeights[font] = value;
      }
    );
  }
  if (themeInput == null ? void 0 : themeInput.typography) {
    Object.entries(themeInput.typography).forEach(
      ([typographyKey, { fontWeight }]) => {
        if (typeof fontWeight === "string") {
          const fontWeightValue = getFontWeightNumberByName(
            fontWeight
          );
          const fontWeightToken = getFontWeightTokenByNumber(fontWeightValue);
          if (!fontWeights[fontWeightToken]) {
            fontWeights[fontWeightToken] = fontWeightValue;
          }
          fontWeights[typographyKey] = `$${fontWeightToken}`;
        } else {
          fontWeights[typographyKey] = fontWeight;
        }
      }
    );
  }
  return fontWeights;
};
var getTextTransforms = (themeInput) => getValuesForProperty(themeInput, "textCase");
var getTextDecorations = (themeInput) => getValuesForProperty(themeInput, "textDecoration");
var getBorderWidths = (themeInput) => {
  const borderWidths = {};
  if (themeInput == null ? void 0 : themeInput.borderWidths) {
    Object.entries(themeInput.borderWidths).forEach(
      ([borderWidth, value]) => {
        if (borderWidth) {
          borderWidths[borderWidth] = value || 0;
        }
      }
    );
  }
  return toPx(borderWidths);
};
var getBorderRadii = (themeInput) => {
  const borderRadii = {};
  if (themeInput == null ? void 0 : themeInput.borderRadii) {
    Object.entries(themeInput.borderRadii).forEach(
      ([borderRadius, value]) => {
        if (borderRadius) {
          borderRadii[borderRadius] = value || 0;
        }
      }
    );
  }
  return toPx(borderRadii);
};
var getShadows = (themeInput) => {
  const shadows = {};
  if (themeInput == null ? void 0 : themeInput.shadows) {
    Object.entries(themeInput.shadows).forEach(
      ([shadowKey, { x, y, blur, spread, color }]) => {
        shadows[shadowKey] = `${x}px ${y}px ${blur}px ${spread}px ${color}`;
      }
    );
  }
  return shadows;
};
var getZIndices = (themeInput) => {
  const zIndices = {};
  if (themeInput == null ? void 0 : themeInput.zIndices) {
    Object.entries(themeInput.zIndices).forEach(
      ([zIndex, value]) => {
        zIndices[zIndex] = value;
      }
    );
  }
  return zIndices;
};
var getTransitions = (themeInput) => {
  const transitions = {};
  if (themeInput == null ? void 0 : themeInput.transitions) {
    Object.entries(themeInput.transitions).forEach(
      ([transition2, value]) => {
        transitions[transition2] = value;
      }
    );
  }
  return transitions;
};
var formatThemeForStitches = (theme2) => {
  const remSpacing = getSpacing(theme2, true);
  const pxSpacing = getSpacing(theme2, false);
  const rem = {
    space: toRem(__spreadValues(__spreadValues({}, remSpacing), getNegativeSpacing(remSpacing))),
    sizes: toRem(remSpacing),
    fontSizes: getRemFontSizes(theme2),
    lineHeights: getRemLineHeights(theme2)
  };
  const px = {
    space: toPx(__spreadValues(__spreadValues({}, pxSpacing), getNegativeSpacing(pxSpacing))),
    sizes: toPx(pxSpacing),
    fontSizes: getPxFontSizes(theme2),
    lineHeights: getPxLineHeights(theme2)
  };
  return {
    rem,
    px,
    colors: getColors(theme2),
    fonts: getFonts(theme2),
    fontWeights: getFontWeights(theme2),
    letterSpacings: getLetterSpacings(theme2),
    textTransforms: getTextTransforms(theme2),
    textDecorations: getTextDecorations(theme2),
    borderWidths: getBorderWidths(theme2),
    radii: getBorderRadii(theme2),
    shadows: getShadows(theme2),
    zIndices: getZIndices(theme2),
    transitions: getTransitions(theme2)
  };
};

// src/theme/icons/base-icon-map.ts
import capabilityClaims from "./assets/base-icons/capabilityClaims.svg";
import capabilityClaimsFilled from "./assets/base-icons/capabilityClaimsFilled.svg";
import capabilityGroupChallenges from "./assets/base-icons/capabilityGroupChallenges.svg";
import capabilityJourney from "./assets/base-icons/capabilityJourney.svg";
import capabilityJourneyFilled from "./assets/base-icons/capabilityJourneyFilled.svg";
import capabilityMarketplace from "./assets/base-icons/capabilityMarketplace.svg";
import capabilityWallet from "./assets/base-icons/capabilityWallet.svg";
import capabilityWalletFilled from "./assets/base-icons/capabilityWalletFilled.svg";
import descriptiveAlarmClock from "./assets/base-icons/descriptiveAlarmClock.svg";
import descriptiveAmbulance from "./assets/base-icons/descriptiveAmbulance.svg";
import descriptiveBuildings from "./assets/base-icons/descriptiveBuildings.svg";
import descriptiveCalendar from "./assets/base-icons/descriptiveCalendar.svg";
import descriptiveChatHistory from "./assets/base-icons/descriptiveChatHistory.svg";
import descriptiveCheckBadge from "./assets/base-icons/descriptiveCheckBadge.svg";
import descriptiveClock from "./assets/base-icons/descriptiveClock.svg";
import descriptiveCompose from "./assets/base-icons/descriptiveCompose.svg";
import descriptiveCreditCardPayment from "./assets/base-icons/descriptiveCreditCardPayment.svg";
import descriptiveDocument from "./assets/base-icons/descriptiveDocument.svg";
import descriptiveFaceID from "./assets/base-icons/descriptiveFaceID.svg";
import descriptiveFilter from "./assets/base-icons/descriptiveFilter.svg";
import descriptiveFlag from "./assets/base-icons/descriptiveFlag.svg";
import descriptiveGraphTrendingUp from "./assets/base-icons/descriptiveGraphTrendingUp.svg";
import descriptiveHealthClipboard from "./assets/base-icons/descriptiveHealthClipboard.svg";
import descriptiveHeart from "./assets/base-icons/descriptiveHeart.svg";
import descriptiveHeartFilled from "./assets/base-icons/descriptiveHeartFilled.svg";
import descriptiveHeartRateUp from "./assets/base-icons/descriptiveHeartRateUp.svg";
import descriptiveHome from "./assets/base-icons/descriptiveHome.svg";
import descriptiveHome2 from "./assets/base-icons/descriptiveHome2.svg";
import descriptiveHomeFilled from "./assets/base-icons/descriptiveHomeFilled.svg";
import descriptiveInformationDesk from "./assets/base-icons/descriptiveInformationDesk.svg";
import descriptiveInsurance from "./assets/base-icons/descriptiveInsurance.svg";
import descriptiveLockPerson from "./assets/base-icons/descriptiveLockPerson.svg";
import descriptiveLockShield from "./assets/base-icons/descriptiveLockShield.svg";
import descriptiveLockTree from "./assets/base-icons/descriptiveLockTree.svg";
import descriptiveMail from "./assets/base-icons/descriptiveMail.svg";
import descriptiveMobileAlertUser from "./assets/base-icons/descriptiveMobileAlertUser.svg";
import descriptiveMoneyBill from "./assets/base-icons/descriptiveMoneyBill.svg";
import descriptiveNotifications from "./assets/base-icons/descriptiveNotifications.svg";
import descriptiveParking from "./assets/base-icons/descriptiveParking.svg";
import descriptivePaymentCard from "./assets/base-icons/descriptivePaymentCard.svg";
import descriptivePeople from "./assets/base-icons/descriptivePeople.svg";
import descriptivePerson from "./assets/base-icons/descriptivePerson.svg";
import descriptivePersonalInfo from "./assets/base-icons/descriptivePersonalInfo.svg";
import descriptivePersonFilled from "./assets/base-icons/descriptivePersonFilled.svg";
import descriptivePhone from "./assets/base-icons/descriptivePhone.svg";
import descriptivePill from "./assets/base-icons/descriptivePill.svg";
import descriptivePillFilled from "./assets/base-icons/descriptivePillFilled.svg";
import descriptiveQuestionBox from "./assets/base-icons/descriptiveQuestionBox.svg";
import descriptiveSecurityLock from "./assets/base-icons/descriptiveSecurityLock.svg";
import descriptiveSettings from "./assets/base-icons/descriptiveSettings.svg";
import descriptiveShop from "./assets/base-icons/descriptiveShop.svg";
import descriptiveShopFilled from "./assets/base-icons/descriptiveShopFilled.svg";
import descriptiveStarRibbon from "./assets/base-icons/descriptiveStarRibbon.svg";
import descriptiveStudentRecertification from "./assets/base-icons/descriptiveStudentRecertification.svg";
import descriptiveSupportQuestionChat from "./assets/base-icons/descriptiveSupportQuestionChat.svg";
import descriptiveSupportQuestionChatFilled from "./assets/base-icons/descriptiveSupportQuestionChatFilled.svg";
import descriptiveTouchID from "./assets/base-icons/descriptiveTouchID.svg";
import descriptiveTransitBus from "./assets/base-icons/descriptiveTransitBus.svg";
import descriptiveUmbrella from "./assets/base-icons/descriptiveUmbrella.svg";
import descriptiveWebsite from "./assets/base-icons/descriptiveWebsite.svg";
import descriptiveWheelchairAccessibility from "./assets/base-icons/descriptiveWheelchairAccessibility.svg";
import interfaceArrowLeft from "./assets/base-icons/interfaceArrowLeft.svg";
import interfaceArrowRight from "./assets/base-icons/interfaceArrowRight.svg";
import interfaceCheckmark from "./assets/base-icons/interfaceCheckmark.svg";
import interfaceChevronDown from "./assets/base-icons/interfaceChevronDown.svg";
import interfaceChevronLeft from "./assets/base-icons/interfaceChevronLeft.svg";
import interfaceChevronRight from "./assets/base-icons/interfaceChevronRight.svg";
import interfaceChevronUp from "./assets/base-icons/interfaceChevronUp.svg";
import interfaceClose from "./assets/base-icons/interfaceClose.svg";
import interfaceCopy from "./assets/base-icons/interfaceCopy.svg";
import interfaceChange from "./assets/base-icons/interfaceChange.svg";
import interfaceDelete from "./assets/base-icons/interfaceDelete.svg";
import interfaceDownload from "./assets/base-icons/interfaceDownload.svg";
import interfaceEdit from "./assets/base-icons/interfaceEdit.svg";
import interfaceEndKey from "./assets/base-icons/interfaceEndKey.svg";
import interfaceExternalLink from "./assets/base-icons/interfaceExternalLink.svg";
import interfaceExternalShare from "./assets/base-icons/interfaceExternalShare.svg";
import interfaceHidden from "./assets/base-icons/interfaceHidden.svg";
import interfaceHomeKey from "./assets/base-icons/interfaceHomeKey.svg";
import interfaceMeatballs from "./assets/base-icons/interfaceMeatballs.svg";
import interfaceMenu from "./assets/base-icons/interfaceMenu.svg";
import interfaceMinus from "./assets/base-icons/interfaceMinus.svg";
import interfacePlus from "./assets/base-icons/interfacePlus.svg";
import interfacePrint from "./assets/base-icons/interfacePrint.svg";
import interfaceQuestionCircle from "./assets/base-icons/interfaceQuestionCircle.svg";
import interfaceQuestionCircleFilled from "./assets/base-icons/interfaceQuestionCircleFilled.svg";
import interfaceRefresh from "./assets/base-icons/interfaceRefresh.svg";
import interfaceSearch from "./assets/base-icons/interfaceSearch.svg";
import interfaceSignOut from "./assets/base-icons/interfaceSignOut.svg";
import interfaceStar from "./assets/base-icons/interfaceStar.svg";
import interfaceURL from "./assets/base-icons/interfaceURL.svg";
import interfaceVisible from "./assets/base-icons/interfaceVisible.svg";
import statusAlert from "./assets/base-icons/statusAlert.svg";
import statusAlertFill from "./assets/base-icons/statusAlertFill.svg";
import statusErrorStatus from "./assets/base-icons/statusErrorStatus.svg";
import statusErrorStatusFilled from "./assets/base-icons/statusErrorStatusFilled.svg";
import statusInformationCircle from "./assets/base-icons/statusInformationCircle.svg";
import statusInformationCircle2 from "./assets/base-icons/statusInformationCircle2.svg";
import statusInformationCircle2Filled from "./assets/base-icons/statusInformationCircle2Filled.svg";
import statusInformationCircleFill from "./assets/base-icons/statusInformationCircleFill.svg";
import statusSuccessStatus from "./assets/base-icons/statusSuccessStatus.svg";
import statusSuccessStatusFilled from "./assets/base-icons/statusSuccessStatusFilled.svg";
import tinyAlert from "./assets/base-icons/tinyAlert.svg";
import tinyBackButton from "./assets/base-icons/tinyBackButton.svg";
import tinyCircleStar from "./assets/base-icons/tinyCircleStar.svg";
import tinyClear from "./assets/base-icons/tinyClear.svg";
import tinyClose from "./assets/base-icons/tinyClose.svg";
import tinyDisclosureIndicator from "./assets/base-icons/tinyDisclosureIndicator.svg";
import tinyExternalLink from "./assets/base-icons/tinyExternalLink.svg";
import tinyHelper from "./assets/base-icons/tinyHelper.svg";
import tinyHelperFilled from "./assets/base-icons/tinyHelperFilled.svg";
import tinyNewWindowInternal from "./assets/base-icons/tinyNewWindowInternal.svg";
import tinyStar from "./assets/base-icons/tinyStar.svg";
import tinyValidationCheck from "./assets/base-icons/tinyValidationCheck.svg";
var CAPABILITY_ICONS = {
  capabilityGroupChallenges,
  capabilityJourney,
  capabilityJourneyFilled,
  capabilityMarketplace,
  capabilityWallet,
  capabilityWalletFilled,
  capabilityClaims,
  capabilityClaimsFilled
};
var DESCRIPTIVE_ICONS = {
  descriptiveAlarmClock,
  descriptiveAmbulance,
  descriptiveBuildings,
  descriptiveCalendar,
  descriptiveChatHistory,
  descriptiveCheckBadge,
  descriptiveClock,
  descriptiveCompose,
  descriptiveCreditCardPayment,
  descriptiveDocument,
  descriptiveFaceID,
  descriptiveFilter,
  descriptiveFlag,
  descriptiveGraphTrendingUp,
  descriptiveHealthClipboard,
  descriptiveHeart,
  descriptiveHeartFilled,
  descriptiveHeartRateUp,
  descriptiveHome,
  descriptiveHome2,
  descriptiveHomeFilled,
  descriptiveInformationDesk,
  descriptiveInsurance,
  descriptiveLockPerson,
  descriptiveLockShield,
  descriptiveLockTree,
  descriptiveMail,
  descriptiveMobileAlertUser,
  descriptiveMoneyBill,
  descriptiveNotifications,
  descriptiveParking,
  descriptivePaymentCard,
  descriptivePeople,
  descriptivePerson,
  descriptivePersonFilled,
  descriptivePersonalInfo,
  descriptivePhone,
  descriptivePill,
  descriptivePillFilled,
  descriptiveQuestionBox,
  descriptiveSecurityLock,
  descriptiveSettings,
  descriptiveShop,
  descriptiveShopFilled,
  descriptiveStarRibbon,
  descriptiveSupportQuestionChat,
  descriptiveSupportQuestionChatFilled,
  descriptiveTouchID,
  descriptiveTransitBus,
  descriptiveUmbrella,
  descriptiveWebsite,
  descriptiveWheelchairAccessibility,
  descriptiveStudentRecertification
};
var INTERFACE_ICONS = {
  interfaceArrowLeft,
  interfaceArrowRight,
  interfaceCheckmark,
  interfaceChevronDown,
  interfaceChevronLeft,
  interfaceChevronRight,
  interfaceChevronUp,
  interfaceClose,
  interfaceCopy,
  interfaceChange,
  interfaceDelete,
  interfaceDownload,
  interfaceEdit,
  interfaceEndKey,
  interfaceExternalLink,
  interfaceExternalShare,
  interfaceHidden,
  interfaceHomeKey,
  interfaceMeatballs,
  interfaceMenu,
  interfaceMinus,
  interfacePlus,
  interfacePrint,
  interfaceQuestionCircle,
  interfaceQuestionCircleFilled,
  interfaceRefresh,
  interfaceSearch,
  interfaceSignOut,
  interfaceStar,
  interfaceURL,
  interfaceVisible
};
var STATUS_ICONS = {
  statusAlert,
  statusAlertFill,
  statusErrorStatus,
  statusErrorStatusFilled,
  statusInformationCircle,
  statusInformationCircle2,
  statusInformationCircle2Filled,
  statusInformationCircleFill,
  statusSuccessStatus,
  statusSuccessStatusFilled
};
var TINY_ICONS = {
  tinyAlert,
  tinyBackButton,
  tinyCircleStar,
  tinyClear,
  tinyClose,
  tinyDisclosureIndicator,
  tinyExternalLink,
  tinyHelper,
  tinyHelperFilled,
  tinyNewWindowInternal,
  tinyStar,
  tinyValidationCheck
};
var BASE_ICON_MAP = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, CAPABILITY_ICONS), DESCRIPTIVE_ICONS), INTERFACE_ICONS), STATUS_ICONS), TINY_ICONS);

// src/theme/icons/get-theme-icons.ts
var getThemeIcons = (customIcons) => __spreadValues(__spreadValues({}, BASE_ICON_MAP), customIcons);

// src/theme/global-strings.ts
var GDS_STRINGS = {
  clear: "Clear",
  close: "Close",
  disclosure: "",
  dismiss: "Dismiss",
  externalLink: "opens an external link",
  loadingText: "Loading",
  newTabInternal: "opens in a new tab",
  newWindowInternal: "opens in new window",
  next: "Next",
  optional: "optional",
  previous: "Previous",
  moreOptions: "More options"
};
var GDS_CORE_ALPHA_STRINGS = {
  paginationPage: "Page",
  paginationLabel: "Pagination",
  paginationLabelNextPage: "Next Page",
  paginationLabelPrevPage: "Previous Page",
  paginationLabelFirstPage: "(First Page)",
  paginationLabelLastPage: "(Last page)"
};
var getThemeStrings = (customStrings) => __spreadValues(__spreadValues(__spreadValues({}, GDS_STRINGS), GDS_CORE_ALPHA_STRINGS), customStrings);

// src/theme/utils/get-fallback-values.ts
import { has, get, set, cloneDeep } from "lodash";

// src/theme/utils/theme-fallback-values.ts
var fallbackTokens = {
  "borderRadii.card": "borderRadii.medium",
  "borderRadii.progressBar": "borderRadii.circle",
  "borderRadii.tags": "4",
  "borderWidths.card": "borderWidths.thin",
  "colors.input.background.default": "colors.interactive.background.default",
  "colors.input.background.disabled": "colors.interactive.background.disabled",
  "colors.input.background.hovered": "colors.interactive.background.hovered",
  "colors.input.background.pressed": "colors.interactive.background.pressed",
  "colors.input.border.critical": "colors.interactive.border.critical.default",
  "colors.input.border.default": "colors.interactive.border.default",
  "colors.input.border.disabled": "colors.interactive.border.disabled",
  "colors.input.border.hovered": "colors.interactive.border.hovered",
  "colors.input.border.success": "colors.success.border.default",
  "colors.input.border.warning": "colors.warning.border.default",
  "colors.onSurface.border.card": "colors.onSurface.border.subdued",
  "colors.surface.skeleton.shimmer.background": "#E7E7E7FF",
  "colors.surface.skeleton.shimmer.overlay": "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)",
  "colors.tag.critical.background.bold": "#DD0E0EFF",
  "colors.tag.critical.background.subdued": "#F9E1E2FF",
  "colors.tag.critical.border.bold": "#DD0E0EFF",
  "colors.tag.critical.border.subdued": "#F9E1E2FF",
  "colors.tag.critical.text.bold": "#FFFFFFFF",
  "colors.tag.critical.text.subdued": "#BB1111FF",
  "colors.tag.four.background.bold": "#870644FF",
  "colors.tag.four.background.subdued": "#F2E1F0FF",
  "colors.tag.four.border.bold": "#870644FF",
  "colors.tag.four.border.subdued": "#F2E1F0FF",
  "colors.tag.four.text.bold": "#FFFFFFFF",
  "colors.tag.four.text.subdued": "#1A1A1AFF",
  "colors.tag.informational.background.bold": "#2E5CDFFF",
  "colors.tag.informational.background.subdued": "#E8F8FFFF",
  "colors.tag.informational.border.bold": "#2E5CDFFF",
  "colors.tag.informational.border.subdued": "#E8F8FFFF",
  "colors.tag.informational.text.bold": "#FFFFFFFF",
  "colors.tag.informational.text.subdued": "#225ECEFF",
  "colors.tag.neutral.background.bold": "#3B3B3BFF",
  "colors.tag.neutral.background.subdued": "#E9E9E9FF",
  "colors.tag.neutral.border.bold": "#3B3B3BFF",
  "colors.tag.neutral.border.subdued": "#E9E9E9FF",
  "colors.tag.neutral.text.bold": "#FFFFFFFF",
  "colors.tag.neutral.text.subdued": "#1A1A1AFF",
  "colors.tag.one.background.bold": "#501CD2FF",
  "colors.tag.one.background.subdued": "#EDEAF5FF",
  "colors.tag.one.border.bold": "#501CD2FF",
  "colors.tag.one.border.subdued": "#EDEAF5FF",
  "colors.tag.one.text.bold": "#FFFFFFFF",
  "colors.tag.one.text.subdued": "#1A1A1AFF",
  "colors.tag.success.background.bold": "#008A09FF",
  "colors.tag.success.background.subdued": "#E3F7F0FF",
  "colors.tag.success.border.bold": "#008A09FF",
  "colors.tag.success.border.subdued": "#E3F7F0FF",
  "colors.tag.success.text.bold": "#FFFFFFFF",
  "colors.tag.success.text.subdued": "#02692BFF",
  "colors.tag.three.background.bold": "#994000FF",
  "colors.tag.three.background.subdued": "#F2EEE6FF",
  "colors.tag.three.border.bold": "#994000FF",
  "colors.tag.three.border.subdued": "#F2EEE6FF",
  "colors.tag.three.text.bold": "#FFFFFFFF",
  "colors.tag.three.text.subdued": "#1A1A1AFF",
  "colors.tag.two.background.bold": "#135D03FF",
  "colors.tag.two.background.subdued": "#DEEADCFF",
  "colors.tag.two.border.bold": "#135D03FF",
  "colors.tag.two.border.subdued": "#DEEADCFF",
  "colors.tag.two.text.bold": "#FFFFFFFF",
  "colors.tag.two.text.subdued": "#1A1A1AFF",
  "colors.tag.warning.background.bold": "#B85B0FFF",
  "colors.tag.warning.background.subdued": "#FAE8D6FF",
  "colors.tag.warning.border.bold": "#B85B0FFF",
  "colors.tag.warning.border.subdued": "#FAE8D6FF",
  "colors.tag.warning.text.bold": "#FFFFFFFF",
  "colors.tag.warning.text.subdued": "#9F3703FF",
  "spacing.eighth": "2"
};

// src/theme/utils/get-fallback-values.ts
var isNodeTestEnv = () => {
  var _a;
  const nodeEnvPropName = "NODE_ENV";
  return typeof process !== "undefined" && ((_a = process.env) == null ? void 0 : _a[nodeEnvPropName]) === "test";
};
var diffMessageTemplate = (diffList, themeName) => `Genesis Design System: Following tokens have been added to your ${themeName || ""} theme with fallback values. For all fallback color tokens please ensure they meet WCAG 2.2 color contrast requirements when used in combination with other colors in your theme. You can update your theme if you wish to provide custom values for these tokens.

${diffList.join(`
`)}
`;
var getFallbackValues = (clientTheme, themeName) => {
  const clientThemeClone = cloneDeep(clientTheme);
  const fallbackTokensAdded = [];
  Object.entries(fallbackTokens).forEach(([key, value]) => {
    if (!has(clientThemeClone, key)) {
      const fallbackValue = get(clientThemeClone, fallbackTokens[key]);
      if (fallbackValue) {
        fallbackTokensAdded.push(`- ${key}: ${fallbackValue}`);
        set(clientThemeClone, key, fallbackValue);
      } else {
        fallbackTokensAdded.push(`- ${key}: ${value}`);
        set(clientThemeClone, key, value);
      }
    }
  });
  const diffMessage = diffMessageTemplate(fallbackTokensAdded, themeName);
  if (!isNodeTestEnv()) {
    console.warn(diffMessage);
  }
  return clientThemeClone;
};

// src/theme/load-theme.ts
var scalesWithNumberValues = [
  "radii",
  "sizes",
  "space",
  "borderWidths"
];
var extractRawValue = (tokenScale) => Object.entries(tokenScale).reduce(
  (newTokenScale, [token, tokenValue]) => {
    const rawValue = parseInt(tokenValue.value, 10);
    return Number.isFinite(rawValue) ? __spreadProps(__spreadValues({}, newTokenScale), {
      [token]: rawValue
    }) : newTokenScale;
  },
  {}
);
var extractRawPxValue = (tokenScale) => Object.entries(tokenScale).reduce(
  (newTokenScale, [token, tokenValue]) => {
    const rawValue = parseInt(tokenValue, 10);
    return Number.isFinite(rawValue) ? __spreadProps(__spreadValues({}, newTokenScale), {
      [token]: rawValue
    }) : newTokenScale;
  },
  {}
);
var extractRawValues = (theme2, px) => {
  const extractedValues = Object.entries(theme2).filter(
    ([tokenScale]) => scalesWithNumberValues.includes(tokenScale)
  ).reduce(
    (rawTokenValues, [themeKey, tokenScale]) => __spreadProps(__spreadValues({}, rawTokenValues), {
      [themeKey]: ["space", "sizes"].includes(themeKey) ? extractRawPxValue(px[themeKey]) : extractRawValue(tokenScale)
    }),
    {}
  );
  return extractedValues;
};
var loadTheme = (theme2, {
  themeName,
  customIcons,
  customStrings,
  useRems = true
} = {
  useRems: true
}) => {
  const resolvedTheme = getFallbackValues(theme2, themeName);
  const _a = formatThemeForStitches(resolvedTheme), { rem, px } = _a, formatted = __objRest(_a, ["rem", "px"]);
  const relativeOrStaticProperties = useRems ? rem : px;
  const formattedTheme = __spreadValues(__spreadValues({}, relativeOrStaticProperties), formatted);
  const stitchesTheme = themeName ? createTheme(themeName, formattedTheme) : createTheme(formattedTheme);
  const rawValues = extractRawValues(stitchesTheme, px);
  return __spreadProps(__spreadValues({}, stitchesTheme), {
    icons: getThemeIcons(customIcons),
    strings: getThemeStrings(customStrings),
    rawValues
  });
};

// src/theme/utils/border-width-token-map.ts
var borderWidthTokenMap = {
  thin: "$thin",
  thick: "$thick",
  card: "$card"
};

// src/theme/utils/space-token-map.ts
var spacingTokenMap = {
  none: "$none",
  eighth: "$eighth",
  quarter: "$quarter",
  half: "$half",
  threeQuarters: "$threeQuarters",
  one: "$one",
  oneAndHalf: "$oneAndHalf",
  two: "$two",
  twoAndHalf: "$twoAndHalf",
  three: "$three",
  four: "$four",
  five: "$five"
};

// src/theme/utils/color-token-map.ts
var colorTokenMap = {
  surfaceBackgroundPrimary: "$surfaceBackgroundPrimary",
  surfaceBackgroundSecondary: "$surfaceBackgroundSecondary",
  surfaceBackgroundTertiary: "$surfaceBackgroundTertiary",
  surfaceCardPrimary: "$surfaceCardPrimary",
  surfaceCardSecondary: "$surfaceCardSecondary",
  surfaceCardDisabled: "$surfaceCardDisabled",
  surfaceScreenHeaderBackground: "$surfaceScreenHeaderBackground",
  surfaceSkeletonShimmerBackground: "$surfaceSkeletonShimmerBackground",
  surfaceSkeletonShimmerOverlay: "$surfaceSkeletonShimmerOverlay",
  onSurfaceTextPrimary: "$onSurfaceTextPrimary",
  onSurfaceTextSubdued: "$onSurfaceTextSubdued",
  onSurfaceTextCritical: "$onSurfaceTextCritical",
  onSurfaceTextSuccess: "$onSurfaceTextSuccess",
  onSurfaceTextWarning: "$onSurfaceTextWarning",
  onSurfaceTextReversed: "$onSurfaceTextReversed",
  onSurfaceBorderSubdued: "$onSurfaceBorderSubdued",
  onSurfaceBorderDefault: "$onSurfaceBorderDefault",
  onSurfaceIconPrimary: "$onSurfaceIconPrimary",
  interactiveActionPrimary: "$interactiveActionPrimary",
  interactiveActionHovered: "$interactiveActionHovered",
  interactiveActionPressed: "$interactiveActionPressed",
  interactiveActionSubdued: "$interactiveActionSubdued",
  interactiveActionDisabled: "$interactiveActionDisabled",
  interactiveBackgroundDefault: "$interactiveBackgroundDefault",
  interactiveBackgroundDisabled: "$interactiveBackgroundDisabled",
  interactiveBackgroundHovered: "$interactiveBackgroundHovered",
  interactiveBackgroundPressed: "$interactiveBackgroundPressed",
  interactiveBorderDefault: "$interactiveBorderDefault",
  interactiveBorderHovered: "$interactiveBorderHovered",
  interactiveBorderDisabled: "$interactiveBorderDisabled",
  interactiveBorderCriticalDefault: "$interactiveBorderCriticalDefault",
  interactiveFocusInner: "$interactiveFocusInner",
  interactiveFocusOuter: "$interactiveFocusOuter",
  interactiveIconDefault: "$interactiveIconDefault",
  interactiveIconDisabled: "$interactiveIconDisabled",
  criticalBackgroundSubdued: "$criticalBackgroundSubdued",
  criticalBackgroundSecondary: "$criticalBackgroundSecondary",
  criticalBorderDefault: "$criticalBorderDefault",
  criticalIcon: "$criticalIcon",
  warningBackgroundSubdued: "$warningBackgroundSubdued",
  warningBackgroundSecondary: "$warningBackgroundSecondary",
  warningBorderDefault: "$warningBorderDefault",
  warningIcon: "$warningIcon",
  successBackgroundSubdued: "$successBackgroundSubdued",
  successBackgroundSecondary: "$successBackgroundSecondary",
  successBorderDefault: "$successBorderDefault",
  successIcon: "$successIcon",
  highlightBackgroundSubdued: "$highlightBackgroundSubdued",
  highlightBackgroundSecondary: "$highlightBackgroundSecondary",
  highlightBorderDefault: "$highlightBorderDefault",
  highlightIcon: "$highlightIcon",
  decorativeBrandPrimaryDarkest: "$decorativeBrandPrimaryDarkest",
  decorativeBrandPrimaryDark: "$decorativeBrandPrimaryDark",
  decorativeBrandPrimaryDefault: "$decorativeBrandPrimaryDefault",
  decorativeBrandPrimaryBright: "$decorativeBrandPrimaryBright",
  decorativeBrandPrimaryBrightest: "$decorativeBrandPrimaryBrightest",
  decorativeBrandPrimaryPastel: "$decorativeBrandPrimaryPastel",
  decorativeBrandSecondaryDarkest: "$decorativeBrandSecondaryDarkest",
  decorativeBrandSecondaryDark: "$decorativeBrandSecondaryDark",
  decorativeBrandSecondaryDefault: "$decorativeBrandSecondaryDefault",
  decorativeBrandSecondaryBright: "$decorativeBrandSecondaryBright",
  decorativeBrandSecondaryBrightest: "$decorativeBrandSecondaryBrightest",
  decorativeBrandSecondaryPastel: "$decorativeBrandSecondaryPastel",
  decorativeBrandTertiaryDarkest: "$decorativeBrandTertiaryDarkest",
  decorativeBrandTertiaryDark: "$decorativeBrandTertiaryDark",
  decorativeBrandTertiaryDefault: "$decorativeBrandTertiaryDefault",
  decorativeBrandTertiaryBright: "$decorativeBrandTertiaryBright",
  decorativeBrandTertiaryBrightest: "$decorativeBrandTertiaryBrightest",
  decorativeBrandTertiaryPastel: "$decorativeBrandTertiaryPastel",
  primaryBackgroundDefault: "$primaryBackgroundDefault",
  primaryBackgroundHovered: "$primaryBackgroundHovered",
  primaryBackgroundPressed: "$primaryBackgroundPressed",
  primaryTextDefault: "$primaryTextDefault",
  primaryBackgroundCriticalDefault: "$primaryBackgroundCriticalDefault",
  primaryBackgroundCriticalHovered: "$primaryBackgroundCriticalHovered",
  primaryBackgroundCriticalPressed: "$primaryBackgroundCriticalPressed",
  primaryTextCriticalDefault: "$primaryTextCriticalDefault",
  secondaryBackgroundDefault: "$secondaryBackgroundDefault",
  secondaryBackgroundHovered: "$secondaryBackgroundHovered",
  secondaryBackgroundPressed: "$secondaryBackgroundPressed",
  secondaryTextDefault: "$secondaryTextDefault",
  secondaryTextHovered: "$secondaryTextHovered",
  secondaryBorderDefault: "$secondaryBorderDefault",
  tertiaryBackgroundDefault: "$tertiaryBackgroundDefault",
  tertiaryBackgroundHovered: "$tertiaryBackgroundHovered",
  tertiaryBackgroundPressed: "$tertiaryBackgroundPressed",
  tertiaryTextDefault: "$tertiaryTextDefault",
  tertiaryTextHovered: "$tertiaryTextHovered",
  tertiaryBorderDefault: "$tertiaryBorderDefault",
  inputBackgroundDefault: "$inputBackgroundDefault",
  inputBackgroundDisabled: "$inputBackgroundDisabled",
  inputBackgroundHovered: "$inputBackgroundHovered",
  inputBackgroundPressed: "$inputBackgroundPressed",
  inputBorderDefault: "$inputBorderDefault",
  inputBorderHovered: "$inputBorderHovered",
  inputBorderDisabled: "$inputBorderDisabled",
  inputBorderCritical: "$inputBorderCritical",
  inputBorderSuccess: "$inputBorderSuccess",
  inputBorderWarning: "$inputBorderWarning",
  dataVizInterfaceTrackBorder: "$dataVizInterfaceTrackBorder",
  dataVizInterfaceTrackBackground: "$dataVizInterfaceTrackBackground",
  dataVizSingleColorBrand: "$dataVizSingleColorBrand",
  dataVizSingleColorNeutral: "$dataVizSingleColorNeutral",
  dataVizStatusCritical: "$dataVizStatusCritical",
  dataVizStatusWarning: "$dataVizStatusWarning",
  dataVizStatusSuccess: "$dataVizStatusSuccess",
  dataVizCategoricalOne: "$dataVizCategoricalOne",
  dataVizCategoricalTwo: "$dataVizCategoricalTwo",
  dataVizCategoricalThree: "$dataVizCategoricalThree",
  dataVizCategoricalFour: "$dataVizCategoricalFour",
  dataVizCategoricalFive: "$dataVizCategoricalFive",
  dataVizCategoricalSix: "$dataVizCategoricalSix",
  tagCriticalBackgroundBold: "$tagCriticalBackgroundBold",
  tagCriticalBackgroundSubdued: "$tagCriticalBackgroundSubdued",
  tagCriticalBorderBold: "$tagCriticalBorderBold",
  tagCriticalBorderSubdued: "$tagCriticalBorderSubdued",
  tagCriticalTextBold: "$tagCriticalTextBold",
  tagCriticalTextSubdued: "$tagCriticalTextSubdued",
  tagFourBackgroundBold: "$tagFourBackgroundBold",
  tagFourBackgroundSubdued: "$tagFourBackgroundSubdued",
  tagFourBorderBold: "$tagFourBorderBold",
  tagFourBorderSubdued: "$tagFourBorderSubdued",
  tagFourTextBold: "$tagFourTextBold",
  tagFourTextSubdued: "$tagFourTextSubdued",
  tagInformationalBackgroundBold: "$tagInformationalBackgroundBold",
  tagInformationalBackgroundSubdued: "$tagInformationalBackgroundSubdued",
  tagInformationalBorderBold: "$tagInformationalBorderBold",
  tagInformationalBorderSubdued: "$tagInformationalBorderSubdued",
  tagInformationalTextBold: "$tagInformationalTextBold",
  tagInformationalTextSubdued: "$tagInformationalTextSubdued",
  tagNeutralBackgroundBold: "$tagNeutralBackgroundBold",
  tagNeutralBackgroundSubdued: "$tagNeutralBackgroundSubdued",
  tagNeutralBorderBold: "$tagNeutralBorderBold",
  tagNeutralBorderSubdued: "$tagNeutralBorderSubdued",
  tagNeutralTextBold: "$tagNeutralTextBold",
  tagNeutralTextSubdued: "$tagNeutralTextSubdued",
  tagOneBackgroundBold: "$tagOneBackgroundBold",
  tagOneBackgroundSubdued: "$tagOneBackgroundSubdued",
  tagOneBorderBold: "$tagOneBorderBold",
  tagOneBorderSubdued: "$tagOneBorderSubdued",
  tagOneTextBold: "$tagOneTextBold",
  tagOneTextSubdued: "$tagOneTextSubdued",
  tagSuccessBackgroundBold: "$tagSuccessBackgroundBold",
  tagSuccessBackgroundSubdued: "$tagSuccessBackgroundSubdued",
  tagSuccessBorderBold: "$tagSuccessBorderBold",
  tagSuccessBorderSubdued: "$tagSuccessBorderSubdued",
  tagSuccessTextBold: "$tagSuccessTextBold",
  tagSuccessTextSubdued: "$tagSuccessTextSubdued",
  tagThreeBackgroundBold: "$tagThreeBackgroundBold",
  tagThreeBackgroundSubdued: "$tagThreeBackgroundSubdued",
  tagThreeBorderBold: "$tagThreeBorderBold",
  tagThreeBorderSubdued: "$tagThreeBorderSubdued",
  tagThreeTextBold: "$tagThreeTextBold",
  tagThreeTextSubdued: "$tagThreeTextSubdued",
  tagTwoBackgroundBold: "$tagTwoBackgroundBold",
  tagTwoBackgroundSubdued: "$tagTwoBackgroundSubdued",
  tagTwoBorderBold: "$tagTwoBorderBold",
  tagTwoBorderSubdued: "$tagTwoBorderSubdued",
  tagTwoTextBold: "$tagTwoTextBold",
  tagTwoTextSubdued: "$tagTwoTextSubdued",
  tagWarningBackgroundBold: "$tagWarningBackgroundBold",
  tagWarningBackgroundSubdued: "$tagWarningBackgroundSubdued",
  tagWarningBorderBold: "$tagWarningBorderBold",
  tagWarningBorderSubdued: "$tagWarningBorderSubdued",
  tagWarningTextBold: "$tagWarningTextBold",
  tagWarningTextSubdued: "$tagWarningTextSubdued"
};

// src/components/utils/check-is-textaction.ts
import { isValidElement } from "react";
var checkIsTextAction = (textAction) => {
  if (!textAction || !isValidElement(textAction)) {
    return false;
  }
  const textActionType = textAction == null ? void 0 : textAction.type;
  const isValidChild = !(typeof textActionType === "string" || textActionType && "displayName" in textActionType && typeof textActionType.displayName === "string" && !textActionType.displayName.includes("TextAction"));
  if (!isValidChild) {
    console.error("The textAction slot only accepts the TextAction component.");
  }
  return isValidChild;
};

// src/components/utils/use-clickable-card.ts
import { useRef as useRef2, useState as useState2, useCallback, useLayoutEffect } from "react";
var useClickableCard = () => {
  const primaryActionRef = useRef2(null);
  const clickAreaRef = useRef2(null);
  const [up2, setUp] = useState2(0);
  const [down2, setDown] = useState2(0);
  const [isIgnoredClick, setIsIgnoredClick] = useState2(null);
  const onCardMouseDown = useCallback(() => setDown(+/* @__PURE__ */ new Date()), []);
  const onCardMouseUp = useCallback(
    (event) => {
      event.preventDefault();
      const target = event.target;
      const isIgnoredTarget = target.closest("[data-ignore-click]") !== null;
      setIsIgnoredClick(isIgnoredTarget);
      return setUp(+/* @__PURE__ */ new Date());
    },
    [setIsIgnoredClick]
  );
  useLayoutEffect(() => {
    const clickDuration = up2 - down2;
    const isClickStarted = clickDuration > 0;
    const isShortClick = clickDuration < 500;
    const isWithinClickThreshold = isClickStarted && isShortClick;
    const isPrimaryActionClicked = primaryActionRef.current === document.activeElement;
    if (primaryActionRef.current && isWithinClickThreshold && !isPrimaryActionClicked && !isIgnoredClick) {
      primaryActionRef.current.click();
    }
  }, [up2, down2, isIgnoredClick]);
  return {
    primaryActionRef,
    clickAreaRef,
    onCardMouseUp,
    onCardMouseDown
  };
};

// src/theme/theme-files/storybook-themes.ts
import Lightbulb from "./assets/example-assets/light-bulb.svg";
var options = {
  customIcons: {
    customLightbulb: Lightbulb,
    customSVGDataURI: "data:image/svg+xml,%3Csvg%20id%3D%22customSVGDataURI%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%0A%20%20%3Cpath%20fill%3D%22none%22%20stroke%3D%22%236a6%22%20stroke-width%3D%2210%22%20d%3D%22m-13.6%2027%2023-20.7%2026.5%2022%22%2F%3E%0A%3C%2Fsvg%3E"
  },
  customStrings: {
    loadingText: "Custom loading text"
  },
  themeName: "wireframe"
};
var storybookArchetypeLightTheme = loadTheme(archetypeLightTheme, __spreadProps(__spreadValues({}, options), {
  themeName: "archetype-light"
}));
var storybookArchetypeDarkTheme = loadTheme(archetypeDarkTheme, __spreadProps(__spreadValues({}, options), {
  themeName: "archetype-dark"
}));
var storybookLeagueTheme = loadTheme(leagueTheme, __spreadProps(__spreadValues({}, options), {
  themeName: "league"
}));

// src/test-utils/genesis-core-inspector.tsx
import React5 from "react";

// src/test-utils/use-genesis-core-inspector.ts
import { useState as useState3, useEffect as useEffect2 } from "react";
var useGenesisCoreInspector = () => {
  const [isEnabled, setIsEnabled] = useState3(
    localStorage.getItem(EnableGenesisCoreInspector) === "true"
  );
  useEffect2(() => {
    localStorage.setItem(EnableGenesisCoreInspector, isEnabled.toString());
  }, [isEnabled]);
  const toggleInspector = () => {
    setIsEnabled(!isEnabled);
    window.location.reload();
  };
  return { isEnabled, toggleInspector };
};

// src/test-utils/genesis-core-inspector.tsx
var StyledDiv = transformingStyled("div", {
  border: "2px solid #575757",
  position: "relative",
  display: "inherit",
  overflow: "inherit",
  paddingBlockStart: "24px"
});
var StyledText = transformingStyled("p", {
  position: "absolute",
  backgroundColor: "#575757",
  color: "#FFFFFF",
  typography: "$label",
  margin: 0,
  padding: "$quarter",
  top: 0,
  insetInlineEnd: 0,
  zIndex: 1
});
var GenesisCoreInspector = ({
  children,
  displayName
}) => {
  const { isEnabled } = useGenesisCoreInspector();
  if (isEnabled) {
    return /* @__PURE__ */ React5.createElement(StyledDiv, { className: "GDS-Core-Inspector" }, /* @__PURE__ */ React5.createElement(StyledText, null, displayName || (children == null ? void 0 : children.type.displayName)), children);
  }
  return children;
};

// src/components/typography/heading-text/heading-text.tsx
import React6, { forwardRef as forwardRef2, useMemo } from "react";

// src/components/typography/typography-base/typography-base.tsx
var TypographyBase = transformingStyled("span", {
  margin: 0,
  "& a, a&": {
    color: "$interactiveActionPrimary",
    fontWeight: "$buttonOne"
  },
  variants: {
    emphasis: {
      base: {
        color: "$onSurfaceTextPrimary"
      },
      subtle: {
        color: "$onSurfaceTextSubdued"
      }
    }
  }
});

// src/components/typography/heading-text/heading-text.tsx
var DISPLAY_NAME = "HeadingText";
var BaseHeading = transformingStyled(TypographyBase, {
  display: "block",
  variants: {
    size: {
      xxl: {
        typography: "$headingOne"
      },
      xl: {
        typography: "$headingTwo"
      },
      lg: {
        typography: "$headingThree"
      },
      md: {
        typography: "$headingFour"
      },
      sm: {
        typography: "$subtitleOne"
      },
      xs: {
        typography: "$subtitleTwo"
      }
    }
  }
});
var spanStyles = css({
  display: "block"
});
var elementByLevel = {
  "1": "h1",
  "2": "h2",
  "3": "h3",
  "4": "h4",
  "5": "h5",
  "6": "h6",
  display: "span"
};
var getElementByLevel = (level) => elementByLevel[level];
var HeadingText = forwardRef2(
  (_a, ref) => {
    var _b = _a, {
      as,
      children,
      className,
      css: css2,
      emphasis = "base",
      id,
      level,
      size,
      "data-testid": testId = `GDS-${DISPLAY_NAME}`
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "className",
      "css",
      "emphasis",
      "id",
      "level",
      "size",
      "data-testid"
    ]);
    const asSpan = level === "display";
    const element = useMemo(
      () => getElementByLevel(level),
      [level]
    );
    return /* @__PURE__ */ React6.createElement(GenesisCoreInspector, { displayName: "HeadingText" }, /* @__PURE__ */ React6.createElement(
      BaseHeading,
      __spreadValues({
        as: as || element,
        className: [
          "GDS-heading-text",
          asSpan ? spanStyles() : void 0,
          className
        ].join(" "),
        css: css2,
        emphasis,
        id,
        ref,
        size,
        "data-testid": testId
      }, props),
      children
    ));
  }
);
HeadingText.displayName = "HeadingText";

// src/components/typography/utility-text/utility-text.tsx
import React7, { forwardRef as forwardRef3 } from "react";

// src/hooks/use-responsive-prop.ts
import { useCallback as useCallback2 } from "react";

// src/hooks/use-active-breakpoint.ts
import { useState as useState4, useEffect as useEffect3 } from "react";
var listeners = /* @__PURE__ */ new Set();
var currentBreakpoint;
var setIfBreakpointIsActive = (breakpoint, matcher) => {
  if (matcher.matches) {
    currentBreakpoint = breakpoint;
    listeners.forEach((listener) => {
      listener(currentBreakpoint);
    });
  }
};
if (typeof window !== "undefined" && window.matchMedia) {
  Object.entries(config.media).forEach(
    ([breakpoint, query]) => {
      const mediaQueryList = window.matchMedia(query);
      setIfBreakpointIsActive(breakpoint, mediaQueryList);
      const listener = (_mediaQueryListEvent) => {
        setIfBreakpointIsActive(breakpoint, _mediaQueryListEvent);
      };
      if (mediaQueryList.addEventListener) {
        mediaQueryList.addEventListener("change", listener);
      }
    }
  );
}
var useActiveBreakpoint = () => {
  const [activeBreakpoint, setActiveBreakpoint] = useState4(currentBreakpoint);
  useEffect3(() => {
    listeners.add(setActiveBreakpoint);
    return () => {
      listeners.delete(setActiveBreakpoint);
    };
  }, []);
  return activeBreakpoint;
};

// src/hooks/use-responsive-prop.ts
function isResponsiveProp(arg) {
  return (arg == null ? void 0 : arg["@initial"]) !== void 0;
}
function getResponsivePropValue(prop, activeBreakpoint) {
  var _a;
  if (!isResponsiveProp(prop)) {
    return prop;
  }
  const initialBreakpointValue = prop["@initial"];
  return (_a = prop == null ? void 0 : prop[`@${activeBreakpoint}`]) != null ? _a : initialBreakpointValue;
}
var useResponsiveProp = (prop) => {
  const activeBreakpoint = useActiveBreakpoint();
  return getResponsivePropValue(prop, activeBreakpoint);
};
var useResponsivePropCallback = () => {
  const activeBreakpoint = useActiveBreakpoint();
  return useCallback2(
    (prop) => getResponsivePropValue(prop, activeBreakpoint),
    [activeBreakpoint]
  );
};
var mapResponsiveProp = (prop, valueMap) => {
  if (!valueMap)
    return prop;
  if (!isResponsiveProp(prop)) {
    return valueMap[prop];
  }
  const result = {};
  Object.keys(prop).forEach((key) => {
    const originalValue = prop[key];
    const newValue = valueMap[originalValue];
    result[key] = newValue;
  });
  return result;
};

// src/components/typography/utility-text/utility-text.tsx
var DISPLAY_NAME2 = "UtilityText";
var StyledUtilityText = transformingStyled(TypographyBase, {
  color: "$onSurfaceTextPrimary",
  variants: {
    size: {
      base: {
        typography: "$bodyOne"
      },
      sm: {
        typography: "$bodyTwo"
      },
      xs: {
        typography: "$caption"
      },
      eyebrow: {
        typography: "$overline"
      }
    },
    // Even though the emphasis variant exists on TypographyBase, TS fails without repeating it here
    emphasis: {
      base: {
        color: "$onSurfaceTextPrimary"
      },
      subtle: {
        color: "$onSurfaceTextSubdued"
      },
      emphasized: {
        color: "$onSurfaceTextPrimary"
      }
    }
  },
  compoundVariants: [
    {
      size: "base",
      emphasis: "emphasized",
      css: { typography: "$subtitleOne" }
    },
    {
      size: "base",
      emphasis: "subtle",
      css: { typography: "$bodyOneSecondary" }
    },
    {
      size: "sm",
      emphasis: "emphasized",
      css: { typography: "$subtitleTwo" }
    },
    {
      size: "sm",
      emphasis: "subtle",
      css: { typography: "$bodyTwoSecondary" }
    },
    {
      size: "xs",
      emphasis: "base",
      css: { color: "$onSurfaceTextPrimary" }
    },
    {
      size: "eyebrow",
      emphasis: "base",
      css: { color: "$onSurfaceTextSubdued" }
    }
  ]
});
var defaultEmphasisBySize = {
  base: "base",
  sm: "base",
  xs: "subtle",
  eyebrow: "base"
};
var UtilityText = forwardRef3(
  (_a, ref) => {
    var _b = _a, {
      as,
      children,
      className,
      css: css2,
      emphasis,
      id,
      size = "base",
      "data-testid": testId = `GDS-${DISPLAY_NAME2}`
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "className",
      "css",
      "emphasis",
      "id",
      "size",
      "data-testid"
    ]);
    const emphasisBySize = mapResponsiveProp(
      size,
      defaultEmphasisBySize
    );
    const responsiveSize = useResponsiveProp(size);
    if (size === "xs" && emphasis === "emphasized")
      console.error(
        `Size is ${size} and emphasis is ${emphasis}. An extra small emphasized variant does not exist.`
      );
    if (size === "eyebrow" && emphasis === "subtle")
      console.error(
        `Size is ${size} and emphasis is ${emphasis}. An eyebrow subtle variant does not exist.`
      );
    return /* @__PURE__ */ React7.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME2 }, /* @__PURE__ */ React7.createElement(
      StyledUtilityText,
      __spreadValues({
        as,
        className: ["GDS-utility-text", className].join(" "),
        css: css2,
        emphasis: emphasis != null ? emphasis : emphasisBySize,
        id,
        ref,
        size: responsiveSize,
        "data-testid": testId
      }, props),
      children
    ));
  }
);
UtilityText.displayName = DISPLAY_NAME2;

// src/components/typography/paragraph-text/paragraph-text.tsx
import React14, { forwardRef as forwardRef6 } from "react";

// src/components/html-to-react/html-to-react.tsx
import React13 from "react";
import DOMPurify2 from "dompurify";
import parse2, {
  domToReact,
  attributesToProps
} from "html-react-parser";

// src/components/html-to-react/html-to-react.utils.ts
import { cloneDeep as cloneDeep2 } from "lodash";

// src/components/text-action/text-action.tsx
import React11, { forwardRef as forwardRef4 } from "react";

// src/components/icon/icon.tsx
import React8 from "react";
import DOMPurify from "dompurify";
import parse from "html-react-parser";

// src/components/forms/utilities.ts
import { isValidElement as isValidElement2 } from "react";
var labelLegendStyles = {
  typography: "$label",
  color: "$onSurfaceTextSubdued",
  marginBlockEnd: "$quarter",
  display: "flex",
  alignItems: "center",
  padding: 0
};
var isReactElement = (element) => isValidElement2(element) && (typeof element.type === "object" || typeof element.type === "function");

// src/components/icon/directionality-aware-aliases.ts
var directionalityAwareAliases = {
  interfaceArrowBack: "interfaceArrowLeft",
  interfaceArrowForward: "interfaceArrowRight",
  interfaceChevronBack: "interfaceChevronLeft",
  interfaceChevronForward: "interfaceChevronRight",
  tinyDisclosureIndicator: "tinyDisclosureIndicator",
  tinyExternalLink: "tinyExternalLink",
  tinyNewWindowInternal: "tinyNewWindowInternal",
  tinyBackButton: "tinyBackButton"
};

// src/components/icon/use-gds-icon.hook.ts
import { useCallback as useCallback3 } from "react";

// src/hooks/use-theme.ts
import { useContext as useContext2 } from "react";
var useTheme = () => {
  const theme2 = useContext2(ThemeContext);
  if (theme2 === void 0) {
    throw new Error(
      "No theme found in context. Check that your component is nested within a GDSThemeProvider."
    );
  }
  return theme2;
};
var useThemeRawValues = () => {
  const { rawValues } = useTheme();
  return rawValues;
};
var useThemeIcons = () => {
  const { icons: icons2 } = useTheme();
  return icons2;
};
var useThemeStrings = () => {
  const { strings } = useTheme();
  return strings;
};

// src/components/icon/use-gds-icon.hook.ts
var useGDSIcon = () => {
  const iconMap = useThemeIcons();
  const getGDSIconPath = useCallback3(
    (iconToken) => {
      var _a, _b, _c;
      const resolvedIcon = iconMap == null ? void 0 : iconMap[iconToken];
      if (typeof resolvedIcon === "string")
        return resolvedIcon.concat("#", iconToken);
      if ((_a = iconToken == null ? void 0 : iconToken.includes) == null ? void 0 : _a.call(iconToken, "illustrative")) {
        const descriptiveToken = iconToken.replace(
          "illustrative",
          "descriptive"
        );
        console.warn(
          `GDS Deprecation Error: use ${descriptiveToken} instead of ${iconToken}`
        );
        return (_c = (_b = iconMap == null ? void 0 : iconMap[descriptiveToken]) == null ? void 0 : _b.concat) == null ? void 0 : _c.call(_b, "#", descriptiveToken);
      }
      return resolvedIcon;
    },
    [iconMap]
  );
  const isGDSIconToken = useCallback3(
    (iconToken) => getGDSIconPath(iconToken) != null,
    [getGDSIconPath]
  );
  return { iconMap, isGDSIconToken, getGDSIconPath };
};

// src/components/icon/icon.tsx
var DISPLAY_NAME3 = "Icon";
var IconBase = transformingStyled("div", { display: "inline-block" });
var isDirectionalityAwareAlias = (icon) => typeof icon === "string" && icon in directionalityAwareAliases;
var extractSvgFromDataUri = (dataUri) => {
  var _a;
  const DATA_SVG_PREFIX = "data:image/svg+xml,";
  const encodedSvg = dataUri.substring(DATA_SVG_PREFIX.length);
  const decodedSvg = decodeURIComponent(encodedSvg);
  return ((_a = decodedSvg.match(/<svg[^>]*>[\s\S]*?<\/svg>/i)) == null ? void 0 : _a[0]) || decodedSvg;
};
var Icon = (_a) => {
  var _b = _a, {
    icon: originalIcon,
    tint,
    size = "$oneAndHalf",
    label,
    css: css2,
    className,
    "data-testid": testId
  } = _b, props = __objRest(_b, [
    "icon",
    "tint",
    "size",
    "label",
    "css",
    "className",
    "data-testid"
  ]);
  const iconSize = useResponsiveProp(size);
  const iconClassName = ["GDS-icon", className].join(" ");
  const { isGDSIconToken, getGDSIconPath } = useGDSIcon();
  let isDirectionalityAware = false;
  let icon = originalIcon;
  if (isDirectionalityAwareAlias(icon)) {
    isDirectionalityAware = true;
    icon = directionalityAwareAliases[icon];
  }
  if (isGDSIconToken(icon) && getGDSIconPath(icon).startsWith("data:image/svg+xml,")) {
    const svgContent = extractSvgFromDataUri(getGDSIconPath(icon));
    const sanitizedHtml = DOMPurify.sanitize(svgContent, { FORCE_BODY: true });
    const svgElement = parse(sanitizedHtml);
    return /* @__PURE__ */ React8.createElement(GenesisCoreInspector, { displayName: "Icon" }, /* @__PURE__ */ React8.createElement(
      IconBase,
      __spreadValues({
        as: "div",
        className: iconClassName,
        "aria-hidden": !label,
        "aria-label": label,
        css: __spreadValues({
          color: tint,
          width: iconSize,
          height: iconSize,
          transform: isDirectionalityAware ? "rotateY(calc(180deg * var(--league-is-rtl)))" : void 0
        }, css2),
        "data-testid": testId || "decoded-svg-icon"
      }, props),
      svgElement
    ));
  }
  if (isGDSIconToken(icon)) {
    return /* @__PURE__ */ React8.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME3 }, /* @__PURE__ */ React8.createElement(
      IconBase,
      __spreadValues(__spreadProps(__spreadValues({
        as: "svg",
        className: iconClassName,
        "aria-hidden": !label,
        "aria-label": label,
        css: __spreadValues({
          color: tint,
          width: iconSize,
          height: iconSize,
          "&:dir(rtl)": {
            transform: isDirectionalityAware ? "rotateY(calc(180deg))" : void 0
          }
        }, css2)
      }, label && { role: "img" }), {
        "data-testid": testId || "svg-icon"
      }), props),
      /* @__PURE__ */ React8.createElement("use", { href: getGDSIconPath(icon) })
    ));
  }
  if (isReactElement(icon)) {
    return /* @__PURE__ */ React8.createElement(GenesisCoreInspector, { displayName: "Icon" }, /* @__PURE__ */ React8.createElement(
      IconBase,
      __spreadValues({
        as: "div",
        className: iconClassName,
        "aria-hidden": !label,
        "aria-label": label,
        css: __spreadValues({ color: tint, width: iconSize, height: iconSize }, css2),
        "data-testid": testId || "custom-svg-icon"
      }, props),
      icon
    ));
  }
  return /* @__PURE__ */ React8.createElement(GenesisCoreInspector, { displayName: "Icon" }, /* @__PURE__ */ React8.createElement(
    IconBase,
    __spreadValues({
      as: "img",
      className: iconClassName,
      src: icon,
      alt: label || "",
      css: __spreadValues({ width: iconSize, height: iconSize }, css2),
      "data-testid": testId || "img-icon"
    }, props)
  ));
};
Icon.displayName = "Icon";

// src/components/spinner/spinner.tsx
import { keyframes as keyframes2 } from "@stitches/react";
import React10 from "react";

// src/components/visually-hidden/visually-hidden.tsx
var visuallyHiddenStyle = {
  position: "absolute",
  height: 1,
  width: 1,
  overflow: "hidden",
  clip: "rect(1px,1px, 1px, 1px)",
  whiteSpace: "nowrap"
};
var VisuallyHidden = transformingStyled("span", {
  "&:not(:focus):not(:active)": visuallyHiddenStyle
});
VisuallyHidden.displayName = "VisuallyHidden";

// src/components/spinner/circle.tsx
import * as React9 from "react";
function Circle({ className }) {
  return /* @__PURE__ */ React9.createElement(
    "svg",
    {
      "aria-hidden": "true",
      className,
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React9.createElement(
      "path",
      {
        opacity: ".1",
        d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1",
        stroke: "currentColor",
        strokeWidth: "1.5"
      }
    ),
    /* @__PURE__ */ React9.createElement(
      "path",
      {
        d: "M1 12C1 5.925 5.925 1 12 1",
        stroke: "currentColor",
        strokeWidth: "1.5"
      }
    )
  );
}

// src/components/spinner/spinner.tsx
var DISPLAY_NAME4 = "Spinner";
var rotate = keyframes2({
  to: { transform: "rotate(360deg)" }
});
var StyledCircle = transformingStyled(Circle, {
  display: "inline-block",
  fill: "transparent",
  borderRadius: "$circle",
  path: {
    strokeWidth: "$$thickness"
  },
  animation: `${rotate} 1s linear infinite forwards`
});
var Span = transformingStyled("span", {
  lineHeight: 0,
  position: "relative"
});
Span.displayName = "Span";
var SpinnerPositioner = transformingStyled("span", {
  variants: {
    replaceContent: {
      true: {
        display: "flex",
        position: "absolute",
        top: "50%",
        insetInlineStart: "50%",
        transform: "translate(-50%, -50%)",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  }
});
var Spinner = (_a) => {
  var _b = _a, {
    children,
    loading,
    loadingText,
    replaceContent = false,
    renderLoadingText = true,
    size,
    tint,
    className,
    thickness,
    css: css2,
    "data-testid": testId = `GDS-${DISPLAY_NAME4}`
  } = _b, props = __objRest(_b, [
    "children",
    "loading",
    "loadingText",
    "replaceContent",
    "renderLoadingText",
    "size",
    "tint",
    "className",
    "thickness",
    "css",
    "data-testid"
  ]);
  const stringsMap = useThemeStrings();
  const spinnerSize = useResponsiveProp(size);
  return /* @__PURE__ */ React10.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME4 }, /* @__PURE__ */ React10.createElement(
    Span,
    __spreadValues({
      className: ["GDS-spinner", className].join(" "),
      css: css2,
      "data-testid": testId
    }, props),
    loading && /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(SpinnerPositioner, { replaceContent }, /* @__PURE__ */ React10.createElement(
      StyledCircle,
      {
        css: {
          width: spinnerSize,
          height: spinnerSize,
          color: tint,
          $$thickness: thickness
        }
      }
    )), renderLoadingText && /* @__PURE__ */ React10.createElement(VisuallyHidden, null, loadingText || stringsMap.loadingText)),
    children && /* @__PURE__ */ React10.createElement(Span, { css: __spreadValues({}, loading && { opacity: 0 }) }, children)
  ));
};
Spinner.displayName = DISPLAY_NAME4;

// src/components/text-action/text-action.tsx
var DISPLAY_NAME5 = "TextAction";
var BaseTextAction = transformingStyled("a", {
  display: "inline-flex",
  alignItems: "center",
  textDecoration: "none",
  position: "relative",
  outline: "none",
  background: "none",
  border: "none",
  borderRadius: "$small",
  cursor: "pointer",
  padding: 0,
  "&:hover": {
    textDecoration: "underline"
  },
  variants: {
    size: {
      medium: {
        typography: "$buttonTwo"
      },
      large: {
        typography: "$buttonOne"
      }
    },
    emphasis: {
      base: {
        color: "$interactiveActionPrimary"
      },
      subtle: {
        color: "$interactiveActionSubdued"
      }
    },
    destructive: {
      true: {
        color: "$onSurfaceTextCritical"
      }
    },
    loading: {
      true: {
        pointerEvents: "none"
      }
    }
  }
});
var iconBySize = {
  medium: "20px",
  large: "24px"
};
var indicatorByString = {
  disclosure: "tinyDisclosureIndicator",
  newTabInternal: "tinyNewWindowInternal",
  externalLink: "tinyExternalLink"
};
var getIconByIndicator = (indicator) => indicatorByString[indicator];
var TextAction = forwardRef4(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      children,
      className,
      css: css2,
      destructive,
      emphasis = "base",
      icon,
      iconLabel,
      indicator,
      indicatorLabel,
      loading,
      loadingText,
      size = "large",
      type,
      "data-testid": testId = `GDS-${DISPLAY_NAME5}`
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "className",
      "css",
      "destructive",
      "emphasis",
      "icon",
      "iconLabel",
      "indicator",
      "indicatorLabel",
      "loading",
      "loadingText",
      "size",
      "type",
      "data-testid"
    ]);
    const iconSize = mapResponsiveProp(size, iconBySize);
    const stringsMap = useThemeStrings();
    const labelByIndicator = {
      disclosure: stringsMap.disclosure,
      newTabInternal: stringsMap.newTabInternal,
      externalLink: stringsMap.externalLink
    };
    const getLabelByIndicator = (indicatorIcon) => labelByIndicator[indicatorIcon];
    if (emphasis === "subtle" && destructive) {
      console.error(
        `Destructive is ${destructive} and emphasis is ${emphasis}. TextAction can only be either subtle or destructive.`
      );
    }
    const defaultType = !type && asElement === "button" ? "button" : void 0;
    return /* @__PURE__ */ React11.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME5 }, /* @__PURE__ */ React11.createElement(
      BaseTextAction,
      __spreadValues({
        as: asElement,
        className: ["GDS-text-action", className].join(" "),
        css: css2,
        destructive,
        emphasis,
        loading,
        ref,
        size: useResponsiveProp(size),
        type: type || defaultType,
        "data-testid": testId
      }, props),
      loading && /* @__PURE__ */ React11.createElement(
        Spinner,
        {
          loading,
          loadingText,
          size: iconSize,
          css: { marginInlineEnd: "$quarter" }
        }
      ),
      icon && !loading && /* @__PURE__ */ React11.createElement(
        Icon,
        {
          icon,
          size: iconSize,
          label: iconLabel,
          css: { marginInlineEnd: "$quarter" }
        }
      ),
      children,
      indicator && /* @__PURE__ */ React11.createElement(
        Icon,
        {
          icon: getIconByIndicator(indicator),
          size: "$one",
          css: { marginInlineStart: "$quarter" },
          label: indicatorLabel || getLabelByIndicator(indicator)
        }
      )
    ));
  }
);
TextAction.displayName = DISPLAY_NAME5;

// src/components/button/button.tsx
import React12, { forwardRef as forwardRef5, useMemo as useMemo2 } from "react";
var DISPLAY_NAME6 = "Button";
var ButtonBase = transformingStyled("button", {
  display: "inline-flex",
  flexWrap: "nowrap",
  alignItems: "center",
  borderRadius: "$button",
  borderWidth: "$thin",
  borderStyle: "solid",
  maxWidth: "100%",
  cursor: "pointer",
  variants: {
    width: {
      hugContents: { width: "unset" },
      fillContainer: { width: "100%", justifyContent: "center" }
    },
    size: {
      large: {
        typography: "$buttonOne",
        paddingBlockStart: "$threeQuarters",
        paddingBlockEnd: "$threeQuarters",
        paddingInlineStart: "$two",
        paddingInlineEnd: "$two"
      },
      medium: {
        typography: "$buttonTwo",
        paddingBlockStart: "$half",
        paddingBlockEnd: "$half",
        paddingInlineStart: "$one",
        paddingInlineEnd: "$one"
      },
      small: {
        typography: "$label",
        paddingBlockStart: "$quarter",
        paddingBlockEnd: "$quarter",
        paddingInlineStart: "$threeQuarters",
        paddingInlineEnd: "$threeQuarters"
      },
      toolbar: {
        paddingBlockStart: "$half",
        paddingBlockEnd: "$half",
        paddingInlineStart: "$threeQuarters",
        paddingInlineEnd: "$threeQuarters",
        typography: "$label"
      }
    },
    loading: {
      true: { pointerEvents: "none" }
    }
  }
});
var destructiveLoadingStyle = {
  backgroundColor: "$primaryBackgroundCriticalDefault",
  color: "$primaryTextCriticalDefault",
  borderColor: "transparent"
};
var destructiveHoverAndActiveStyle = {
  "&:hover": {
    backgroundColor: "$primaryBackgroundCriticalHovered",
    color: "$primaryTextCriticalDefault",
    borderColor: "transparent"
  },
  "&:active": {
    backgroundColor: "$primaryBackgroundCriticalPressed",
    color: "$primaryTextCriticalDefault",
    borderColor: "transparent"
  }
};
var disabledStyle = {
  backgroundColor: "$interactiveBackgroundDisabled",
  color: "$onSurfaceTextSubdued",
  borderColor: "transparent",
  pointerEvents: "none"
};
var loadingStyle = {
  backgroundColor: "$primaryBackgroundDefault",
  color: "$secondaryTextHovered",
  borderColor: "transparent"
};
var StandardButton = transformingStyled(ButtonBase, {
  variants: {
    priority: {
      primary: {
        backgroundColor: "$primaryBackgroundDefault",
        color: "$primaryTextDefault",
        borderColor: "transparent",
        // Transparent border maintains border width
        '&[aria-disabled="true"], &:disabled': disabledStyle,
        "&:hover": {
          backgroundColor: "$primaryBackgroundHovered"
        },
        "&:active": {
          backgroundColor: "$primaryBackgroundPressed"
        }
      },
      secondary: {
        backgroundColor: "$secondaryBackgroundDefault",
        color: "$secondaryTextDefault",
        borderColor: "$secondaryBorderDefault",
        '&[aria-disabled="true"], &:disabled': disabledStyle,
        "&:hover": {
          backgroundColor: "$secondaryBackgroundHovered",
          color: "$secondaryTextHovered",
          borderColor: "transparent"
        },
        "&:active": {
          backgroundColor: "$secondaryBackgroundPressed",
          color: "$secondaryTextHovered",
          borderColor: "transparent"
        }
      },
      tertiary: {
        backgroundColor: "$tertiaryBackgroundDefault",
        color: "$tertiaryTextDefault",
        borderColor: "$tertiaryBorderDefault",
        '&[aria-disabled="true"], &:disabled': disabledStyle,
        "&:hover": {
          backgroundColor: "$tertiaryBackgroundHovered",
          color: "$tertiaryTextHovered",
          borderColor: "transparent"
        },
        "&:active": {
          backgroundColor: "$tertiaryBackgroundPressed",
          color: "$tertiaryTextHovered",
          borderColor: "transparent"
        }
      }
    },
    destructive: {
      true: destructiveHoverAndActiveStyle
    },
    quiet: {
      true: { borderColor: "transparent" }
    },
    // These variants don't have a shared style - they are only used in compound variants, so the default value is an empty object
    iconOnly: {
      true: {}
    },
    reducePadding: {
      true: {}
    },
    size: {
      small: {},
      medium: {},
      large: {},
      toolbar: {}
    },
    loading: {
      true: {}
    }
  },
  compoundVariants: [
    // Icon only
    {
      size: "large",
      iconOnly: true,
      css: {
        padding: "$threeQuarters"
      }
    },
    {
      size: "medium",
      iconOnly: true,
      css: {
        padding: "$half"
      }
    },
    {
      size: "small",
      iconOnly: true,
      css: {
        padding: "$half"
      }
    },
    // Quiet
    {
      priority: "primary",
      quiet: true,
      css: {
        borderColor: "transparent"
      }
    },
    {
      priority: "secondary",
      quiet: true,
      css: {
        borderColor: "transparent"
      }
    },
    {
      priority: "tertiary",
      quiet: true,
      css: {
        borderColor: "transparent"
      }
    },
    // Destructive
    {
      priority: "primary",
      destructive: true,
      css: {
        backgroundColor: "$primaryBackgroundCriticalDefault",
        color: "$primaryTextCriticalDefault"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      quiet: false,
      css: {
        color: "$onSurfaceTextCritical",
        borderColor: "$onSurfaceTextCritical"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      quiet: true,
      css: {
        color: "$onSurfaceTextCritical",
        borderColor: "transparent"
      }
    },
    // Loading
    {
      loading: true,
      destructive: false,
      css: loadingStyle
    },
    // Destructive loading
    {
      loading: true,
      destructive: true,
      css: destructiveLoadingStyle
    },
    {
      size: "large",
      reducePadding: true,
      css: {
        paddingInlineStart: "$oneAndHalf",
        paddingInlineEnd: "$oneAndHalf"
      }
    },
    {
      size: "medium",
      reducePadding: true,
      css: {
        paddingInlineStart: "$threeQuarters",
        paddingInlineEnd: "$threeQuarters"
      }
    },
    {
      size: "small",
      reducePadding: true,
      css: { paddingInlineStart: "$half", paddingInlineEnd: "$half" }
    }
  ]
});
var toolbarQuietStyle = {
  borderColor: "transparent",
  backgroundColor: "transparent",
  "&:hover": {
    borderColor: "transparent",
    backgroundColor: "transparent"
  }
};
var ToolbarButton = transformingStyled(ButtonBase, {
  variants: {
    priority: {
      primary: {
        backgroundColor: "$primaryBackgroundDefault",
        color: "$primaryTextDefault",
        borderColor: "transparent",
        // Transparent border maintains border width
        "&:hover": {
          backgroundColor: "$primaryBackgroundHovered"
        },
        "&:active": {
          backgroundColor: "$primaryBackgroundPressed"
        },
        '&[aria-disabled="true"], &:disabled': disabledStyle
      },
      secondary: {
        backgroundColor: "$surfaceBackgroundPrimary",
        color: "$interactiveActionPrimary",
        borderColor: "$interactiveActionPrimary",
        "&:hover": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionHovered",
          borderColor: "$interactiveActionHovered"
        },
        "&:active": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionPressed",
          borderColor: "$interactiveActionPressed"
        },
        '&[aria-disabled="true"], &:disabled': disabledStyle
      },
      tertiary: {
        backgroundColor: "$surfaceBackgroundPrimary",
        color: "$interactiveActionSubdued",
        borderColor: "$interactiveActionSubdued",
        "&:hover": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionSubdued",
          borderColor: "$interactiveActionSubdued"
        },
        "&:active": {
          backgroundColor: "$surfaceBackgroundPrimary",
          color: "$interactiveActionPrimary",
          borderColor: "$interactiveActionPrimary"
        },
        '&[aria-disabled="true"], &:disabled': disabledStyle
      }
    },
    destructive: {
      true: destructiveHoverAndActiveStyle
    },
    loading: {
      true: {}
    },
    iconOnly: {
      true: {
        padding: "$quarter"
      }
    },
    reducePadding: {
      true: { padding: "$half" }
    },
    quiet: { true: toolbarQuietStyle }
  },
  compoundVariants: [
    // Destructive
    {
      priority: "primary",
      destructive: true,
      quiet: false,
      loading: false,
      css: {
        backgroundColor: "$primaryBackgroundCriticalDefault",
        color: "$primaryTextCriticalDefault"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      loading: false,
      quiet: false,
      css: {
        color: "$onSurfaceTextCritical",
        borderColor: "$onSurfaceTextCritical"
      }
    },
    {
      priority: "secondary",
      destructive: true,
      loading: false,
      quiet: true,
      css: __spreadProps(__spreadValues({}, destructiveHoverAndActiveStyle), {
        color: "$onSurfaceTextCritical",
        borderColor: "transparent"
      })
    },
    {
      destructive: true,
      loading: true,
      css: destructiveLoadingStyle
    },
    {
      priority: "tertiary",
      quiet: true,
      css: toolbarQuietStyle
    }
  ]
});
var IconWrapper = transformingStyled("span", {
  display: "flex",
  alignItems: "center",
  variants: {
    paddingInlineEnd: {
      large: { paddingInlineEnd: "$half" },
      medium: { paddingInlineEnd: "$half" },
      small: { paddingInlineEnd: "$quarter" },
      toolbar: { paddingInlineEnd: "$quarter" },
      none: { paddingInlineEnd: "$none" }
    },
    paddingInlineStart: {
      large: { paddingInlineStart: "$half" },
      medium: { paddingInlineStart: "$half" },
      small: { paddingInlineStart: "$quarter" },
      toolbar: { paddingInlineStart: "$quarter" },
      none: { paddingInlineStart: "$none" }
    }
  }
});
var LabelWrapper = transformingStyled("span", {
  variants: {
    truncateLabel: {
      true: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
      }
    }
  }
});
var iconSizes = {
  large: 24,
  medium: 20,
  small: 16,
  toolbar: 16
};
function useIndicatorProps() {
  const stringsMap = useThemeStrings();
  return useMemo2(
    () => ({
      size: {
        large: 16,
        medium: 14,
        small: 12,
        toolbar: 16
      },
      icon: {
        newTabInternal: "tinyNewWindowInternal",
        newWindowInternal: "tinyNewWindowInternal",
        externalLink: "tinyExternalLink"
      },
      label: {
        newTabInternal: stringsMap.newTabInternal,
        newWindowInternal: stringsMap.newWindowInternal,
        externalLink: stringsMap.externalLink
      }
    }),
    [stringsMap]
  );
}
var ButtonIndicator = ({
  wrapperSpacing,
  indicator,
  indicatorLabel,
  responsiveSize
}) => {
  const indicatorProps = useIndicatorProps();
  return /* @__PURE__ */ React12.createElement(IconWrapper, { paddingInlineStart: wrapperSpacing }, /* @__PURE__ */ React12.createElement(
    Icon,
    {
      icon: indicatorProps.icon[indicator],
      size: indicatorProps.size[responsiveSize],
      label: indicatorLabel || indicatorProps.label[indicator]
    }
  ));
};
var Button = forwardRef5(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      children,
      icon,
      iconLabel,
      hideLabel,
      truncateLabel,
      size = "large",
      priority = "primary",
      width = "hugContents",
      destructive,
      quiet = false,
      disabled = false,
      "aria-disabled": ariaDisabled,
      loading = false,
      loadingText,
      indicator,
      indicatorLabel,
      type,
      className,
      textAlign = "start",
      "data-testid": testId = `GDS-${DISPLAY_NAME6}`
    } = _b, props = __objRest(_b, [
      "as",
      "children",
      "icon",
      "iconLabel",
      "hideLabel",
      "truncateLabel",
      "size",
      "priority",
      "width",
      "destructive",
      "quiet",
      "disabled",
      "aria-disabled",
      "loading",
      "loadingText",
      "indicator",
      "indicatorLabel",
      "type",
      "className",
      "textAlign",
      "data-testid"
    ]);
    if (!icon && hideLabel)
      console.error(
        `Icon is ${icon} and hideLabel is ${hideLabel}. You can hide the label only if you provide an icon. Otherwise, the button appears to be empty.`
      );
    if (priority === "tertiary" && destructive)
      console.error(
        `Priority is ${priority} and destructive is ${destructive}. Only primary and secondary buttons can be destructive.`
      );
    if (priority === "primary" && quiet)
      console.error(
        `Priority is ${priority} and quiet is ${quiet}. Only secondary and tertiary buttons can be quiet.`
      );
    if (indicator && hideLabel)
      console.error(
        `Indicator is ${indicator} and hideLabel is ${hideLabel}. Only buttons with visible text can have the indicator icon.`
      );
    const responsiveSize = useResponsiveProp(size);
    const responsiveHideLabel = useResponsiveProp(hideLabel);
    const spaceBetweenIconAndLabel = responsiveHideLabel ? "none" : responsiveSize;
    const responsiveIconSize = mapResponsiveProp(size, iconSizes);
    const responsiveWidth = useResponsiveProp(width);
    const iconOnly = Boolean(icon && responsiveHideLabel);
    const reducePadding = !icon && responsiveHideLabel;
    const ButtonComponent = responsiveSize === "toolbar" ? ToolbarButton : StandardButton;
    const defaultType = !type && !asElement ? "button" : void 0;
    return /* @__PURE__ */ React12.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME6 }, /* @__PURE__ */ React12.createElement(
      ButtonComponent,
      __spreadValues({
        "data-testid": testId,
        as: asElement,
        className: ["GDS-button", className].join(" "),
        size: responsiveSize,
        width: responsiveWidth,
        priority,
        destructive,
        quiet,
        disabled,
        "aria-disabled": ariaDisabled,
        loading,
        ref,
        iconOnly,
        reducePadding,
        type: type || defaultType
      }, props),
      loading && /* @__PURE__ */ React12.createElement(IconWrapper, { paddingInlineEnd: spaceBetweenIconAndLabel }, /* @__PURE__ */ React12.createElement(
        Spinner,
        {
          loading: true,
          loadingText,
          size: `${responsiveIconSize}px`
        }
      )),
      icon && !loading && /* @__PURE__ */ React12.createElement(IconWrapper, { paddingInlineEnd: spaceBetweenIconAndLabel }, /* @__PURE__ */ React12.createElement(Icon, { icon, label: iconLabel, size: responsiveIconSize })),
      responsiveHideLabel ? /* @__PURE__ */ React12.createElement(VisuallyHidden, null, children) : /* @__PURE__ */ React12.createElement(LabelWrapper, { truncateLabel, css: { textAlign } }, children),
      indicator && !hideLabel && /* @__PURE__ */ React12.createElement(
        ButtonIndicator,
        {
          wrapperSpacing: spaceBetweenIconAndLabel,
          indicator,
          responsiveSize,
          indicatorLabel
        }
      )
    ));
  }
);
Button.displayName = DISPLAY_NAME6;

// src/components/html-to-react/html-to-react.config.ts
var defaultHTMLTagOptions = {
  a: {
    component: TextAction
  },
  b: {
    component: UtilityText,
    props: {
      as: "strong",
      css: {
        fontWeight: "bold"
      }
    }
  },
  p: {
    component: UtilityText,
    props: {
      as: "p",
      css: {
        "> a": {
          textDecoration: "underline"
        }
      }
    }
  },
  h1: {
    component: HeadingText,
    props: { level: "1", size: "xxl" }
  },
  h2: {
    component: HeadingText,
    props: { level: "2", size: "xl" }
  },
  h3: {
    component: HeadingText,
    props: { level: "3", size: "lg" }
  },
  h4: {
    component: HeadingText,
    props: { level: "4", size: "md" }
  },
  h5: {
    component: HeadingText,
    props: { level: "5", size: "sm" }
  },
  h6: {
    component: HeadingText,
    props: { level: "6", size: "xs" }
  },
  button: {
    component: Button
  },
  ul: {
    component: UtilityText,
    props: {
      as: "ul",
      css: {
        listStyle: "revert !important",
        marginBlockEnd: "$oneAndHalf",
        padding: "0 0 0 $oneAndHalf"
      }
    }
  },
  ol: {
    component: UtilityText,
    props: {
      as: "ol",
      css: {
        typography: "$bodyOne",
        listStyle: "revert",
        marginBlockEnd: "$oneAndHalf",
        padding: "0 0 0 18px"
      }
    }
  },
  em: {
    component: "em",
    props: { style: { fontStyle: "italic" } }
  },
  i: {
    component: "em",
    props: { style: { fontStyle: "italic" } }
  },
  sup: {
    component: UtilityText,
    props: {
      as: "sup",
      color: "$onSurfaceTextSubdued",
      size: "eyebrow"
    }
  },
  sub: {
    component: UtilityText,
    props: {
      as: "sub",
      color: "$onSurfaceTextSubdued",
      size: "eyebrow"
    }
  }
};

// src/components/html-to-react/html-to-react.utils.ts
var applyOptionsWithDefaults = (newOptions, defaultOptions = cloneDeep2(defaultHTMLTagOptions)) => newOptions && typeof newOptions === "object" ? Object.entries(newOptions).reduce(
  (acc, [tag, { component, props = {} }]) => {
    var _a;
    if (!acc[tag]) {
      if (!component)
        return acc;
      acc[tag] = {
        component,
        props: __spreadValues({}, props)
      };
      return acc;
    }
    if (component) {
      acc[tag].component = component;
    }
    acc[tag].props = __spreadValues(__spreadValues({}, (_a = acc[tag]) == null ? void 0 : _a.props), props);
    return acc;
  },
  defaultOptions
) : defaultOptions;

// src/components/html-to-react/html-to-react.tsx
var curateOptions = (options2) => {
  const allOptions = applyOptionsWithDefaults(options2);
  return {
    trim: true,
    replace({
      name,
      attribs,
      children
    }) {
      if (!attribs)
        return void 0;
      const attributeProps = attributesToProps(attribs);
      if (name in allOptions) {
        const { component: Component, props } = allOptions[name];
        return /* @__PURE__ */ React13.createElement(Component, __spreadValues(__spreadValues({}, props), attributeProps), children && children.length ? domToReact(children, this) : void 0);
      }
      return void 0;
    }
  };
};
var HtmlToReact = ({
  htmlString,
  options: options2
}) => {
  if (!htmlString)
    return null;
  const sanitizedHtml = DOMPurify2.sanitize(htmlString, {
    FORCE_BODY: true
  });
  const derivedOptions = options2 ? curateOptions(options2) : curateOptions({});
  const reactElement = parse2(
    sanitizedHtml,
    derivedOptions
  );
  return (
    // wrapping return in fragment suppresses error discussed here: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20356
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ React13.createElement(React13.Fragment, null, shouldPseudolocalize ? pseudolocalize(reactElement) : reactElement)
  );
};
var startsWithBlockLevelTag = (string) => {
  const pOrDivTagRegex = /^<(p|div|ul|ol|li|h)[\s\S]*>/i;
  return pOrDivTagRegex.test(string);
};

// src/components/typography/paragraph-text/paragraph-text.tsx
var DISPLAY_NAME7 = "ParagraphText";
var StyledParagraphText = transformingStyled(TypographyBase, {
  variants: {
    size: {
      base: {
        typography: "$bodyOne",
        "&:not(:last-child)": {
          marginBlockEnd: "$bodyOne"
        }
      },
      sm: {
        typography: "$bodyTwo",
        "&:not(:last-child)": {
          marginBlockEnd: "$bodyTwo"
        }
      },
      xs: {
        typography: "$caption",
        "&:not(:last-child)": {
          marginBlockEnd: "$quarter"
        }
      }
    }
  }
});
var ParagraphText = forwardRef6(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      emphasis = "base",
      id,
      size = "base",
      htmlStringOptions = {},
      as,
      "data-testid": testId = `GDS-${DISPLAY_NAME7}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "emphasis",
      "id",
      "size",
      "htmlStringOptions",
      "as",
      "data-testid"
    ]);
    const beginsWithPOrDivTag = typeof children === "string" ? startsWithBlockLevelTag(children) : void 0;
    return /* @__PURE__ */ React14.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME7 }, /* @__PURE__ */ React14.createElement(
      StyledParagraphText,
      __spreadValues({
        as: as || beginsWithPOrDivTag && "div" || "p",
        className: ["GDS-paragraph-text", className].join(" "),
        css: css2,
        emphasis,
        id,
        ref,
        size,
        "data-testid": testId
      }, props),
      typeof children === "string" ? /* @__PURE__ */ React14.createElement(HtmlToReact, { htmlString: children, options: htmlStringOptions }) : children
    ));
  }
);
ParagraphText.displayName = DISPLAY_NAME7;

// src/components/heading-bar/heading-bar.tsx
import React15, {
  forwardRef as forwardRef7,
  isValidElement as isValidElement3,
  useRef as useRef3,
  useState as useState5,
  useLayoutEffect as useLayoutEffect2
} from "react";
var DISPLAY_NAME8 = "HeadingBar";
var HeadingBarWrapper = transformingStyled("div", {
  variants: {
    transparency: {
      none: {
        background: "$$backgroundColor"
      },
      transparent: {
        background: "transparent"
      },
      gradient: {
        background: "linear-gradient(180deg, rgba(0, 0, 0, 0.7) 5.8%, rgba(0, 0, 0, 0) 99.68%)"
      },
      withBackgrounds: {
        background: "transparent"
      }
    }
  }
});
var HeadingBarBase = transformingStyled("div", {
  display: "flex",
  position: "relative",
  padding: "$threeQuarters",
  minHeight: "$three"
});
var ActionWrapper = transformingStyled("div", {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  zIndex: 1
});
var ActionBackground = transformingStyled("div", {
  display: "flex",
  alignItems: "center",
  borderRadius: "$pill",
  variants: {
    hasBackgrounds: {
      true: {
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    }
  }
});
var TitleWrapper = transformingStyled("div", {
  height: "100%",
  position: "absolute",
  top: 0,
  insetInlineStart: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  paddingBlockStart: "$threeQuarters",
  paddingBlockEnd: "$threeQuarters",
  paddingInlineStart: "calc($$padding + $threeQuarters)",
  paddingInlineEnd: "calc($$padding + $threeQuarters)"
});
var Title = transformingStyled(HeadingText, {
  padding: "$quarter $half",
  borderRadius: "$pill",
  textAlign: "center",
  variants: {
    hasBackgrounds: {
      true: {
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    },
    gradient: {
      true: {
        color: "$onSurfaceTextReversed"
      }
    }
  }
});
var HeadingBar = forwardRef7(
  (_a, ref) => {
    var _b = _a, {
      title,
      leadingAction: originalLeadingAction,
      trailingAction: originalTrailingAction,
      leftAction,
      rightAction,
      headingLevel = "display",
      largeTitle,
      backgroundColor = "$surfaceBackgroundPrimary",
      transparency = "none",
      css: css2,
      "data-testid": testId = `GDS-${DISPLAY_NAME8}`
    } = _b, props = __objRest(_b, [
      "title",
      "leadingAction",
      "trailingAction",
      "leftAction",
      "rightAction",
      "headingLevel",
      "largeTitle",
      "backgroundColor",
      "transparency",
      "css",
      "data-testid"
    ]);
    var _a2, _b2, _c, _d;
    const leadingAction = originalLeadingAction || leftAction;
    const trailingAction = originalTrailingAction || rightAction;
    const leadingRef = useRef3(null);
    const trailingRef = useRef3(null);
    const [sidePadding, setSidePadding] = useState5(null);
    const leadingWidth = (_b2 = (_a2 = leadingRef == null ? void 0 : leadingRef.current) == null ? void 0 : _a2.offsetWidth) != null ? _b2 : 0;
    const trailingWidth = (_d = (_c = trailingRef == null ? void 0 : trailingRef.current) == null ? void 0 : _c.offsetWidth) != null ? _d : 0;
    useLayoutEffect2(() => {
      if (leadingWidth > trailingWidth) {
        setSidePadding(leadingWidth);
      } else
        setSidePadding(trailingWidth);
    }, [leadingWidth, trailingWidth]);
    const hasBackgrounds = transparency === "withBackgrounds";
    const titleComponent = isValidElement3(title) ? title : /* @__PURE__ */ React15.createElement(
      Title,
      {
        level: headingLevel,
        size: largeTitle ? "xl" : "sm",
        hasBackgrounds,
        gradient: transparency === "gradient",
        className: "GDS-heading-bar-title"
      },
      title
    );
    const getJustifyContent = () => {
      if (leadingAction && trailingAction)
        return "space-between";
      if (trailingAction)
        return "flex-end";
      return "flex-start";
    };
    return /* @__PURE__ */ React15.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME8 }, /* @__PURE__ */ React15.createElement(
      HeadingBarWrapper,
      {
        "data-testid": testId,
        className: "GDS-heading-bar-wrapper",
        transparency,
        css: __spreadProps(__spreadValues({}, css2), {
          $$backgroundColor: `$colors${backgroundColor}`
        })
      },
      /* @__PURE__ */ React15.createElement(
        HeadingBarBase,
        __spreadValues({
          className: "GDS-heading-bar-base",
          ref,
          css: {
            justifyContent: getJustifyContent()
          }
        }, props),
        leadingAction && /* @__PURE__ */ React15.createElement(
          ActionWrapper,
          {
            ref: leadingRef,
            className: "GDS-heading-bar-left-action GDS-heading-bar-leading-action"
          },
          /* @__PURE__ */ React15.createElement(ActionBackground, { hasBackgrounds }, leadingAction)
        ),
        title && sidePadding !== null && /* @__PURE__ */ React15.createElement(
          TitleWrapper,
          {
            css: { $$padding: `${sidePadding}px` },
            className: "GDS-heading-bar-title-wrapper"
          },
          titleComponent
        ),
        trailingAction && /* @__PURE__ */ React15.createElement(
          ActionWrapper,
          {
            ref: trailingRef,
            className: "GDS-heading-bar-right-action GDS-heading-bar-trailing-action"
          },
          /* @__PURE__ */ React15.createElement(ActionBackground, { hasBackgrounds }, trailingAction)
        )
      )
    ));
  }
);
HeadingBar.displayName = DISPLAY_NAME8;

// src/components/divider/divider.tsx
import React16 from "react";
var DISPLAY_NAME9 = "Divider";
var BaseDivider = transformingStyled("hr", {
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  height: "auto",
  variants: {
    orientation: {
      vertical: {
        margin: "0px",
        flexShrink: "0",
        borderWidth: "0px $thin 0px 0px",
        alignSelf: "stretch"
      },
      horizontal: {
        width: "100%",
        borderWidth: "0px 0px $thin"
      }
    }
  }
});
var getMarginCss = (orientation, margin) => {
  if (typeof margin === "string") {
    return { [orientation === "horizontal" ? "marginX" : "marginY"]: margin };
  }
  const responsiveMargins = Object.entries(margin).reduce(
    (obj, [key, value]) => __spreadProps(__spreadValues({}, obj), {
      [key]: { [orientation === "horizontal" ? "marginX" : "marginY"]: value }
    }),
    {}
  );
  return responsiveMargins;
};
var Divider = (_a) => {
  var _b = _a, {
    "aria-hidden": ariaHidden = true,
    className,
    css: css2,
    margin,
    orientation = "horizontal",
    "data-testid": testId = `GDS-${DISPLAY_NAME9}`
  } = _b, props = __objRest(_b, [
    "aria-hidden",
    "className",
    "css",
    "margin",
    "orientation",
    "data-testid"
  ]);
  const ariaOrientation = useResponsiveProp(orientation);
  return /* @__PURE__ */ React16.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME9 }, /* @__PURE__ */ React16.createElement(
    BaseDivider,
    __spreadValues({
      "aria-hidden": ariaHidden,
      "aria-orientation": ariaOrientation,
      className: ["GDS-divider", className].join(" "),
      css: __spreadValues(__spreadValues({}, css2), margin && getMarginCss(orientation, margin)),
      "data-testid": testId,
      orientation
    }, props)
  ));
};
Divider.displayName = "Divider";

// src/components/stack-layout/stack-layout.tsx
import React19, { forwardRef as forwardRef10 } from "react";

// src/components/stack-layout/vertical-stack-layout/vertical-stack-layout.tsx
import React17, { forwardRef as forwardRef8, Children as Children2 } from "react";
var BaseVerticalStack = transformingStyled("div", {
  display: "flex",
  flex: "1",
  flexDirection: "column",
  height: "100%",
  variants: {
    horizontalAlignment: {
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    },
    verticalAlignment: {
      top: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      bottom: {
        justifyContent: "flex-end"
      },
      spaceAround: {
        justifyContent: "space-around"
      },
      spaceBetween: {
        justifyContent: "space-between"
      },
      spaceEvenly: {
        justifyContent: "space-evenly"
      },
      stretch: {
        justifyContent: "stretch",
        "& > *": {
          flex: "1 1 0"
        }
      }
    }
  }
});
var VerticalStackLayout = forwardRef8(
  (_a, ref) => {
    var _b = _a, {
      horizontalAlignment = "start",
      verticalAlignment = "top",
      spacing,
      divider,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "horizontalAlignment",
      "verticalAlignment",
      "spacing",
      "divider",
      "children",
      "className",
      "css"
    ]);
    const responsiveSpacing = useResponsiveProp(spacing);
    const responsiveDivider = useResponsiveProp(divider);
    const arrayChildren = Children2.toArray(children);
    return /* @__PURE__ */ React17.createElement(
      BaseVerticalStack,
      __spreadValues({
        horizontalAlignment,
        verticalAlignment,
        ref,
        className: ["GDS-vertical-stack-layout", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), spacing && { gap: `$space${responsiveSpacing}` })
      }, props),
      React17.Children.map(arrayChildren, (child, index) => {
        const isLast = index === arrayChildren.length - 1;
        return /* @__PURE__ */ React17.createElement(React17.Fragment, null, child, !isLast && responsiveDivider ? responsiveDivider : null);
      })
    );
  }
);

// src/components/stack-layout/horizontal-stack-layout/horizontal-stack-layout.tsx
import React18, { forwardRef as forwardRef9, Children as Children3 } from "react";
var BaseStack = transformingStyled("div", {
  display: "flex",
  flex: "1",
  variants: {
    horizontalAlignment: {
      start: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      end: {
        justifyContent: "flex-end"
      },
      spaceBetween: {
        justifyContent: "space-between"
      },
      spaceAround: {
        justifyContent: "space-around"
      },
      spaceEvenly: {
        justifyContent: "space-evenly"
      },
      stretch: {
        justifyContent: "stretch",
        "& > *": {
          flex: "1 1 0"
        }
      }
    },
    verticalAlignment: {
      top: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      bottom: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    }
  }
});
var HorizontalStackLayout = forwardRef9(
  (_a, ref) => {
    var _b = _a, {
      horizontalAlignment = "start",
      verticalAlignment = "top",
      spacing,
      divider,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "horizontalAlignment",
      "verticalAlignment",
      "spacing",
      "divider",
      "children",
      "className",
      "css"
    ]);
    const responsiveSpacing = useResponsiveProp(spacing);
    const responsiveDivider = useResponsiveProp(divider);
    const arrayChildren = Children3.toArray(children);
    return /* @__PURE__ */ React18.createElement(
      BaseStack,
      __spreadValues({
        horizontalAlignment,
        verticalAlignment,
        ref,
        className: ["GDS-horizontal-stack-layout", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), spacing && { gap: `$space${responsiveSpacing}` })
      }, props),
      React18.Children.map(arrayChildren, (child, index) => {
        const isLast = index === arrayChildren.length - 1;
        return /* @__PURE__ */ React18.createElement(React18.Fragment, null, child, !isLast && responsiveDivider ? responsiveDivider : null);
      })
    );
  }
);

// src/components/stack-layout/stack-layout.tsx
var DISPLAY_NAME10 = "StackLayout";
var StackLayout = forwardRef10(
  (_a, ref) => {
    var _b = _a, {
      orientation = "vertical",
      "data-testid": testId = `GDS-${DISPLAY_NAME10}`
    } = _b, props = __objRest(_b, [
      "orientation",
      "data-testid"
    ]);
    const responsiveOrientation = useResponsiveProp(orientation);
    return responsiveOrientation === "horizontal" ? /* @__PURE__ */ React19.createElement(GenesisCoreInspector, { displayName: `Horizontal ${DISPLAY_NAME10}` }, /* @__PURE__ */ React19.createElement(
      HorizontalStackLayout,
      __spreadValues({
        ref,
        "data-testid": testId
      }, props)
    )) : /* @__PURE__ */ React19.createElement(GenesisCoreInspector, { displayName: `Vertical ${DISPLAY_NAME10}` }, /* @__PURE__ */ React19.createElement(
      VerticalStackLayout,
      __spreadValues({
        ref,
        "data-testid": testId
      }, props)
    ));
  }
);
StackLayout.displayName = DISPLAY_NAME10;

// src/components/stack-layout/stack-item/stack-item.tsx
import React20, { forwardRef as forwardRef11 } from "react";
var BaseStackItem = transformingStyled("div", {
  display: "flex",
  flexDirection: "column",
  variants: {
    horizontalAlignment: {
      fillContainer: {
        alignItems: "stretch"
      },
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "flex-end"
      }
    },
    verticalAlignment: {
      fillContainer: {
        justifyContent: "stretch",
        "& > *": {
          flexGrow: 1
        }
      },
      top: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      bottom: {
        justifyContent: "flex-end"
      }
    }
  }
});
var setFlexBasis = (baseWidth) => baseWidth === "hugContents" ? "fit-content" : baseWidth;
var StackItem = forwardRef11(
  (_a, ref) => {
    var _b = _a, {
      horizontalAlignment = "fillContainer",
      verticalAlignment = "fillContainer",
      growFactor,
      shrinkFactor,
      baseWidth,
      itemOrder,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "horizontalAlignment",
      "verticalAlignment",
      "growFactor",
      "shrinkFactor",
      "baseWidth",
      "itemOrder",
      "children",
      "className",
      "css"
    ]);
    return /* @__PURE__ */ React20.createElement(
      BaseStackItem,
      __spreadValues({
        horizontalAlignment,
        verticalAlignment,
        ref,
        className: ["GDS-stack-item", className].join(" "),
        css: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, css2), { flexGrow: growFactor, flexShrink: shrinkFactor }), baseWidth && { flexBasis: setFlexBasis(baseWidth) }), itemOrder && { order: itemOrder })
      }, props),
      children
    );
  }
);

// src/components/column-layout/column-layout.tsx
import React22, { useEffect as useEffect4, forwardRef as forwardRef13, useMemo as useMemo3 } from "react";

// src/components/column-layout/column.tsx
import React21, { forwardRef as forwardRef12 } from "react";
var ColumnBase = transformingStyled("div", {
  alignSelf: "stretch"
});
var isColumn = (column) => {
  const columnProps = column == null ? void 0 : column.props;
  return (columnProps == null ? void 0 : columnProps.width) !== void 0;
};
var Column = forwardRef12(
  (_a, ref) => {
    var _b = _a, {
      width: responsiveWidth,
      offset: responsiveOffset,
      order: responsiveOrder,
      as: asElement,
      index,
      css: css2,
      className,
      children,
      startColumn
    } = _b, props = __objRest(_b, [
      "width",
      "offset",
      "order",
      "as",
      "index",
      "css",
      "className",
      "children",
      "startColumn"
    ]);
    const width = useResponsiveProp(responsiveWidth);
    const offset = useResponsiveProp(responsiveOffset);
    const order = useResponsiveProp(responsiveOrder);
    const gridColumnStart = offset && offset > 0 ? startColumn != null ? startColumn : 0 : "auto";
    const gridColumnEnd = `span ${width}`;
    return /* @__PURE__ */ React21.createElement(GenesisCoreInspector, { displayName: "Column" }, /* @__PURE__ */ React21.createElement(
      ColumnBase,
      __spreadValues({
        ref,
        className: ["GDS-column", className].join(" "),
        css: __spreadValues({
          gridColumnStart,
          gridColumnEnd,
          order
        }, css2)
      }, props),
      children
    ));
  }
);
Column.displayName = "Column";

// src/components/column-layout/column-layout.tsx
var ColumnCount = /* @__PURE__ */ ((ColumnCount2) => {
  ColumnCount2[ColumnCount2["mobile"] = 4] = "mobile";
  ColumnCount2[ColumnCount2["mobileLandscape"] = 8] = "mobileLandscape";
  ColumnCount2[ColumnCount2["tablet"] = 8] = "tablet";
  ColumnCount2[ColumnCount2["laptop"] = 12] = "laptop";
  ColumnCount2[ColumnCount2["desktop"] = 12] = "desktop";
  return ColumnCount2;
})(ColumnCount || {});
var DISPLAY_NAME11 = "ColumnLayout";
var ColumnLayoutBase = transformingStyled("div", {
  display: "grid",
  gap: "$oneAndHalf",
  paddingInlineStart: "$$spacingStart",
  paddingInlineEnd: "$$spacingEnd",
  "@mobile": {
    gridTemplateColumns: `repeat(${4 /* mobile */}, 1fr)`,
    gap: "$one"
  },
  "@mobileLandscape": {
    gridTemplateColumns: `repeat(${8 /* mobileLandscape */}, 1fr)`
  },
  "@tablet": {
    gridTemplateColumns: `repeat(${8 /* tablet */}, 1fr)`
  },
  "@laptop": {
    gridTemplateColumns: `repeat(${12 /* laptop */}, 1fr)`
  },
  "@desktop": {
    gridTemplateColumns: `repeat(${12 /* desktop */}, 1fr)`,
    maxWidth: breakpoints.desktop
  },
  variants: {
    background: {
      primary: {
        backgroundColor: "$surfaceBackgroundPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceBackgroundSecondary"
      },
      highlight: {
        backgroundColor: "$surfaceBackgroundTertiary"
      },
      transparent: {
        backgroundColor: "transparent"
      }
    }
  }
});
var ColumnLayout = forwardRef13(
  (_a, ref) => {
    var _b = _a, {
      onBreakpointChange,
      className,
      css: css2,
      children,
      background = "primary",
      spacingStart = {
        "@initial": "$oneAndHalf",
        "@mobile": "$oneAndHalf",
        "@mobileLandscape": "$two",
        "@tablet": "$two",
        "@laptop": "$twoAndHalf",
        "@desktop": "$twoAndHalf"
      },
      spacingEnd = {
        "@initial": "$oneAndHalf",
        "@mobile": "$oneAndHalf",
        "@mobileLandscape": "$two",
        "@tablet": "$two",
        "@laptop": "$twoAndHalf",
        "@desktop": "$twoAndHalf"
      },
      "data-testid": testId = `GDS-${DISPLAY_NAME11}`
    } = _b, props = __objRest(_b, [
      "onBreakpointChange",
      "className",
      "css",
      "children",
      "background",
      "spacingStart",
      "spacingEnd",
      "data-testid"
    ]);
    const activeBreakpoint = useActiveBreakpoint();
    const getResponsivePropValue2 = useResponsivePropCallback();
    const enhancedChildren = useMemo3(() => {
      let currentColumn = 1;
      return React22.Children.map(children, (child) => {
        var _a2, _b2, _c, _d;
        if (React22.isValidElement(child) && isColumn(child)) {
          const width = (_b2 = getResponsivePropValue2((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.width)) != null ? _b2 : 0;
          const offset = (_d = getResponsivePropValue2((_c = child == null ? void 0 : child.props) == null ? void 0 : _c.offset)) != null ? _d : 0;
          const startColumn = currentColumn + offset;
          currentColumn = startColumn + width;
          return React22.cloneElement(child, {
            startColumn
          });
        }
        return null;
      });
    }, [children, getResponsivePropValue2]);
    useEffect4(() => {
      if (activeBreakpoint)
        onBreakpointChange == null ? void 0 : onBreakpointChange({
          breakpoint: activeBreakpoint,
          columns: ColumnCount[activeBreakpoint]
        });
    }, [activeBreakpoint, onBreakpointChange]);
    return /* @__PURE__ */ React22.createElement(
      ColumnLayoutBase,
      __spreadValues({
        ref,
        background,
        className: ["GDS-column-layout", className].join(" "),
        css: __spreadValues({
          $$spacingStart: `$space${useResponsiveProp(spacingStart)}`,
          $$spacingEnd: `$space${useResponsiveProp(spacingEnd)}`
        }, css2),
        "data-testid": testId
      }, props),
      enhancedChildren
    );
  }
);
ColumnLayout.displayName = "ColumnLayout";

// src/components/skeleton/skeleton-rectangle.tsx
import React24 from "react";

// src/components/skeleton/skeleton-base.tsx
import React23 from "react";
import { keyframes as keyframes3 } from "@stitches/react";
var slide = keyframes3({
  "0%": {
    transform: "translateX(-100%)"
  },
  "100%": {
    transform: "translateX(100%)"
  }
});
var BaseSkeleton = transformingStyled("div", {
  backgroundColor: "$surfaceSkeletonShimmerBackground",
  height: "100%",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  "&:after": {
    content: "",
    top: 0,
    transform: "translateX(100%)",
    width: " 100%",
    height: "100%",
    position: "absolute",
    animation: `${slide} 2s infinite`,
    backgroundImage: "$surfaceSkeletonShimmerOverlay"
  }
});
var SkeletonBase = (_a) => {
  var _b = _a, {
    height = "100%",
    width,
    borderRadius = "$small",
    css: css2
  } = _b, props = __objRest(_b, [
    "height",
    "width",
    "borderRadius",
    "css"
  ]);
  const responsiveWidth = useResponsiveProp(width);
  const responsiveHeight = useResponsiveProp(height);
  return /* @__PURE__ */ React23.createElement(
    BaseSkeleton,
    __spreadValues({
      "aria-hidden": "true",
      css: __spreadValues({
        width: responsiveWidth,
        height: responsiveHeight,
        borderRadius
      }, css2)
    }, props)
  );
};

// src/components/skeleton/skeleton-rectangle.tsx
var DISPLAY_NAME12 = "SkeletonRectangle";
var ASPECT_RATIOS = {
  square: 1 / 1,
  standard: 4 / 3,
  tall: 3 / 4,
  wide: 16 / 9,
  panoramic: 11 / 4
};
var isGDSRatioToken = (ratioToken) => ratioToken in ASPECT_RATIOS;
var getAspectRatio = (aspectRatio) => {
  if (isGDSRatioToken(aspectRatio))
    return ASPECT_RATIOS[aspectRatio];
  return aspectRatio;
};
var SkeletonRectangle = (_a) => {
  var _b = _a, {
    aspectRatio = "square",
    borderRadius,
    height,
    width,
    css: css2,
    className,
    "data-testid": testId = `GDS-${DISPLAY_NAME12}`
  } = _b, props = __objRest(_b, [
    "aspectRatio",
    "borderRadius",
    "height",
    "width",
    "css",
    "className",
    "data-testid"
  ]);
  return /* @__PURE__ */ React24.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME12 }, /* @__PURE__ */ React24.createElement(
    SkeletonBase,
    __spreadValues({
      className: ["GDS-skeleton-rectangle", className].join(" "),
      height,
      width,
      borderRadius,
      css: __spreadProps(__spreadValues({}, css2), {
        "aspect-ratio": getAspectRatio(aspectRatio)
      }),
      "data-testid": testId
    }, props)
  ));
};
SkeletonRectangle.displayName = DISPLAY_NAME12;

// src/components/skeleton/skeleton-circle.tsx
import React25 from "react";
var DISPLAY_NAME13 = "SkeletonCircle";
var SkeletonCircle = (_a) => {
  var _b = _a, {
    size = "100%",
    css: css2,
    className,
    "data-testid": testId = `GDS-${DISPLAY_NAME13}`
  } = _b, props = __objRest(_b, [
    "size",
    "css",
    "className",
    "data-testid"
  ]);
  return /* @__PURE__ */ React25.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME13 }, /* @__PURE__ */ React25.createElement(
    SkeletonBase,
    __spreadValues({
      className: ["GDS-skeleton-circle", className].join(" "),
      height: size,
      width: size,
      borderRadius: "$circle",
      css: __spreadValues({}, css2),
      "data-testid": testId
    }, props)
  ));
};
SkeletonCircle.displayName = DISPLAY_NAME13;

// src/components/skeleton/skeleton-text.tsx
import React26 from "react";
var DISPLAY_NAME14 = "SkeletonText";
var LINE_WIDTHS = [100, 93, 81, 55, 66, 99, 88];
var LAST_LINE = 35;
var generateLines = ({
  lines = 1,
  header,
  width,
  borderRadius,
  css: css2,
  "data-testid": testId
}) => {
  const result = [];
  for (let index = 0; index < lines; index += 1) {
    const lineWidth = width || (lines > 1 && index === lines - 1 ? LAST_LINE : LINE_WIDTHS[index % LINE_WIDTHS.length]);
    result.push(
      /* @__PURE__ */ React26.createElement(
        SkeletonBase,
        {
          css: css2,
          key: index,
          height: header ? "$two" : "$one",
          width: width || `${lineWidth}%`,
          borderRadius,
          "data-testid": testId
        }
      )
    );
  }
  return result;
};
var SkeletonTextWrapper = transformingStyled("div", {
  textAlign: "$$alignment",
  display: "flex",
  gap: "$half",
  width: "100%",
  flexDirection: "column",
  variants: {
    alignment: {
      left: { alignItems: "start" },
      start: { alignItems: "start" },
      right: { alignItems: "end" },
      end: { alignItems: "end" },
      center: { alignItems: "center" }
    }
  }
});
var SkeletonText = (_a) => {
  var _b = _a, {
    lines = 1,
    header = false,
    alignment = "start",
    borderRadius,
    width,
    css: css2,
    "data-testid": testId = `GDS-${DISPLAY_NAME14}`
  } = _b, props = __objRest(_b, [
    "lines",
    "header",
    "alignment",
    "borderRadius",
    "width",
    "css",
    "data-testid"
  ]);
  return /* @__PURE__ */ React26.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME14 }, /* @__PURE__ */ React26.createElement(
    SkeletonTextWrapper,
    __spreadValues({
      alignment: useResponsiveProp(alignment),
      "data-testid": testId
    }, props),
    generateLines({
      lines,
      header,
      width: useResponsiveProp(width),
      borderRadius,
      css: css2,
      "data-testid": testId
    })
  ));
};
SkeletonText.displayName = DISPLAY_NAME14;

// src/components/image/image.tsx
import React27, { forwardRef as forwardRef14 } from "react";
var DISPLAY_NAME15 = "Image";
var StyledImage = transformingStyled("img", {});
var Image = forwardRef14(
  (_a, ref) => {
    var _b = _a, {
      className,
      alt = "",
      "data-testid": testId = `GDS-${DISPLAY_NAME15}`
    } = _b, props = __objRest(_b, [
      "className",
      "alt",
      "data-testid"
    ]);
    return /* @__PURE__ */ React27.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME15 }, /* @__PURE__ */ React27.createElement(
      StyledImage,
      __spreadValues({
        alt,
        className: ["GDS-image", className].join(" "),
        ref,
        "data-testid": testId
      }, props)
    ));
  }
);
Image.displayName = DISPLAY_NAME15;

// src/components/image-message/image-message.tsx
import React28 from "react";
var DISPLAY_NAME16 = "ImageMessage";
var ImageMessageBase = transformingStyled("div", {
  display: "flex",
  img: {
    maxWidth: "100%",
    maxHeight: "100%"
  },
  variants: {
    imagePosition: {
      top: {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      },
      end: { flexDirection: "row-reverse" },
      start: { flexDirection: "row" }
    }
  }
});
var ImageWrapper = transformingStyled("div", {
  display: "flex",
  variants: {
    imagePosition: {
      top: {
        width: "100%",
        marginBlockEnd: "$$imageGap"
      },
      start: {
        marginInlineEnd: "$$imageGap"
      },
      end: {
        marginInlineStart: "$$imageGap"
      }
    },
    imageHorizontalAlignment: {
      center: {
        justifyContent: "center"
      },
      start: {
        justifyContent: "start"
      },
      end: {
        justifyContent: "end"
      }
    },
    imageVerticalAlignment: {
      center: {
        alignItems: "center"
      },
      top: {
        alignItems: "start"
      },
      bottom: {
        alignItems: "end"
      }
    }
  }
});
var ContentWrapper = transformingStyled("div", {
  width: "100%"
});
var ImageMessage = (_a) => {
  var _b = _a, {
    children,
    image,
    imageGap = "$oneAndHalf",
    imageAlt = "",
    imagePosition = "top",
    imageHorizontalAlignment = "center",
    imageVerticalAlignment = "center",
    imageWidth = "auto",
    imageHeight = "auto",
    className,
    css: css2,
    "data-testid": testId = `GDS-${DISPLAY_NAME16}`
  } = _b, props = __objRest(_b, [
    "children",
    "image",
    "imageGap",
    "imageAlt",
    "imagePosition",
    "imageHorizontalAlignment",
    "imageVerticalAlignment",
    "imageWidth",
    "imageHeight",
    "className",
    "css",
    "data-testid"
  ]);
  return /* @__PURE__ */ React28.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME16 }, /* @__PURE__ */ React28.createElement(
    ImageMessageBase,
    __spreadValues({
      imagePosition: useResponsiveProp(imagePosition),
      className: ["GDS-image-message", className].join(" "),
      css: css2,
      "data-testid": testId
    }, props),
    /* @__PURE__ */ React28.createElement(
      ImageWrapper,
      {
        css: { $$imageGap: `$space${useResponsiveProp(imageGap)}` },
        imageHorizontalAlignment: useResponsiveProp(imageHorizontalAlignment),
        imageVerticalAlignment: useResponsiveProp(imageVerticalAlignment),
        imagePosition: useResponsiveProp(imagePosition)
      },
      /* @__PURE__ */ React28.createElement(
        Image,
        {
          width: imageWidth,
          height: imageHeight,
          src: image,
          alt: imageAlt
        }
      )
    ),
    children && /* @__PURE__ */ React28.createElement(ContentWrapper, null, children)
  ));
};
ImageMessage.displayName = DISPLAY_NAME16;

// src/components/status/status-banner/status-banner.tsx
import React30, { forwardRef as forwardRef15 } from "react";

// src/components/utils/is-emoji.ts
var EmojiRegexMatcher = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Presentation})", "iu");
var isEmoji = (node) => typeof node === "string" && EmojiRegexMatcher.test(node);

// src/components/status/status-color-tokens.ts
var backgroundColorByStatus = {
  success: "$successBackgroundSubdued",
  error: "$criticalBackgroundSubdued",
  info: "$highlightBackgroundSubdued",
  warning: "$warningBackgroundSubdued",
  neutral: "$inputBackgroundDisabled",
  brand: "$decorativeBrandPrimaryPastel"
};
var iconTintByStatus = {
  success: "$successIcon",
  error: "$criticalIcon",
  info: "$highlightIcon",
  warning: "$warningIcon",
  neutral: "$onSurfaceIconPrimary",
  brand: "$decorativeBrandPrimaryDefault"
};

// src/utilities.ts
import {
  createElement as createElement2
} from "react";
var isIcon = (icon) => {
  const iconProps = icon == null ? void 0 : icon.props;
  return (iconProps == null ? void 0 : iconProps.icon) !== void 0;
};
var withClassName = (component, ...classes) => {
  const name = `${typeof component === "string" ? component : ""}_${classes[0]}`;
  return {
    [name](props) {
      return createElement2(component, __spreadProps(__spreadValues({}, props), {
        className: `${props.className} ${classes}`
      }));
    }
  }[name];
};
var getComponentDisplayName = (element) => {
  const node = element;
  const { type } = node;
  const displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
  return displayName;
};

// src/components/status/status-banner/status-banner-emoji.tsx
import React29 from "react";
var Emoji = transformingStyled("span");
var StatusBannerEmoji = (_a) => {
  var _b = _a, {
    label,
    children,
    css: css2,
    className
  } = _b, props = __objRest(_b, [
    "label",
    "children",
    "css",
    "className"
  ]);
  if (!label) {
    console.error(
      "StatusBannerEmoji is missing a descriptive label. To be accessible, [role='img'] elements must have an alternative text."
    );
  }
  return /* @__PURE__ */ React29.createElement(
    Emoji,
    __spreadValues({
      className,
      css: __spreadValues({ typography: "$subtitleOne" }, css2),
      role: "img",
      "aria-label": label,
      "aria-hidden": !label
    }, props),
    children
  );
};

// src/components/status/status-banner/status-banner.tsx
var DISPLAY_NAME17 = "StatusBanner";
var iconByStatus = {
  success: "statusSuccessStatusFilled",
  error: "statusErrorStatusFilled",
  info: "statusInformationCircleFill",
  warning: "statusAlertFill",
  neutral: "statusInformationCircleFill",
  brand: "descriptivePerson"
};
var StatusBannerBase = transformingStyled(StackLayout, {
  borderRadius: "$small",
  padding: "$one",
  variants: {
    status: {
      info: {
        backgroundColor: backgroundColorByStatus.info
      },
      success: {
        backgroundColor: backgroundColorByStatus.success
      },
      warning: {
        backgroundColor: backgroundColorByStatus.warning
      },
      error: {
        backgroundColor: backgroundColorByStatus.error
      },
      brand: {
        backgroundColor: backgroundColorByStatus.brand
      },
      neutral: {
        backgroundColor: backgroundColorByStatus.neutral
      }
    }
  }
});
var StatusBannerIcon = ({
  icon,
  iconLabel,
  status,
  className
}) => {
  var _a;
  const { isGDSIconToken } = useGDSIcon();
  const defaultTint = iconTintByStatus[status];
  const defaultIcon = iconByStatus[status];
  if (!icon)
    return /* @__PURE__ */ React30.createElement(
      Icon,
      {
        icon: defaultIcon,
        tint: defaultTint,
        className,
        label: iconLabel
      }
    );
  if (isGDSIconToken(icon))
    return /* @__PURE__ */ React30.createElement(Icon, { icon, tint: defaultTint, label: iconLabel });
  if (isEmoji(icon))
    return /* @__PURE__ */ React30.createElement(StatusBannerEmoji, { className, label: iconLabel }, icon);
  if (React30.isValidElement(icon)) {
    if (isIcon(icon)) {
      const iconProps = icon == null ? void 0 : icon.props;
      const iconTint = (_a = iconProps.tint) != null ? _a : defaultTint;
      return React30.cloneElement(icon, __spreadProps(__spreadValues({}, iconProps), {
        className,
        tint: iconTint
      }));
    }
    return React30.cloneElement(icon, {
      className
    });
  }
  return null;
};
var StatusBanner = forwardRef15(
  (_a, ref) => {
    var _b = _a, {
      status,
      title,
      showIcon = true,
      headingLevel = "display",
      icon,
      iconLabel,
      onDismissClick,
      textAction,
      css: css2,
      children,
      className,
      "data-testid": testId = `GDS-${DISPLAY_NAME17}`
    } = _b, props = __objRest(_b, [
      "status",
      "title",
      "showIcon",
      "headingLevel",
      "icon",
      "iconLabel",
      "onDismissClick",
      "textAction",
      "css",
      "children",
      "className",
      "data-testid"
    ]);
    const hasChildren = Boolean(children);
    const strings = useThemeStrings();
    const isTextAction = textAction ? checkIsTextAction(textAction) : void 0;
    if (textAction && onDismissClick) {
      console.warn(
        "StatusBanner only accepts either textAction or onDismissClick. Please remove one of them."
      );
    }
    return /* @__PURE__ */ React30.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME17 }, /* @__PURE__ */ React30.createElement(
      StatusBannerBase,
      __spreadValues({
        className: ["GDS-status-banner", className].join(" "),
        orientation: "horizontal",
        spacing: "$half",
        verticalAlignment: hasChildren ? void 0 : "center",
        status,
        ref,
        css: css2,
        "data-testid": testId
      }, props),
      showIcon ? /* @__PURE__ */ React30.createElement(StackItem, null, /* @__PURE__ */ React30.createElement(
        StatusBannerIcon,
        {
          icon,
          iconLabel,
          status,
          className: "GDS-status-banner-icon"
        }
      )) : null,
      /* @__PURE__ */ React30.createElement(StackItem, { growFactor: 1 }, /* @__PURE__ */ React30.createElement(StackLayout, null, title ? /* @__PURE__ */ React30.createElement(StackItem, null, React30.isValidElement(title) ? title : /* @__PURE__ */ React30.createElement(
        HeadingText,
        {
          level: headingLevel,
          size: "sm",
          className: "GDS-status-banner-title"
        },
        title
      )) : null, children ? /* @__PURE__ */ React30.createElement(StackItem, null, children) : null)),
      isTextAction && textAction,
      onDismissClick && !textAction ? /* @__PURE__ */ React30.createElement(StackItem, null, /* @__PURE__ */ React30.createElement(
        Button,
        {
          className: "GDS-status-banner-dismiss-button",
          onClick: onDismissClick,
          priority: "secondary",
          quiet: true,
          hideLabel: true,
          icon: "tinyClose",
          size: "small"
        },
        strings == null ? void 0 : strings.dismiss
      )) : null
    ));
  }
);
StatusBanner.displayName = DISPLAY_NAME17;

// src/components/status/status-badge/status-badge.tsx
import React31 from "react";
var DISPLAY_NAME18 = "StatusBadge";
var StatusBadgeLight = transformingStyled("div", {
  width: 10,
  height: 10,
  borderRadius: "$circle",
  variants: {
    status: {
      info: {
        backgroundColor: iconTintByStatus.info
      },
      success: {
        backgroundColor: iconTintByStatus.success
      },
      warning: {
        backgroundColor: iconTintByStatus.warning
      },
      error: {
        backgroundColor: iconTintByStatus.error
      },
      brand: {
        backgroundColor: iconTintByStatus.brand
      },
      neutral: {
        backgroundColor: iconTintByStatus.neutral
      }
    }
  }
});
var StatusBadgeBase = transformingStyled("div", {
  display: "inline-block",
  borderRadius: "$pill",
  variants: {
    status: {
      info: {
        backgroundColor: backgroundColorByStatus.info
      },
      success: {
        backgroundColor: backgroundColorByStatus.success
      },
      warning: {
        backgroundColor: backgroundColorByStatus.warning
      },
      error: {
        backgroundColor: backgroundColorByStatus.error
      },
      brand: {
        backgroundColor: backgroundColorByStatus.brand
      },
      neutral: {
        backgroundColor: backgroundColorByStatus.neutral
      }
    }
  }
});
var StatusBadge = (_a) => {
  var _b = _a, {
    status,
    label,
    showLight = true,
    className,
    css: css2,
    "data-testid": testId = `GDS-${DISPLAY_NAME18}`
  } = _b, props = __objRest(_b, [
    "status",
    "label",
    "showLight",
    "className",
    "css",
    "data-testid"
  ]);
  return /* @__PURE__ */ React31.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME18 }, /* @__PURE__ */ React31.createElement(
    StatusBadgeBase,
    __spreadValues({
      className: ["GDS-status-badge", className].join(" "),
      status,
      css: css2,
      "data-testid": testId
    }, props),
    /* @__PURE__ */ React31.createElement(
      StackLayout,
      {
        orientation: "horizontal",
        verticalAlignment: "center",
        spacing: "$quarter",
        css: { paddingInlineStart: "$half", paddingInlineEnd: "$half" }
      },
      showLight ? /* @__PURE__ */ React31.createElement(
        StatusBadgeLight,
        {
          className: "GDS-status-badge-light",
          status
        }
      ) : null,
      /* @__PURE__ */ React31.createElement(UtilityText, { size: "sm", emphasis: "emphasized" }, label)
    )
  ));
};
StatusBadge.displayName = DISPLAY_NAME18;

// src/components/card/card.tsx
import React35, { forwardRef as forwardRef17 } from "react";

// src/components/card/card-section.tsx
import React32 from "react";
var BaseCardPart = transformingStyled("div", {
  padding: "$oneAndHalf",
  position: "relative",
  flex: 1
});
var CardSection = ({
  children,
  className,
  css: css2,
  padding,
  "data-testid": testId = "GDS-CardSection"
}) => {
  const cardPadding = useResponsiveProp(padding);
  return /* @__PURE__ */ React32.createElement(
    BaseCardPart,
    {
      "data-testid": testId,
      className: ["GDS-card-section", className].join(" "),
      css: __spreadValues(__spreadValues({}, css2), padding && {
        padding: `${cardPadding}`
      })
    },
    children
  );
};

// src/components/card/card-image.tsx
import React33 from "react";
var BaseImage = transformingStyled("img", {
  width: "100%",
  objectFit: "cover"
});
var CardImage = (_a) => {
  var _b = _a, {
    className,
    css: css2,
    image,
    imageAlt = "",
    "data-testid": testId = "GDS-CardImage"
  } = _b, props = __objRest(_b, [
    "className",
    "css",
    "image",
    "imageAlt",
    "data-testid"
  ]);
  return /* @__PURE__ */ React33.createElement(
    BaseImage,
    __spreadValues({
      src: image,
      alt: imageAlt,
      css: css2,
      className: ["GDS-card-image", className].join(" "),
      "data-testid": testId
    }, props)
  );
};

// src/components/card/card-click-area.tsx
import React34, { forwardRef as forwardRef16 } from "react";
var IMAGE_MAX_WIDTH = "350px";
var DISPLAY_NAME19 = "CardClickArea";
var ImagePositionWrapper = transformingStyled("div", {
  borderRadius: "$card",
  display: "flex",
  overflow: "hidden",
  variants: {
    imagePosition: {
      top: {
        flexDirection: "column",
        alignItems: "stretch"
      },
      start: {
        flexDirection: "row",
        "& img": {
          maxWidth: IMAGE_MAX_WIDTH
        }
      },
      end: {
        flexDirection: "row-reverse",
        "& img": {
          maxWidth: IMAGE_MAX_WIDTH
        }
      }
    }
  }
});
var BaseClickArea = transformingStyled(ImagePositionWrapper, {
  border: "$borderWidths$card solid $onSurfaceBorderCard",
  boxShadow: "$card",
  borderRadius: "$card",
  overflow: "hidden",
  flex: "1",
  "&:hover": {
    cursor: "pointer",
    border: "$borderWidths$card solid $colors$interactiveFocusOuter",
    "a:hover, button:hover": {
      textDecoration: "none"
    }
  },
  '& [class*="GDS"]:focus': {
    outline: "none"
  },
  '& [class*="GDS"]:focus-visible': __spreadValues({}, focusOutlineOuter)
});
var CardClickArea = forwardRef16(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      imagePosition = "top",
      onCardMouseDown,
      onCardMouseUp,
      "data-testid": testId = `GDS-${DISPLAY_NAME19}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "imagePosition",
      "onCardMouseDown",
      "onCardMouseUp",
      "data-testid"
    ]);
    const cardImagePosition = useResponsiveProp(imagePosition);
    return /* @__PURE__ */ React34.createElement(
      BaseClickArea,
      __spreadValues({
        ref,
        className: ["GDS-card-click-area", className].join(" "),
        onMouseDown: onCardMouseDown,
        onMouseUp: onCardMouseUp,
        imagePosition: cardImagePosition,
        css: css2,
        "data-testid": testId
      }, props),
      children
    );
  }
);

// src/components/card/card.tsx
var FLAT_CARD_DISPLAY_NAME = "FlatCardContainer";
var ELEVATED_CARD_DISPLAY_NAME = "ElevatedCard";
var CARD_SECTION_DISPLAY_NAME = "CardSection";
var CARD_IMAGE_DISPLAY_NAME = "CardImage";
var CARD_CLICK_AREA_DISPLAY_NAME = "CardClickArea";
var overlayStyles = {
  backgroundOverlay: {
    true: {
      "&:before": {
        content: "",
        position: "absolute",
        top: 0,
        insetInlineEnd: 0,
        bottom: 0,
        insetInlineStart: 0,
        width: "100%",
        height: "100%",
        opacity: "40%"
      }
    }
  }
};
var BaseCardContainer = transformingStyled(ImagePositionWrapper, {
  position: "relative"
});
var ElevatedCardBase = transformingStyled(BaseCardContainer, {
  border: "$borderWidths$card solid $onSurfaceBorderCard",
  boxShadow: "$card",
  "&:has(.GDS-card-click-area)": {
    border: "none",
    boxShadow: "none"
  },
  variants: __spreadProps(__spreadValues({}, overlayStyles), {
    backgroundColor: {
      primary: {
        backgroundColor: "$surfaceCardPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceCardSecondary"
      },
      highlight: {
        backgroundColor: "$surfaceBackgroundTertiary"
      }
    }
  }),
  compoundVariants: [
    {
      backgroundColor: "primary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceCardPrimary"
        }
      }
    },
    {
      backgroundColor: "secondary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceCardSecondary"
        }
      }
    },
    {
      backgroundColor: "highlight",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundTertiary"
        }
      }
    }
  ]
});
var FlatCardBase = transformingStyled(BaseCardContainer, {
  variants: __spreadProps(__spreadValues({}, overlayStyles), {
    backgroundColor: {
      transparent: {
        backgroundColor: "transparent"
      },
      primary: {
        backgroundColor: "$surfaceBackgroundPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceBackgroundSecondary"
      },
      highlight: {
        backgroundColor: "$surfaceBackgroundTertiary"
      }
    }
  }),
  compoundVariants: [
    {
      backgroundColor: "primary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundPrimary"
        }
      }
    },
    {
      backgroundColor: "secondary",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundSecondary"
        }
      }
    },
    {
      backgroundColor: "highlight",
      backgroundOverlay: "true",
      css: {
        "&:before": {
          backgroundColor: "$surfaceBackgroundTertiary"
        }
      }
    }
  ]
});
var ElevatedCardContainer = forwardRef17(
  (_a, ref) => {
    var _b = _a, {
      backgroundColor = "primary",
      backgroundImage,
      backgroundOverlay,
      children,
      className,
      css: css2,
      imagePosition = "top",
      "data-testid": testId = `GDS-${ELEVATED_CARD_DISPLAY_NAME}`
    } = _b, props = __objRest(_b, [
      "backgroundColor",
      "backgroundImage",
      "backgroundOverlay",
      "children",
      "className",
      "css",
      "imagePosition",
      "data-testid"
    ]);
    const cardImagePosition = useResponsiveProp(imagePosition);
    return /* @__PURE__ */ React35.createElement(GenesisCoreInspector, { displayName: ELEVATED_CARD_DISPLAY_NAME }, /* @__PURE__ */ React35.createElement(
      ElevatedCardBase,
      __spreadValues({
        "data-testid": testId,
        backgroundColor,
        backgroundOverlay,
        className: ["GDS-elevated-card", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), backgroundImage && {
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }),
        imagePosition: cardImagePosition,
        ref
      }, props),
      children
    ));
  }
);
var FlatCardContainer = forwardRef17(
  (_a, ref) => {
    var _b = _a, {
      backgroundColor = "primary",
      backgroundImage,
      backgroundOverlay,
      children,
      css: css2,
      className,
      imagePosition = "top",
      "data-testid": testId = `GDS-${FLAT_CARD_DISPLAY_NAME}`
    } = _b, props = __objRest(_b, [
      "backgroundColor",
      "backgroundImage",
      "backgroundOverlay",
      "children",
      "css",
      "className",
      "imagePosition",
      "data-testid"
    ]);
    const cardImagePosition = useResponsiveProp(imagePosition);
    return /* @__PURE__ */ React35.createElement(GenesisCoreInspector, { displayName: FLAT_CARD_DISPLAY_NAME }, /* @__PURE__ */ React35.createElement(
      FlatCardBase,
      __spreadValues({
        "data-testid": testId,
        backgroundColor,
        backgroundOverlay,
        className: ["GDS-flat-card", className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), backgroundImage && {
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }),
        imagePosition: cardImagePosition,
        ref
      }, props),
      children
    ));
  }
);
var Card = {
  Flat: FlatCardContainer,
  Elevated: ElevatedCardContainer,
  Section: CardSection,
  Image: CardImage,
  ClickArea: CardClickArea
};
Card.Flat.displayName = FLAT_CARD_DISPLAY_NAME;
Card.Elevated.displayName = ELEVATED_CARD_DISPLAY_NAME;
Card.Section.displayName = CARD_SECTION_DISPLAY_NAME;
Card.Image.displayName = CARD_IMAGE_DISPLAY_NAME;
Card.ClickArea.displayName = CARD_CLICK_AREA_DISPLAY_NAME;

// src/components/composable-card/composable-card-root.tsx
import React39, { forwardRef as forwardRef20 } from "react";

// src/components/composable-card/composable-card-dismiss-button.tsx
import React36, { forwardRef as forwardRef18 } from "react";
var getButtonStyles = (isFloatingButton) => isFloatingButton ? {
  position: "absolute",
  insetBlockStart: "$half",
  insetInlineEnd: "$half",
  zIndex: 2
} : { alignSelf: "end" };
var ComposableCardDismissButton = forwardRef18(
  ({
    "data-testid": testId = `GDS-ComposableCard-DismissButton`,
    onDismiss,
    dismissButtonLabel,
    isFloatingButton = false,
    css: css2
  }, ref) => {
    const strings = useThemeStrings();
    const buttonStyles = getButtonStyles(isFloatingButton);
    return /* @__PURE__ */ React36.createElement(
      Button,
      {
        "data-testid": testId,
        className: "GDS-composable-card-dismiss-button",
        hideLabel: true,
        icon: "interfaceClose",
        priority: "secondary",
        onClick: onDismiss,
        quiet: true,
        size: "small",
        css: __spreadValues(__spreadValues({}, buttonStyles), css2),
        ref
      },
      dismissButtonLabel || strings.dismiss
    );
  }
);

// src/components/box/box.tsx
import React37, { forwardRef as forwardRef19 } from "react";
var BaseBox = transformingStyled("div");
var DISPLAY_NAME20 = "Box";
var Box = forwardRef19(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      className,
      css: css2,
      children,
      "data-testid": testId = `GDS-${DISPLAY_NAME20}`
    } = _b, props = __objRest(_b, [
      "as",
      "className",
      "css",
      "children",
      "data-testid"
    ]);
    return /* @__PURE__ */ React37.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME20 }, /* @__PURE__ */ React37.createElement(
      BaseBox,
      __spreadValues({
        "data-testid": testId,
        as: asElement,
        className: ["GDS-box", className].join(" "),
        css: __spreadValues({}, css2),
        ref
      }, props),
      children
    ));
  }
);
Box.displayName = DISPLAY_NAME20;

// src/components/composable-card/composable-card-media.tsx
import React38 from "react";
var ComposableCardMedia = ({
  mediaSrc,
  mediaAltText,
  mediaHeight = "148px",
  css: css2
}) => /* @__PURE__ */ React38.createElement(Box, { className: "GDS-composable-card-media", css: css2 }, /* @__PURE__ */ React38.createElement(
  Image,
  {
    src: mediaSrc,
    alt: mediaAltText,
    css: {
      display: "block",
      height: mediaHeight,
      objectFit: "cover",
      objectPosition: "center",
      borderStartEndRadius: "$card",
      borderStartStartRadius: "$card"
    }
  }
));

// src/components/composable-card/composable-card-root.tsx
var DISPLAY_NAME21 = "ComposableCardRoot";
var StyledCardRoot = transformingStyled(StackLayout, {
  border: "$borderWidths$card solid $onSurfaceBorderCard",
  boxShadow: "$card",
  borderRadius: "$card",
  position: "relative",
  transition: "border-color $defaultTime ease-in-out",
  overflow: "hidden",
  height: "auto",
  "&:has(.GDS-composable-card-action)": {
    "&:hover": {
      cursor: "pointer",
      border: "$borderWidths$card solid $colors$interactiveFocusOuter",
      "a:hover, button:hover": {
        textDecoration: "none"
      }
    }
  },
  variants: {
    backgroundColor: {
      primary: {
        backgroundColor: "$surfaceCardPrimary"
      },
      secondary: {
        backgroundColor: "$surfaceCardSecondary"
      }
    }
  }
});
var overlayStyles2 = {
  content: "",
  position: "absolute",
  top: 0,
  insetInlineEnd: 0,
  bottom: 0,
  insetInlineStart: 0,
  width: "100%",
  height: "100%",
  opacity: "40%"
};
var getOverlayColor = (backgroundColor) => {
  if (backgroundColor === "primary") {
    return "$surfaceCardPrimary";
  }
  if (backgroundColor === "secondary") {
    return "$surfaceCardSecondary";
  }
  return void 0;
};
var ComposableCardRoot = forwardRef20(
  ({
    "data-testid": testId = `GDS-${DISPLAY_NAME21}`,
    backgroundColor = "secondary",
    children,
    className,
    css: css2,
    dismissButtonLabel = "Dismiss",
    mediaAltText,
    mediaHeight,
    mediaSrc,
    onCardMouseDown,
    onCardMouseUp,
    onDismiss,
    backgroundImage,
    backgroundOverlay
  }, ref) => {
    const hasMedia = !!mediaSrc;
    const hasChildren = !!children;
    const shouldRenderFloatingDismissButton = onDismiss && mediaSrc;
    const shouldRenderInlineDismissButton = onDismiss && !mediaSrc && hasChildren;
    const cardBodyStyles = __spreadValues({
      backgroundImage: `url(${backgroundImage})`,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    }, backgroundOverlay && {
      position: "relative",
      "&:before": __spreadValues({
        backgroundColor: getOverlayColor(backgroundColor)
      }, overlayStyles2)
    });
    return /* @__PURE__ */ React39.createElement(
      StyledCardRoot,
      {
        backgroundColor,
        className: ["GDS-composable-card", className].join(" "),
        css: __spreadValues(__spreadValues({}, onCardMouseUp && { cursor: "pointer" }), css2),
        "data-testid": testId,
        onMouseDown: onCardMouseDown,
        onMouseUp: onCardMouseUp,
        ref,
        horizontalAlignment: "stretch"
      },
      shouldRenderFloatingDismissButton && /* @__PURE__ */ React39.createElement(
        ComposableCardDismissButton,
        {
          onDismiss,
          dismissButtonLabel,
          isFloatingButton: true
        }
      ),
      hasMedia && /* @__PURE__ */ React39.createElement(
        ComposableCardMedia,
        {
          mediaSrc,
          mediaAltText,
          mediaHeight
        }
      ),
      hasChildren && /* @__PURE__ */ React39.createElement(Box, { className: "GDS-composable-card-body", css: cardBodyStyles }, /* @__PURE__ */ React39.createElement(
        StackLayout,
        {
          spacing: "$half",
          css: { padding: "$one", position: "relative" },
          horizontalAlignment: "stretch"
        },
        shouldRenderInlineDismissButton && /* @__PURE__ */ React39.createElement(
          ComposableCardDismissButton,
          {
            onDismiss,
            dismissButtonLabel
          }
        ),
        /* @__PURE__ */ React39.createElement(StackLayout, { spacing: "$one", horizontalAlignment: "stretch" }, children)
      ))
    );
  }
);
ComposableCardRoot.displayName = DISPLAY_NAME21;

// src/components/composable-card/composable-card-body.tsx
import React41, { forwardRef as forwardRef22 } from "react";

// src/components/composable-card/conditional-link-or-button.tsx
import React40, { forwardRef as forwardRef21 } from "react";

// src/components/utils/is-external-link.ts
var isExternalUrl = (url) => {
  if (!url) {
    return false;
  }
  const startsWithHttp = /^http/i.test(url);
  const isNotSameHostname = !new RegExp(
    `^http(s)?://${window.location.hostname}`,
    "i"
  ).test(url);
  return startsWithHttp && isNotSameHostname;
};

// src/components/utils/get-link-or-button-props.ts
var getLinkOrButtonProps = (onClick, href, linkAs) => {
  if (href) {
    const external = isExternalUrl(href);
    if (!external && linkAs) {
      return {
        as: linkAs,
        onClick: (event) => {
          if (onClick) {
            onClick(event);
          }
        }
      };
    }
    return {
      as: "a",
      target: "_blank",
      rel: "noopener noreferrer",
      href,
      onClick: (event) => {
        if (onClick) {
          onClick(event);
        }
      }
    };
  }
  return {
    as: "button",
    onClick: onClick || (() => {
    })
  };
};

// src/components/composable-card/conditional-link-or-button.tsx
var ConditionalLinkRenderer = forwardRef21((_a, ref) => {
  var _b = _a, { css: css2, heading, href, onClick, linkAs } = _b, extraProps = __objRest(_b, ["css", "heading", "href", "onClick", "linkAs"]);
  if (onClick || href) {
    const linkProps = getLinkOrButtonProps(onClick, href, linkAs);
    return /* @__PURE__ */ React40.createElement(
      TextAction,
      __spreadValues(__spreadProps(__spreadValues({
        ref
      }, linkProps), {
        className: "GDS-composable-card-action",
        css: css2
      }), extraProps),
      heading
    );
  }
  return /* @__PURE__ */ React40.createElement("span", null, heading);
});

// src/components/composable-card/composable-card-body.tsx
var DISPLAY_NAME22 = "ComposableCardBody";
var indicatorByString2 = {
  externalLink: "tinyExternalLink",
  meatballs: "interfaceMeatballs",
  newWindowInternal: "tinyNewWindowInternal",
  rightChevron: "interfaceChevronForward"
};
var getIconByIndicator2 = (indicator) => indicatorByString2[indicator];
var ComposableCardBodyContent = forwardRef22(
  (_a, ref) => {
    var _b = _a, {
      caption,
      className,
      css: css2,
      heading,
      headingLevel = "3",
      href,
      imageAltText,
      imagePosition = "leading",
      imageSize = "48px",
      imageSrc,
      onClick,
      subheading,
      trailingIcon,
      trailingIconAltText,
      linkAs
    } = _b, props = __objRest(_b, [
      "caption",
      "className",
      "css",
      "heading",
      "headingLevel",
      "href",
      "imageAltText",
      "imagePosition",
      "imageSize",
      "imageSrc",
      "onClick",
      "subheading",
      "trailingIcon",
      "trailingIconAltText",
      "linkAs"
    ]);
    const stringsMap = useThemeStrings();
    const labelByIndicator = {
      externalLink: stringsMap.externalLink,
      meatballs: stringsMap.moreOptions,
      newWindowInternal: stringsMap.newWindowInternal,
      rightChevron: stringsMap.disclosure
    };
    const getLabelByIndicator = (indicatorIcon) => labelByIndicator[indicatorIcon];
    return /* @__PURE__ */ React41.createElement(
      StackLayout,
      {
        className: ["GDS-composable-card-body-content", className].join(" "),
        css: css2,
        "data-testid": `GDS-${DISPLAY_NAME22}`,
        horizontalAlignment: "spaceBetween",
        orientation: "horizontal",
        spacing: "$half",
        verticalAlignment: "center"
      },
      imageSrc && imagePosition === "leading" && /* @__PURE__ */ React41.createElement(
        Image,
        {
          src: imageSrc,
          alt: imageAltText,
          css: { width: imageSize, height: imageSize }
        }
      ),
      (caption || heading || subheading) && /* @__PURE__ */ React41.createElement(StackItem, { css: { flex: 1 } }, caption && /* @__PURE__ */ React41.createElement(UtilityText, { size: "xs", emphasis: "base" }, caption), heading && /* @__PURE__ */ React41.createElement(
        HeadingText,
        {
          level: headingLevel,
          size: "sm",
          css: { '& [class*="GDS"]:focus': { outlineOffset: "0" } }
        },
        /* @__PURE__ */ React41.createElement(
          ConditionalLinkRenderer,
          __spreadValues({
            heading,
            href,
            linkAs,
            onClick,
            ref
          }, props)
        )
      ), subheading && /* @__PURE__ */ React41.createElement(ParagraphText, null, subheading)),
      trailingIcon && /* @__PURE__ */ React41.createElement(
        Icon,
        {
          icon: getIconByIndicator2(trailingIcon),
          label: trailingIconAltText || getLabelByIndicator(trailingIcon)
        }
      ),
      imageSrc && imagePosition === "trailing" && !trailingIcon && /* @__PURE__ */ React41.createElement(
        Image,
        {
          alt: imageAltText,
          css: { width: imageSize, height: imageSize },
          src: imageSrc
        }
      )
    );
  }
);
ComposableCardBodyContent.displayName = DISPLAY_NAME22;

// src/components/composable-card/composable-card-cta-section.tsx
import React42, { forwardRef as forwardRef23 } from "react";
var CTA = (ctaProps) => {
  const _a = ctaProps || {}, {
    type,
    label,
    href,
    icon,
    iconAltText,
    indicator,
    indicatorAltText,
    onClick,
    as,
    position
  } = _a, extraProps = __objRest(_a, [
    "type",
    "label",
    "href",
    "icon",
    "iconAltText",
    "indicator",
    "indicatorAltText",
    "onClick",
    "as",
    "position"
  ]);
  const sharedProps = __spreadValues(__spreadValues({
    icon,
    iconLabel: iconAltText || "",
    indicator,
    indicatorLabel: indicatorAltText
  }, extraProps), getLinkOrButtonProps(onClick, href, as));
  if (type === "textAction") {
    return /* @__PURE__ */ React42.createElement(
      TextAction,
      __spreadProps(__spreadValues({}, sharedProps), {
        css: {
          alignSelf: position === "fullWidth" ? "center" : void 0,
          textAlign: position === "fullWidth" || position === "center" ? "center" : void 0
        }
      }),
      label
    );
  }
  return /* @__PURE__ */ React42.createElement(
    Button,
    __spreadValues({
      priority: type === "tertiaryQuiet" ? "tertiary" : type,
      quiet: type === "tertiaryQuiet",
      size: "medium",
      width: position === "fullWidth" ? "fillContainer" : void 0
    }, sharedProps),
    label
  );
};
var getOrientationAndAlignment = (ctaPosition) => {
  switch (ctaPosition) {
    case "fullWidth":
      return {
        orientation: "vertical",
        horizontalAlignment: "stretch"
      };
    case "center":
      return {
        orientation: "horizontal",
        horizontalAlignment: "center",
        verticalAlignment: "center"
      };
    case "leading":
    default:
      return {
        orientation: "vertical",
        horizontalAlignment: "start"
      };
  }
};
var ComposableCardCTASection = forwardRef23(({ className, css: css2, firstCta, secondCta, position = "leading" }, ref) => /* @__PURE__ */ React42.createElement(
  StackLayout,
  __spreadValues({
    spacing: "$half",
    ref,
    className: ["GDS-composable-card-cta-section", className].join(" "),
    css: __spreadValues({ flexWrap: "wrap" }, css2)
  }, getOrientationAndAlignment(position)),
  firstCta && /* @__PURE__ */ React42.createElement(
    CTA,
    __spreadValues({
      type: (firstCta == null ? void 0 : firstCta.type) || "primary",
      position
    }, firstCta)
  ),
  firstCta && secondCta && /* @__PURE__ */ React42.createElement(
    CTA,
    __spreadValues({
      type: (secondCta == null ? void 0 : secondCta.type) || "textAction",
      position
    }, secondCta)
  )
));

// src/components/composable-card/composable-card-content.tsx
import React43, { forwardRef as forwardRef24 } from "react";
var DISPLAY_NAME23 = "ComposableCardContent";
var ComposableCardContent = forwardRef24(
  (_a, ref) => {
    var _b = _a, {
      "data-testid": testId = `GDS-${DISPLAY_NAME23}`,
      children,
      className,
      css: css2
    } = _b, props = __objRest(_b, [
      "data-testid",
      "children",
      "className",
      "css"
    ]);
    return /* @__PURE__ */ React43.createElement(
      Box,
      __spreadValues({
        className: ["GDS-composable-card-content-slot", className].join(" "),
        css: css2,
        "data-testid": testId,
        ref
      }, props),
      children
    );
  }
);
ComposableCardContent.displayName = DISPLAY_NAME23;

// src/components/composable-card/index.ts
var ComposableCard = {
  Root: ComposableCardRoot,
  Body: ComposableCardBodyContent,
  Content: ComposableCardContent,
  CTASection: ComposableCardCTASection
};

// src/components/portal/portal.tsx
import React44, { forwardRef as forwardRef25 } from "react";
import * as RadixPortal from "@radix-ui/react-portal";
var Portal = forwardRef25(
  (_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
    const theme2 = useTheme();
    return /* @__PURE__ */ React44.createElement(RadixPortal.Root, __spreadProps(__spreadValues({}, props), { className: "GDS-portal" }), /* @__PURE__ */ React44.createElement(ThemeContainer, { theme: theme2, ref }, children));
  }
);

// src/components/responsive/responsive.tsx
import React45 from "react";

// src/hooks/use-media-query.ts
import { useState as useState6, useEffect as useEffect5 } from "react";
var useMediaQuery = (query) => {
  const [matches, setMatches] = useState6(window.matchMedia(query).matches);
  useEffect5(() => {
    const eventListener = (e) => setMatches(e.matches);
    const matchedMediaList = window.matchMedia(query);
    matchedMediaList.addEventListener("change", eventListener);
    return () => matchedMediaList.removeEventListener("change", eventListener);
  }, [query]);
  return matches;
};

// src/breakpoints/query-helpers.ts
var sortBreakpointsValues = (values) => {
  const keys = Object.keys(values);
  const breakpointsAsArray = keys.map((key) => ({ key, val: values[key] })) || [];
  breakpointsAsArray.sort(
    (breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val
  );
  return breakpointsAsArray.reduce(
    (acc, obj) => __spreadProps(__spreadValues({}, acc), { [obj.key]: obj.val }),
    {}
  );
};
var sortedBreakpointValues = sortBreakpointsValues(breakpoints);
var breakpointKeys = Object.keys(sortedBreakpointValues);
var unit = "px";
var isBreakpointToken = (token) => token in breakpoints;
var getValue = (breakpoint) => {
  if (isBreakpointToken(breakpoint))
    return breakpoints[breakpoint];
  return breakpoint;
};
var up = (breakpoint) => {
  const value = getValue(breakpoint);
  return `(min-width:${value}${unit})`;
};
var down = (breakpoint) => {
  const value = getValue(breakpoint);
  return `(max-width:${value - 1}${unit})`;
};
var between = (rangeValues) => {
  const startValue = getValue(rangeValues == null ? void 0 : rangeValues[0]);
  const endValue = getValue(rangeValues == null ? void 0 : rangeValues[1]);
  return `(min-width:${startValue}${unit}) and (max-width:${endValue - 1}${unit})`;
};
var only = (breakpoint) => {
  if (breakpointKeys.indexOf(breakpoint) + 1 < breakpointKeys.length) {
    return between([
      breakpoint,
      breakpointKeys[breakpointKeys.indexOf(breakpoint) + 1]
    ]);
  }
  return up(breakpoint);
};
var not = (breakpoint) => {
  const keyIndex = breakpointKeys.indexOf(breakpoint);
  if (keyIndex === 0) {
    return up(breakpointKeys[1]);
  }
  if (keyIndex === breakpointKeys.length - 1) {
    return down(breakpointKeys[keyIndex]);
  }
  const betweenQuery = between([
    breakpoint,
    breakpointKeys[breakpointKeys.indexOf(breakpoint) + 1]
  ]);
  return betweenQuery && `not all and ${betweenQuery}`;
};
var queryHelpers = { up, down, between, only, not };

// src/components/responsive/responsive.tsx
var getMediaQueryFromProps = (otherProps, query) => {
  if (query)
    return query;
  const queryHelperPropKeys = Object.keys(otherProps).filter((key) => Object.keys(queryHelpers).includes(key)).sort();
  const queryHelperProps = queryHelperPropKeys.reduce(
    (result, key) => __spreadProps(__spreadValues({}, result), { [key]: otherProps[key] }),
    {}
  );
  if (!query && queryHelperPropKeys.length === 0) {
    console.warn(
      "No prop passed. Please provide one of: up, down, between, only, not, query."
    );
    return "false";
  }
  if (query && queryHelperPropKeys.length > 0 || !query && queryHelperPropKeys.length > 1) {
    console.warn(
      "Too many props passed. Please provide only one of: up, down, between, only, not, query."
    );
    return "false";
  }
  const helperKey = queryHelperPropKeys[0];
  if (helperKey) {
    const helperFunction = queryHelpers[helperKey];
    const value = queryHelperProps[helperKey];
    return helperFunction(value);
  }
  return "false";
};
var Responsive = (_a) => {
  var _b = _a, {
    children,
    query
  } = _b, otherProps = __objRest(_b, [
    "children",
    "query"
  ]);
  const queryValue = getMediaQueryFromProps(otherProps, query);
  const matches = useMediaQuery(queryValue);
  return matches ? /* @__PURE__ */ React45.createElement("div", null, children) : null;
};
Responsive.displayName = "Responsive";

// src/components/popover/popover.tsx
import * as RadixPopoverPrimitive3 from "@radix-ui/react-popover";

// src/components/popover/popover-trigger.tsx
import React46, { forwardRef as forwardRef26 } from "react";
import * as RadixPopoverPrimitive from "@radix-ui/react-popover";
var DISPLAY_NAME24 = "PopoverTrigger";
var BaseTrigger = transformingStyled(RadixPopoverPrimitive.Trigger, {});
var PopoverTrigger = forwardRef26(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      hideLabel,
      icon,
      label,
      priority,
      quiet,
      size,
      "data-testid": testId = `GDS-${DISPLAY_NAME24}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "hideLabel",
      "icon",
      "label",
      "priority",
      "quiet",
      "size",
      "data-testid"
    ]);
    if (!label && !children)
      console.warn(
        "To show a Popover initiator, set the label on Popover.Trigger or provide a custom button element as a child of Popover.Trigger."
      );
    return /* @__PURE__ */ React46.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME24 }, /* @__PURE__ */ React46.createElement(
      BaseTrigger,
      {
        className: ["GDS-popover-trigger", className].join(" "),
        css: css2,
        ref,
        "data-testid": testId,
        asChild: true
      },
      label ? /* @__PURE__ */ React46.createElement(
        Button,
        __spreadValues({
          hideLabel,
          icon,
          priority,
          quiet,
          size
        }, props),
        label
      ) : children
    ));
  }
);

// src/components/popover/popover-content.tsx
import React47, { forwardRef as forwardRef27 } from "react";
import * as RadixPopoverPrimitive2 from "@radix-ui/react-popover";
var DISPLAY_NAME25 = "PopoverContent";
var BasePopoverContent = transformingStyled(RadixPopoverPrimitive2.Content, {
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary",
  borderRadius: "$medium",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  backgroundColor: "$surfaceBackgroundPrimary",
  boxShadow: "$dropdown",
  zIndex: "$tooltip",
  '&[class*="GDS"]:focus, &[class*="GDS"]:active': {
    boxShadow: "$dropdown",
    outline: "none",
    position: "initial"
  }
});
var getPhysicalSide = (dir, side) => {
  if (!side) {
    return side;
  }
  if (!(side === "inlineStart" || side === "inlineEnd")) {
    return side;
  }
  if (dir === "ltr") {
    if (side === "inlineStart") {
      return "left";
    }
    return "right";
  }
  if (side === "inlineStart") {
    return "right";
  }
  return "left";
};
var PopoverHeading = transformingStyled("div", {
  display: "flex",
  justifyContent: "flex-end",
  marginBlockEnd: "$one"
});
var PopoverContent = forwardRef27(
  (_a, ref) => {
    var _b = _a, {
      align,
      avoidCollisions,
      children,
      className,
      closeLabel,
      collisionPadding,
      css: css2,
      headingBar,
      padding = "$one",
      showCloseButton = true,
      side,
      sideOffset = 6,
      "data-testid": testId = `GDS-${DISPLAY_NAME25}`
    } = _b, props = __objRest(_b, [
      "align",
      "avoidCollisions",
      "children",
      "className",
      "closeLabel",
      "collisionPadding",
      "css",
      "headingBar",
      "padding",
      "showCloseButton",
      "side",
      "sideOffset",
      "data-testid"
    ]);
    const contentPadding = useResponsiveProp(padding);
    const responsiveSide = useResponsiveProp(side);
    const responsiveAlign = useResponsiveProp(align);
    const stringsMap = useThemeStrings();
    const dir = useTextDirectionality();
    const physicalSide = getPhysicalSide(dir || "ltr", responsiveSide);
    return /* @__PURE__ */ React47.createElement(Portal, null, /* @__PURE__ */ React47.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME25 }, /* @__PURE__ */ React47.createElement(
      BasePopoverContent,
      __spreadValues({
        className: ["GDS-popover-content", className].join(" "),
        align: responsiveAlign,
        avoidCollisions,
        collisionPadding,
        css: __spreadValues(__spreadValues({}, css2), padding && {
          padding: `${contentPadding}`
        }),
        ref,
        side: physicalSide,
        sideOffset,
        "data-testid": testId
      }, props),
      headingBar || showCloseButton && /* @__PURE__ */ React47.createElement(PopoverHeading, { className: "GDS-popover-heading-bar" }, /* @__PURE__ */ React47.createElement(RadixPopoverPrimitive2.Close, { asChild: true }, /* @__PURE__ */ React47.createElement(
        Button,
        {
          type: "button",
          icon: "tinyClose",
          hideLabel: true,
          quiet: true,
          priority: "secondary",
          size: "small",
          className: "GDS-popover-close",
          css: {
            color: "$interactiveActionSubdued",
            svg: {
              width: "$threeQuarters",
              height: "$threeQuarters"
            }
          }
        },
        closeLabel || stringsMap.close
      ))),
      children
    )));
  }
);

// src/components/popover/popover.tsx
var GDSPopoverPrimitive = RadixPopoverPrimitive3;
var PopoverClose = withClassName(
  RadixPopoverPrimitive3.Close,
  "GDS-close-button"
);
var Popover = {
  Root: RadixPopoverPrimitive3.Root,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Close: PopoverClose
};
Popover.Root.displayName = "Popover.Root";
Popover.Trigger.displayName = "Popover.Trigger";
Popover.Content.displayName = "Popover.Content";
Popover.Close.displayName = "Popover.Close";

// src/components/modal/modal.tsx
import React50 from "react";
import * as Dialog2 from "@radix-ui/react-dialog";

// src/components/modal/modal-content.tsx
import React49, { forwardRef as forwardRef28, useRef as useRef4 } from "react";
import * as Dialog from "@radix-ui/react-dialog";

// src/hooks/use-composed-ref.ts
import * as React48 from "react";
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return React48.useCallback(composeRefs(...refs), refs);
}

// src/components/modal/animations.ts
import { keyframes as keyframes4 } from "@stitches/react";
var transition = "$transitions$defaultTime ease-in-out";
var animations = {
  overlayShow: {
    "0%": { opacity: 0 },
    "100%": { opacity: 1 }
  },
  overlayClose: {
    "0%": { opacity: 1 },
    "100%": { opacity: 0 }
  },
  contentShow: {
    "0%": { opacity: 0, transform: "translate(-50%, -48%) scale(.96)" },
    "100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" }
  },
  contentClose: {
    "0%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
    "100%": { opacity: 0, transform: "translate(-50%, -48%) scale(.96)" }
  },
  leftOpen: {
    "0%": { transform: "translateX(-100%)" },
    "100%": { transform: "translateX(0)" }
  },
  leftClose: {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(-100%)" }
  },
  rightOpen: {
    "0%": { transform: "translateX(100%)" },
    "100%": { transform: "translateX(0)" }
  },
  rightClose: {
    "0%": { transform: "translateX(0)" },
    "100%": { transform: "translateX(100%)" }
  },
  inlineStartOpen: {
    "0%": {
      transform: "translateX(calc((var(--league-is-rtl) * 2 - 1) * 100%))"
    },
    "100%": { transform: "translateX(0)" }
  },
  inlineStartClose: {
    "0%": { transform: "translateX(0)" },
    "100%": {
      transform: "translateX(calc((var(--league-is-rtl) * 2 - 1) * 100%))"
    }
  },
  inlineEndOpen: {
    "0%": {
      transform: "translateX(calc((1 - var(--league-is-rtl) * 2) * 100%))"
    },
    "100%": { transform: "translateX(0)" }
  },
  inlineEndClose: {
    "0%": { transform: "translateX(0)" },
    "100%": {
      transform: "translateX(calc((1 - var(--league-is-rtl) * 2) * 100%))"
    }
  },
  bottomOpen: {
    "0%": { transform: "translateY(100%)" },
    "100%": { transform: "translateY(0)" }
  },
  bottomClose: {
    "0%": { transform: "translateY(0)" },
    "100%": { transform: "translateY(100%)" }
  }
};
var animate = (frames) => `${keyframes4(animations[frames])} ${transition}`;

// src/components/modal/modal-content.tsx
var applyModalAnimation = ({
  open,
  close
}) => ({
  animation: animate(open),
  "@media (prefers-reduced-motion)": { animation: "none" },
  '&[data-state="closed"]': {
    animation: animate(close),
    "@media (prefers-reduced-motion)": { animation: "none" }
  }
});
var DialogOverlay = transformingStyled(Dialog.Overlay, __spreadValues({
  backgroundColor: "rgba(136, 136, 136, 0.7)",
  position: "fixed",
  inset: 0,
  zIndex: "$modal"
}, applyModalAnimation({ open: "overlayShow", close: "overlayClose" })));
var distanceFromEdge = 40;
var DialogContainer = transformingStyled(Dialog.Content, {
  background: "$surfaceBackgroundPrimary",
  boxShadow: "$dropdown",
  position: "fixed",
  overflow: "auto",
  zIndex: "$modal",
  width: "33vw",
  "@tablet": { width: "66vw" },
  "@mobileLandscape": { width: "66vw" },
  "&:focus": { outline: "none !important" },
  variants: {
    layout: {
      standard: __spreadProps(__spreadValues({
        maxHeight: "100%",
        top: "50%",
        insetInlineStart: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "$large"
      }, applyModalAnimation({ open: "contentShow", close: "contentClose" })), {
        "@mobile": __spreadValues({
          transform: "unset",
          width: "100vw",
          margin: "0 auto",
          bottom: 0,
          top: "unset",
          insetInlineStart: 0,
          insetInlineEnd: 0,
          maxHeight: `calc(100% - ${distanceFromEdge}px)`,
          borderRadius: "$large $large 0 0"
        }, applyModalAnimation({ open: "bottomOpen", close: "bottomClose" }))
      }),
      fullscreen: __spreadProps(__spreadValues({
        bottom: 0,
        insetInlineStart: `${distanceFromEdge}px`,
        insetInlineEnd: `${distanceFromEdge}px`,
        width: `calc(100vw - ${distanceFromEdge * 2}px)`,
        height: `calc(100% - ${distanceFromEdge}px)`,
        borderRadius: "$large $large 0 0"
      }, applyModalAnimation({ open: "bottomOpen", close: "bottomClose" })), {
        "@mobile": {
          width: "100vw",
          insetInlineStart: 0,
          insetInlineEnd: 0,
          borderRadius: "$large $large 0 0"
        }
      }),
      left: __spreadProps(__spreadValues({
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: "0 $large $large 0"
      }, applyModalAnimation({ open: "leftOpen", close: "leftClose" })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      }),
      bottomLeft: __spreadProps(__spreadValues({
        height: "100%",
        bottom: `${distanceFromEdge}px`,
        left: `${distanceFromEdge}px`,
        borderRadius: "0 $large $large 0"
      }, applyModalAnimation({ open: "leftOpen", close: "leftClose" })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      }),
      right: __spreadProps(__spreadValues({
        height: "100%",
        top: 0,
        right: 0,
        left: "unset",
        borderRadius: "$large 0 0 $large"
      }, applyModalAnimation({ open: "rightOpen", close: "rightClose" })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      }),
      bottomRight: __spreadProps(__spreadValues({
        height: "100%",
        bottom: `${distanceFromEdge}px`,
        right: `${distanceFromEdge}px`,
        left: "unset",
        borderRadius: "0 $large $large 0"
      }, applyModalAnimation({ open: "rightOpen", close: "rightClose" })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      }),
      inlineStart: __spreadProps(__spreadValues({
        height: "100%",
        top: 0,
        insetInlineStart: 0,
        borderRadius: "0 $large $large 0"
      }, applyModalAnimation({
        open: "inlineStartOpen",
        close: "inlineStartClose"
      })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      }),
      inlineEnd: __spreadProps(__spreadValues({
        height: "100%",
        top: 0,
        insetInlineEnd: 0,
        insetInlineStart: "unset",
        borderRadius: "$large 0 0 $large"
      }, applyModalAnimation({
        open: "inlineEndOpen",
        close: "inlineEndClose"
      })), {
        "@mobile": {
          width: `calc(100vw - ${distanceFromEdge}px)`
        }
      })
    }
  }
});
var DialogContent = transformingStyled("div");
var ModalWrapper = transformingStyled("div");
var ModalContent = forwardRef28(
  (_a, ref) => {
    var _b = _a, {
      layout = "standard",
      padding = "$oneAndHalf",
      showCloseButton = true,
      forceModalFocus = true,
      onInteractOutside,
      width,
      className,
      children,
      css: css2,
      container
    } = _b, props = __objRest(_b, [
      "layout",
      "padding",
      "showCloseButton",
      "forceModalFocus",
      "onInteractOutside",
      "width",
      "className",
      "children",
      "css",
      "container"
    ]);
    const responsivePadding = useResponsiveProp(padding);
    const responsiveWidth = useResponsiveProp(width);
    const responsiveLayout = useResponsiveProp(layout);
    const strings = useThemeStrings();
    const internalRef = useRef4(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const hasDescription = React49.Children.toArray(children).some((child) => {
      if (React49.isValidElement(child) && typeof child.type !== "string") {
        const componentName = getComponentDisplayName(child);
        if (componentName === "Modal.Description") {
          return true;
        }
      }
      return false;
    });
    return /* @__PURE__ */ React49.createElement(Portal, { container }, /* @__PURE__ */ React49.createElement(ModalWrapper, { css: css2 }, /* @__PURE__ */ React49.createElement(DialogOverlay, { className: "GDS-modal-overlay", "data-testid": "overlay" }), /* @__PURE__ */ React49.createElement(GenesisCoreInspector, { displayName: "Modal" }, /* @__PURE__ */ React49.createElement(
      DialogContainer,
      __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
        className: ["GDS-modal", className].join(" ")
      }, forceModalFocus && {
        onOpenAutoFocus: (e) => {
          e.preventDefault();
          if (internalRef == null ? void 0 : internalRef.current)
            internalRef.current.focus();
        }
      }), width && {
        css: { width: responsiveWidth }
      }), !hasDescription && {
        "aria-describedby": void 0
      }), {
        onInteractOutside,
        layout: responsiveLayout,
        ref: composedRefs
      }), props),
      showCloseButton && /* @__PURE__ */ React49.createElement(
        StackLayout,
        {
          orientation: "horizontal",
          horizontalAlignment: "end",
          css: { padding: "$half $half $none $half" },
          className: "GDS-modal-close-button-wrapper"
        },
        /* @__PURE__ */ React49.createElement(Dialog.Close, { asChild: true }, /* @__PURE__ */ React49.createElement(
          Button,
          {
            priority: "tertiary",
            quiet: true,
            icon: "tinyClose",
            hideLabel: true,
            size: "small",
            className: "GDS-modal-close-button"
          },
          strings.close
        ))
      ),
      /* @__PURE__ */ React49.createElement(
        DialogContent,
        {
          className: "GDS-modal-content",
          css: { padding: responsivePadding }
        },
        children
      )
    ))));
  }
);

// src/components/modal/modal.tsx
var GDSModalPrimitive = Dialog2;
var ModalTrigger = ({ children }) => /* @__PURE__ */ React50.createElement(Dialog2.Trigger, { asChild: true, "aria-expanded": void 0, "aria-controls": void 0 }, children);
var ModalClose = ({ children }) => /* @__PURE__ */ React50.createElement(Dialog2.Close, { asChild: true }, children);
var ModalTitle = ({ children }) => /* @__PURE__ */ React50.createElement(Dialog2.Title, { asChild: true }, children);
var ModalDescription = ({ children }) => /* @__PURE__ */ React50.createElement(Dialog2.Description, { asChild: true }, children);
var Modal = {
  Root: Dialog2.Root,
  Trigger: ModalTrigger,
  Content: ModalContent,
  Close: ModalClose,
  Title: ModalTitle,
  Description: ModalDescription
};
Modal.Root.displayName = "Modal.Root";
Modal.Content.displayName = "Modal.Content";
Modal.Trigger.displayName = "Modal.Trigger";
Modal.Close.displayName = "Modal.Close";
Modal.Title.displayName = "Modal.Title";
Modal.Description.displayName = "Modal.Description";

// src/components/tooltip/tooltip.tsx
import React52, { forwardRef as forwardRef30 } from "react";
import * as RadixTooltipPrimitive3 from "@radix-ui/react-tooltip";

// src/components/tooltip/tooltip-content.tsx
import React51, { forwardRef as forwardRef29 } from "react";
import * as RadixTooltipPrimitive2 from "@radix-ui/react-tooltip";
var BaseTooltipContent = transformingStyled(RadixTooltipPrimitive2.Content, {
  typography: "$bodyTwo",
  color: "$onSurfaceTextPrimary",
  borderRadius: "$medium",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderSubdued",
  backgroundColor: "$surfaceBackgroundPrimary",
  boxShadow: "$dropdown",
  zIndex: "$tooltip",
  '&[class*="GDS"]:focus, &[class*="GDS"]:active': {
    boxShadow: "$dropdown",
    outline: "none",
    position: "initial"
  }
});
var getPhysicalSide2 = (dir, side) => {
  if (!side) {
    return side;
  }
  if (!(side === "inlineStart" || side === "inlineEnd")) {
    return side;
  }
  if (dir === "ltr") {
    if (side === "inlineStart") {
      return "left";
    }
    return "right";
  }
  if (side === "inlineStart") {
    return "right";
  }
  return "left";
};
var TooltipContent = forwardRef29(
  (_a, ref) => {
    var _b = _a, {
      align,
      avoidCollisions = true,
      children,
      className,
      collisionPadding,
      css: css2,
      padding = "$half",
      side,
      sideOffset = 6
    } = _b, props = __objRest(_b, [
      "align",
      "avoidCollisions",
      "children",
      "className",
      "collisionPadding",
      "css",
      "padding",
      "side",
      "sideOffset"
    ]);
    const contentPadding = useResponsiveProp(padding);
    const responsiveSide = useResponsiveProp(side);
    const responsiveAlign = useResponsiveProp(align);
    const dir = useTextDirectionality();
    const physicalSide = getPhysicalSide2(dir, responsiveSide);
    return /* @__PURE__ */ React51.createElement(Portal, null, /* @__PURE__ */ React51.createElement(
      BaseTooltipContent,
      __spreadValues({
        align: responsiveAlign,
        avoidCollisions,
        className: ["GDS-tooltip-content", className].join(" "),
        collisionPadding,
        css: __spreadValues(__spreadValues({}, css2), padding && {
          padding: `${contentPadding}`
        }),
        ref,
        side: physicalSide,
        sideOffset
      }, props),
      children
    ));
  }
);

// src/components/tooltip/tooltip.tsx
var GDSTooltipPrimitive = RadixTooltipPrimitive3;
var DISPLAY_NAME26 = "Tooltip";
var Tooltip = forwardRef30(
  (_a, ref) => {
    var _b = _a, {
      align,
      avoidCollisions,
      children,
      className,
      content,
      css: css2,
      defaultOpen,
      onOpenChange,
      open,
      padding,
      side,
      sideOffset,
      "data-testid": testId = `GDS-${DISPLAY_NAME26}`
    } = _b, props = __objRest(_b, [
      "align",
      "avoidCollisions",
      "children",
      "className",
      "content",
      "css",
      "defaultOpen",
      "onOpenChange",
      "open",
      "padding",
      "side",
      "sideOffset",
      "data-testid"
    ]);
    return /* @__PURE__ */ React52.createElement(
      RadixTooltipPrimitive3.Root,
      {
        open,
        defaultOpen,
        onOpenChange
      },
      /* @__PURE__ */ React52.createElement(GenesisCoreInspector, { displayName: "TooltipTrigger" }, /* @__PURE__ */ React52.createElement(RadixTooltipPrimitive3.Trigger, { asChild: true, className: "GDS-tooltip-trigger" }, children)),
      /* @__PURE__ */ React52.createElement(GenesisCoreInspector, { displayName: "TooltipContent" }, /* @__PURE__ */ React52.createElement(
        TooltipContent,
        __spreadValues({
          align,
          avoidCollisions,
          className,
          css: css2,
          padding,
          ref,
          side,
          sideOffset,
          "data-testid": testId
        }, props),
        content
      ))
    );
  }
);
Tooltip.displayName = DISPLAY_NAME26;

// src/components/tabs/tabs.tsx
import * as RadixTabsPrimitive5 from "@radix-ui/react-tabs";

// src/components/tabs/tabs-root.tsx
import React53 from "react";
import * as RadixTabsPrimitive from "@radix-ui/react-tabs";
var DISPLAY_NAME27 = "Tabs";
var BaseTabsRoot = transformingStyled(RadixTabsPrimitive.Root, {
  width: "100%"
});
var TabsRoot = (_a) => {
  var _b = _a, {
    activationMode = "manual",
    children,
    className,
    css: css2,
    defaultValue,
    onValueChange,
    value,
    "data-testid": testId = `GDS-${DISPLAY_NAME27}`
  } = _b, props = __objRest(_b, [
    "activationMode",
    "children",
    "className",
    "css",
    "defaultValue",
    "onValueChange",
    "value",
    "data-testid"
  ]);
  return /* @__PURE__ */ React53.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME27 }, /* @__PURE__ */ React53.createElement(
    BaseTabsRoot,
    __spreadValues({
      activationMode,
      className: [`GDS-tabs`, className].join(" "),
      css: css2,
      defaultValue,
      onValueChange,
      value,
      "data-testid": testId
    }, props),
    children
  ));
};

// src/components/tabs/tab-list.tsx
import React56, { forwardRef as forwardRef32 } from "react";
import * as RadixTabsPrimitive2 from "@radix-ui/react-tabs";

// src/components/tabs/use-tabs-scroll.tsx
import { useRef as useRef5, useEffect as useEffect6, useState as useState7, useCallback as useCallback5 } from "react";
import { throttle } from "lodash";
var useTabsScroll = () => {
  var _a;
  const [isScrolledStart, setIsScrolledStart] = useState7(true);
  const [isScrolledEnd, setIsScrolledEnd] = useState7(false);
  const [hasOverflow, setHasOverflow] = useState7(false);
  const tabsList = useRef5(null);
  const listWidth = (_a = tabsList.current) == null ? void 0 : _a.offsetWidth;
  const scrollAmount = listWidth ? listWidth / 2 : 0;
  const showScrollBack = !isScrolledStart && hasOverflow;
  const showScrollForward = !isScrolledEnd && hasOverflow;
  const dir = useTextDirectionality();
  const scrollBack = useCallback5(() => {
    if (tabsList.current) {
      if (dir === "ltr") {
        tabsList.current.scrollLeft -= scrollAmount;
      } else {
        tabsList.current.scrollLeft += scrollAmount;
      }
    }
  }, [scrollAmount, dir]);
  const scrollForward = useCallback5(() => {
    if (tabsList.current) {
      if (dir === "ltr") {
        tabsList.current.scrollLeft += scrollAmount;
      } else {
        tabsList.current.scrollLeft -= scrollAmount;
      }
    }
  }, [scrollAmount, dir]);
  const showHideControls = () => {
    if (tabsList.current && Math.abs(tabsList.current.scrollLeft) < 1) {
      setIsScrolledStart(true);
    } else {
      setIsScrolledStart(false);
    }
    if (tabsList.current && Math.ceil(Math.abs(tabsList.current.scrollLeft)) >= tabsList.current.scrollWidth - tabsList.current.offsetWidth) {
      setIsScrolledEnd(true);
    } else {
      setIsScrolledEnd(false);
    }
  };
  const showControlsOnOverflow = () => {
    const { innerWidth } = window;
    let offsetWidth = 0;
    let scrollWidth = 0;
    if (tabsList.current) {
      offsetWidth = tabsList.current.offsetWidth;
      scrollWidth = tabsList.current.scrollWidth;
    }
    return scrollWidth > offsetWidth || scrollWidth > innerWidth ? setHasOverflow(true) : setHasOverflow(false);
  };
  useEffect6(() => {
    const currentRef = tabsList == null ? void 0 : tabsList.current;
    const onScroll = throttle(() => {
      showHideControls();
    }, 500);
    const onResize = throttle(() => {
      showControlsOnOverflow();
    }, 500);
    currentRef == null ? void 0 : currentRef.addEventListener("scroll", onScroll);
    showControlsOnOverflow();
    window.addEventListener("resize", onResize);
    return () => {
      currentRef == null ? void 0 : currentRef.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      setHasOverflow(false);
      setIsScrolledEnd(false);
      setIsScrolledStart(true);
    };
  }, [tabsList]);
  return {
    scrollBack,
    scrollForward,
    tabsList,
    showScrollBack,
    showScrollForward
  };
};

// src/components/tabs/scroll-buttons.tsx
import React54, { forwardRef as forwardRef31 } from "react";
var ScrollableWrapper = transformingStyled("div", {
  position: "relative",
  maxWidth: "100%"
});
var ScrollableItemsWrapper = transformingStyled("div");
var ButtonWrapper = transformingStyled("div", {
  backgroundColor: "$surfaceBackgroundPrimary",
  position: "absolute",
  top: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
var ScrollBack = forwardRef31(
  ({ onClick }, ref) => {
    const strings = useThemeStrings();
    return /* @__PURE__ */ React54.createElement(ButtonWrapper, { css: { insetInlineStart: 0 } }, /* @__PURE__ */ React54.createElement(
      Button,
      {
        className: "GDS-scroll-button GDS-scroll-back-button GDS-scroll-left-button",
        size: "small",
        icon: "interfaceChevronBack",
        priority: "tertiary",
        hideLabel: true,
        onClick,
        ref
      },
      strings.previous
    ));
  }
);
var ScrollForward = forwardRef31(({ onClick }, ref) => {
  const strings = useThemeStrings();
  return /* @__PURE__ */ React54.createElement(ButtonWrapper, { css: { insetInlineEnd: 0 } }, /* @__PURE__ */ React54.createElement(
    Button,
    {
      className: "GDS-scroll-button GDS-scroll-forward-button GDS-scroll-right-button",
      size: "small",
      icon: "interfaceChevronForward",
      priority: "tertiary",
      hideLabel: true,
      onClick,
      ref
    },
    strings.next
  ));
});

// src/components/tabs/tablist-context.tsx
import React55, { createContext as createContext3, useContext as useContext3 } from "react";
var TabListContext = createContext3(null);
var useTablistContext = () => {
  const tabListContext = useContext3(TabListContext);
  if (!tabListContext) {
    throw new Error(
      "tabListContext has to be used within <TabListContext.Provider>"
    );
  }
  return tabListContext;
};
var TabListContextProvider = ({ tabListElements, children }) => /* @__PURE__ */ React55.createElement(TabListContext.Provider, { value: tabListElements }, children);

// src/components/tabs/tab-list.tsx
var DISPLAY_NAME28 = "TabList";
var BaseTablist = transformingStyled(RadixTabsPrimitive2.List, {
  display: "flex",
  gap: "$half",
  overflowX: "auto",
  scrollBehavior: "smooth",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
    width: "0px",
    background: "transparent"
  },
  variants: {
    tabDistribution: {
      distributeEvenly: {
        justifyContent: "stretch",
        "> .GDS-tab": {
          flex: "1 0 auto"
        }
      },
      hugContents: {
        justifyContent: "flex-start"
      }
    }
  }
});
var TabList = forwardRef32(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      divider,
      loop = false,
      tabDistribution = "distributeEvenly",
      "data-testid": testId = `GDS-${DISPLAY_NAME28}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "divider",
      "loop",
      "tabDistribution",
      "data-testid"
    ]);
    const responsiveTabDistribution = useResponsiveProp(tabDistribution);
    const responsiveDivider = useResponsiveProp(divider);
    const {
      scrollBack,
      scrollForward,
      tabsList,
      showScrollBack,
      showScrollForward
    } = useTabsScroll();
    const composedRefs = useComposedRefs(
      ref,
      tabsList
    );
    const tabListWrapperRef = React56.useRef(null);
    const scrollBackButtonRef = React56.useRef(null);
    const scrollForwardButtonRef = React56.useRef(null);
    const tabListElements = {
      tabListWrapper: tabListWrapperRef.current,
      scrollBackButton: scrollBackButtonRef.current,
      scrollForwardButton: scrollForwardButtonRef.current
    };
    return /* @__PURE__ */ React56.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME28 }, /* @__PURE__ */ React56.createElement(TabListContextProvider, { tabListElements }, /* @__PURE__ */ React56.createElement(Box, { css: css2 }, /* @__PURE__ */ React56.createElement(ScrollableWrapper, null, showScrollBack && /* @__PURE__ */ React56.createElement(
      ScrollBack,
      {
        ref: scrollBackButtonRef,
        onClick: () => scrollBack()
      }
    ), /* @__PURE__ */ React56.createElement(
      ScrollableItemsWrapper,
      {
        className: "GDS-tab-list-wrapper",
        ref: tabListWrapperRef,
        css: __spreadValues({}, responsiveDivider && {
          borderBlockEnd: "$borderWidths$thin solid $onSurfaceBorderSubdued"
        })
      },
      /* @__PURE__ */ React56.createElement(
        BaseTablist,
        __spreadValues({
          ref: composedRefs,
          className: [`GDS-tab-list`, className].join(" "),
          tabDistribution: responsiveTabDistribution,
          loop,
          "data-testid": testId
        }, props),
        children
      )
    ), showScrollForward && /* @__PURE__ */ React56.createElement(
      ScrollForward,
      {
        ref: scrollForwardButtonRef,
        onClick: () => scrollForward()
      }
    )))));
  }
);

// src/components/tabs/tab.tsx
import React57, { forwardRef as forwardRef33, useRef as useRef6, useMemo as useMemo4 } from "react";
import * as RadixTabsPrimitive3 from "@radix-ui/react-tabs";

// src/components/tabs/use-tab-element-is-in-view.tsx
var useTabElementIsInView = () => {
  const { tabListWrapper, scrollBackButton, scrollForwardButton } = useTablistContext();
  const tabScrollOptions = {
    behavior: "smooth",
    block: "nearest",
    inline: "center"
  };
  const dir = useTextDirectionality();
  const elementIsInView = (tabElement) => {
    var _a;
    if (!tabListWrapper || !tabElement.current) {
      return false;
    }
    const leftEdge = tabListWrapper.getBoundingClientRect();
    const scrollButtonWidth = ((_a = scrollBackButton || scrollForwardButton) == null ? void 0 : _a.getBoundingClientRect().width) || 0;
    const leftOffset = leftEdge.left + (scrollBackButton ? scrollButtonWidth : 0);
    const rightOffset = leftEdge.right - (scrollForwardButton ? scrollButtonWidth : 0);
    const { left, right } = tabElement.current.getBoundingClientRect();
    if (dir === "rtl") {
      return right <= rightOffset && left >= leftEdge.left;
    }
    return left >= leftOffset && right <= rightOffset;
  };
  return {
    elementIsInView,
    tabScrollOptions
  };
};

// src/components/tabs/tab.tsx
var DISPLAY_NAME29 = "Tab";
var tabStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "$onSurfaceTextSubdued",
  padding: "$threeQuarters $half",
  border: "none",
  borderBottomStyle: "solid",
  borderBottomColor: "transparent",
  borderBottomWidth: "$borderWidths$thick",
  backgroundColor: "$surfaceBackgroundPrimary",
  cursor: "pointer",
  '&[aria-current="page"], &[data-state="active"], &.active': {
    color: "$interactiveActionPrimary",
    borderBottomColor: "$interactiveActionPrimary"
  },
  "&:hover": {
    color: "$interactiveActionHovered"
  },
  '&[class*="GDS"]:focus': {
    outlineOffset: "-$space$half"
  },
  typography: "$buttonTwo"
};
var BaseTab = transformingStyled(RadixTabsPrimitive3.Trigger, __spreadValues({}, tabStyles));
var TabIconLabelWrapper = transformingStyled("span", {
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "$half"
});
var Tab = forwardRef33(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      icon,
      iconLabel,
      width,
      "data-testid": testId = `GDS-${DISPLAY_NAME29}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "icon",
      "iconLabel",
      "width",
      "data-testid"
    ]);
    const internalRef = useRef6(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const tabWidth = useResponsiveProp(width);
    const tabIcon = useResponsiveProp(icon);
    const { elementIsInView, tabScrollOptions } = useTabElementIsInView();
    const { scrollBackButton, scrollForwardButton } = useTablistContext();
    const scrollElementIfNotInView = useMemo4(
      () => () => {
        if (!elementIsInView(internalRef) && (scrollBackButton || scrollForwardButton)) {
          internalRef.current.scrollIntoView(tabScrollOptions);
        }
      },
      [
        elementIsInView,
        tabScrollOptions,
        scrollBackButton,
        scrollForwardButton
      ]
    );
    return /* @__PURE__ */ React57.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME29 }, /* @__PURE__ */ React57.createElement(
      BaseTab,
      __spreadValues({
        className: [`GDS-tab`, className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), width && {
          width: `${tabWidth}`
        }),
        ref: composedRefs,
        onFocus: () => scrollElementIfNotInView(),
        "data-testid": testId
      }, props),
      /* @__PURE__ */ React57.createElement(TabIconLabelWrapper, null, tabIcon && /* @__PURE__ */ React57.createElement(Icon, { icon: tabIcon, label: iconLabel }), children)
    ));
  }
);

// src/components/tabs/tab-panel.tsx
import React58, { forwardRef as forwardRef34 } from "react";
import * as RadixTabsPrimitive4 from "@radix-ui/react-tabs";
var DISPLAY_NAME30 = "TabPanel";
var BaseTabpanel = transformingStyled(RadixTabsPrimitive4.Content, {
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary",
  padding: "$threeQuarters $half",
  '&:focus, &[class*="GDS"]:focus': {
    boxShadow: "none",
    outline: "none"
  },
  '&[class*="GDS"]:focus-visible, &:focus-visible': __spreadValues({}, focusOutlineInner)
});
var TabPanel = forwardRef34(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      value,
      "data-testid": testId = `GDS-${DISPLAY_NAME30}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "value",
      "data-testid"
    ]);
    return /* @__PURE__ */ React58.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME30 }, /* @__PURE__ */ React58.createElement(
      BaseTabpanel,
      __spreadValues({
        className: [`GDS-tab-panel`, className].join(" "),
        value,
        css: css2,
        ref,
        "data-testid": testId
      }, props),
      children
    ));
  }
);

// src/components/tabs/tabs.tsx
var GDSTabsPrimitive = RadixTabsPrimitive5;
var Tabs = {
  Root: TabsRoot,
  Tab,
  TabList,
  TabPanel
};
Tabs.Root.displayName = "Tabs.Root";
Tabs.Tab.displayName = "Tabs.Tab";
Tabs.TabList.displayName = "Tabs.TabList";
Tabs.TabPanel.displayName = "Tabs.TabPanel";

// src/components/scrollable/scrollable.tsx
import React59, { forwardRef as forwardRef35 } from "react";
var DISPLAY_NAME31 = "Scrollable";
var ScrollableWrapper2 = transformingStyled("div", {
  overflow: "hidden",
  '&:focus, &[class*="GDS"]:focus': {
    boxShadow: "none",
    outline: "none"
  },
  '&:focus-visible, &[class*="GDS"]:focus-visible': __spreadValues({}, focusOutlineOuter),
  variants: {
    orientation: {
      vertical: {
        overflowY: "auto"
      },
      horizontal: {
        overflowX: "auto"
      }
    }
  }
});
var Scrollable = forwardRef35(
  (_a, ref) => {
    var _b = _a, {
      children,
      orientation = "vertical",
      css: css2,
      width,
      height,
      className,
      "data-testid": testId = `GDS-${DISPLAY_NAME31}`
    } = _b, props = __objRest(_b, [
      "children",
      "orientation",
      "css",
      "width",
      "height",
      "className",
      "data-testid"
    ]);
    const responsiveOrientation = useResponsiveProp(orientation);
    const responsiveHeight = useResponsiveProp(height);
    const responsiveWidth = useResponsiveProp(width);
    return /* @__PURE__ */ React59.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME31 }, /* @__PURE__ */ React59.createElement(
      ScrollableWrapper2,
      __spreadValues({
        className: ["GDS-scrollable", className].join(" "),
        ref,
        css: __spreadValues(__spreadValues(__spreadValues({}, css2), width && { width: `${responsiveWidth}` }), height && { height: `${responsiveHeight}` }),
        orientation: responsiveOrientation,
        tabIndex: 0,
        "data-testid": testId
      }, props),
      children
    ));
  }
);
Scrollable.displayName = DISPLAY_NAME31;

// src/components/nav-list/nav-list.tsx
import React62, { forwardRef as forwardRef38 } from "react";

// src/components/nav-list/nav-link.tsx
import React60, {
  forwardRef as forwardRef36,
  useRef as useRef7,
  useMemo as useMemo5
} from "react";
var DISPLAY_NAME32 = "NavItem";
var BaseNavLink = transformingStyled("a", __spreadValues({}, tabStyles));
var NavItem = transformingStyled("li", {
  listStyle: "none"
});
var Link = forwardRef36(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      href,
      icon,
      iconLabel,
      target,
      width,
      "data-testid": testId = `GDS-${DISPLAY_NAME32}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "href",
      "icon",
      "iconLabel",
      "target",
      "width",
      "data-testid"
    ]);
    const internalRef = useRef7(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const tabWidth = useResponsiveProp(width);
    const tabIcon = useResponsiveProp(icon);
    const { elementIsInView, tabScrollOptions } = useTabElementIsInView();
    const { scrollBackButton, scrollForwardButton } = useTablistContext();
    const scrollElementIfNotInView = useMemo5(
      () => () => {
        if (!elementIsInView(internalRef) && (scrollBackButton || scrollForwardButton)) {
          internalRef.current.scrollIntoView(tabScrollOptions);
        }
      },
      [
        elementIsInView,
        tabScrollOptions,
        scrollBackButton,
        scrollForwardButton
      ]
    );
    return /* @__PURE__ */ React60.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME32 }, /* @__PURE__ */ React60.createElement(
      NavItem,
      {
        className: [`GDS-nav-item`, className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), width && {
          width: `${tabWidth}`
        }),
        "data-testid": testId
      },
      /* @__PURE__ */ React60.createElement(
        BaseNavLink,
        __spreadValues({
          className: "GDS-nav-link",
          href,
          target,
          ref: composedRefs,
          onFocus: () => scrollElementIfNotInView()
        }, props),
        /* @__PURE__ */ React60.createElement(TabIconLabelWrapper, null, tabIcon && /* @__PURE__ */ React60.createElement(Icon, { icon: tabIcon, label: iconLabel }), children)
      )
    ));
  }
);

// src/components/nav-list/router-link.tsx
import React61, { forwardRef as forwardRef37, useRef as useRef8, useMemo as useMemo6 } from "react";
import { NavLink } from "@leagueplatform/routing";
var DISPLAY_NAME33 = "RouterLink";
var BaseRouterLink = transformingStyled(NavLink, __spreadValues({}, tabStyles));
var RouterLink = forwardRef37(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      icon,
      iconLabel,
      id,
      path,
      width,
      "data-testid": testId = `GDS-${DISPLAY_NAME33}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "icon",
      "iconLabel",
      "id",
      "path",
      "width",
      "data-testid"
    ]);
    const internalRef = useRef8(null);
    const composedRefs = useComposedRefs(ref, internalRef);
    const tabWidth = useResponsiveProp(width);
    const tabIcon = useResponsiveProp(icon);
    const { elementIsInView, tabScrollOptions } = useTabElementIsInView();
    const { scrollBackButton, scrollForwardButton } = useTablistContext();
    const scrollElementIfNotInView = useMemo6(
      () => () => {
        if (!elementIsInView(internalRef) && (scrollBackButton || scrollForwardButton)) {
          internalRef.current.scrollIntoView(tabScrollOptions);
        }
      },
      [
        elementIsInView,
        tabScrollOptions,
        scrollBackButton,
        scrollForwardButton
      ]
    );
    return /* @__PURE__ */ React61.createElement(
      NavItem,
      {
        className: [`GDS-nav-item`, className].join(" "),
        css: __spreadValues(__spreadValues({}, css2), width && {
          width: `${tabWidth}`
        }),
        "data-testid": testId
      },
      /* @__PURE__ */ React61.createElement(
        BaseRouterLink,
        __spreadValues({
          className: "GDS-nav-router-link",
          id,
          to: path,
          ref: composedRefs,
          onFocus: () => scrollElementIfNotInView()
        }, props),
        /* @__PURE__ */ React61.createElement(TabIconLabelWrapper, null, tabIcon && /* @__PURE__ */ React61.createElement(Icon, { icon: tabIcon, label: iconLabel }), children)
      )
    );
  }
);

// src/components/nav-list/nav-list.tsx
var DISPLAY_NAME34 = "NavList";
var BaseNav = transformingStyled("nav", {
  overflowX: "auto",
  scrollBehavior: "smooth",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
    width: "0px",
    background: "transparent"
  }
});
var BaseNavList = transformingStyled("ul", {
  display: "flex",
  gap: "$half",
  margin: 0,
  padding: 0,
  variants: {
    tabDistribution: {
      distributeEvenly: {
        justifyContent: "stretch",
        "> .GDS-nav-item": {
          flex: "1 0 auto"
        }
      },
      hugContents: {
        justifyContent: "flex-start"
      }
    }
  }
});
var List2 = forwardRef38(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      divider,
      tabDistribution = "distributeEvenly",
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "data-testid": testId = `GDS-${DISPLAY_NAME34}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "divider",
      "tabDistribution",
      "aria-label",
      "aria-labelledby",
      "data-testid"
    ]);
    const responsiveTabDistribution = useResponsiveProp(tabDistribution);
    const responsiveDivider = useResponsiveProp(divider);
    const {
      scrollBack,
      scrollForward,
      tabsList,
      showScrollBack,
      showScrollForward
    } = useTabsScroll();
    const composedRefs = useComposedRefs(
      ref,
      tabsList
    );
    const tabListWrapperRef = React62.useRef(null);
    const scrollBackButtonRef = React62.useRef(null);
    const scrollForwardButtonRef = React62.useRef(null);
    const tabListElements = {
      tabListWrapper: tabListWrapperRef.current,
      scrollBackButton: scrollBackButtonRef.current,
      scrollForwardButton: scrollForwardButtonRef.current
    };
    return /* @__PURE__ */ React62.createElement(TabListContextProvider, { tabListElements }, /* @__PURE__ */ React62.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME34 }, /* @__PURE__ */ React62.createElement(ScrollableWrapper, { "data-testid": testId }, showScrollBack && /* @__PURE__ */ React62.createElement(
      ScrollBack,
      {
        ref: scrollBackButtonRef,
        onClick: () => scrollBack()
      }
    ), /* @__PURE__ */ React62.createElement(
      ScrollableItemsWrapper,
      {
        ref: tabListWrapperRef,
        className: "GDS-nav-list-wrapper"
      },
      /* @__PURE__ */ React62.createElement(
        BaseNav,
        {
          className: "GDS-nav",
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          ref: composedRefs
        },
        /* @__PURE__ */ React62.createElement(
          BaseNavList,
          __spreadValues({
            className: [`GDS-nav-list`, className].join(" "),
            tabDistribution: responsiveTabDistribution,
            tabIndex: 0,
            css: __spreadValues(__spreadValues({}, css2), responsiveDivider && {
              borderBlockEnd: "$borderWidths$thin solid $onSurfaceBorderSubdued"
            })
          }, props),
          children
        )
      )
    ), showScrollForward && /* @__PURE__ */ React62.createElement(
      ScrollForward,
      {
        ref: scrollForwardButtonRef,
        onClick: () => scrollForward()
      }
    ))));
  }
);
var NavList = {
  List: List2,
  Link,
  RouterLink
};
NavList.List.displayName = "NavList.List";
NavList.Link.displayName = "NavList.Link";
NavList.RouterLink.displayName = "NavList.RouterLink";

// src/components/forms/base-input/base-input.tsx
import React66, { forwardRef as forwardRef40 } from "react";

// src/components/forms/input-elements/add-on.tsx
import React63, { forwardRef as forwardRef39 } from "react";
var StyledAddOn = transformingStyled("div", {
  typography: "$bodyTwo",
  color: "$onSurfaceTextPrimary",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingBlockStart: "$half",
  paddingBlockEnd: "$half",
  backgroundColor: "$surfaceBackgroundSecondary",
  border: "$borderWidths$thin solid $inputBorderDefault",
  variants: {
    position: {
      start: {
        borderStartStartRadius: "$medium",
        borderEndStartRadius: "$medium",
        borderInlineEnd: "none",
        paddingInlineStart: "$threeQuarters",
        paddingInlineEnd: "$half"
      },
      end: {
        borderStartEndRadius: "$medium",
        borderEndEndRadius: "$medium",
        borderInlineStart: "none",
        paddingInlineStart: "$half",
        paddingInlineEnd: "$threeQuarters"
      }
    }
  }
});
var addonPositionByString = {
  start: "Start",
  end: "End"
};
var getStringForClassName = (position) => addonPositionByString[position];
var AddOn = forwardRef39(
  (_a, ref) => {
    var _b = _a, { position, icon, iconLabel, children, css: css2 } = _b, props = __objRest(_b, ["position", "icon", "iconLabel", "children", "css"]);
    return /* @__PURE__ */ React63.createElement(
      StyledAddOn,
      __spreadValues({
        className: `GDS-input-add-on GDS-input-addon-${getStringForClassName(
          position
        )}`,
        position,
        css: css2,
        ref
      }, props),
      icon ? /* @__PURE__ */ React63.createElement(Icon, { icon, label: iconLabel }) : children
    );
  }
);

// src/components/forms/input-elements/affix-content.tsx
import React64 from "react";
var AffixWrapper = transformingStyled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  typography: "$bodyTwo",
  marginBlockEnd: "0",
  color: "$onSurfaceTextPrimary",
  maxHeight: "19px"
});
var AffixContent = (_a) => {
  var _b = _a, {
    position,
    children,
    className,
    css: css2
  } = _b, props = __objRest(_b, [
    "position",
    "children",
    "className",
    "css"
  ]);
  return /* @__PURE__ */ React64.createElement(
    AffixWrapper,
    __spreadValues({
      className: [
        "GDS-affix-wrapper",
        `GDS-affix-${position}-content`,
        className
      ].join(" "),
      css: __spreadValues(__spreadValues({}, position === "leading" ? { paddingInlineEnd: "$half" } : { paddingInlineStart: "$half" }), css2)
    }, props),
    typeof children === "string" ? /* @__PURE__ */ React64.createElement("span", null, children) : children
  );
};

// src/components/forms/input-elements/input-elements.tsx
var InputElements = {
  AddOn,
  AffixContent
};
InputElements.AffixContent.displayName = "InputElements.AffixContent";
InputElements.AddOn.displayName = "InputElements.AddOn";

// src/components/forms/input-styles.ts
var inputBorderStyles = {
  border: "$borderWidths$thin solid $interactiveBorderDefault",
  borderStartStartRadius: "$medium",
  borderEndStartRadius: "$medium",
  borderStartEndRadius: "$medium",
  borderEndEndRadius: "$medium"
};
var inputStyles = __spreadProps(__spreadValues({}, inputBorderStyles), {
  padding: "$threeQuarters $one",
  flex: "1 0 auto",
  '&:focus, &[class*="GDS"]:focus': __spreadValues({
    borderColor: "$interactiveFocusInner"
  }, focusOutlineInner)
});
var affixedStyles = {
  "&.GDS-affixed": __spreadProps(__spreadValues({}, inputStyles), {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "$inputBackgroundDefault",
    "&:hover:not(:focus-within):not(:focus)": {
      borderColor: "$inputBorderHovered",
      backgroundColor: "$inputBackgroundHovered",
      input: {
        borderColor: "$inputBorderHovered",
        backgroundColor: "$inputBackgroundHovered"
      }
    },
    input: {
      border: "none",
      padding: "0"
    },
    '[class*="GDS"]:not(button):focus, &:focus-within:has(button:focus)': {
      outline: "none",
      boxShadow: "none",
      borderColor: "$interactiveBorderDefault"
    },
    "&:focus-within": __spreadValues({
      borderColor: "$interactiveFocusInner"
    }, focusOutlineInner),
    // override nested .GDS-affixed styles when BaseInput is rendered within TextInput or any other wrapper that uses .GDS-affixed styles
    "& .GDS-affixed-base": {
      border: "none",
      padding: "0",
      input: {
        "&:focus, &:focus-within": {
          outline: "none",
          boxShadow: "none"
        }
      },
      "&:focus-within, &:focus": {
        borderColor: "$interactiveFocusInner",
        outline: "none",
        boxShadow: "none"
      }
    }
  })
};
var affixedBaseInputStyles = {
  "&.GDS-affixed-base": __spreadProps(__spreadValues({}, inputStyles), {
    "&:hover:not(:focus-within):not(:focus)": {
      borderColor: "$inputBorderHovered",
      backgroundColor: "$inputBackgroundHovered",
      input: {
        borderColor: "$inputBorderHovered",
        backgroundColor: "$inputBackgroundHovered"
      }
    },
    input: {
      border: "none",
      padding: "0"
    },
    '[class*="GDS"]:not(button):focus': {
      outline: "none",
      boxShadow: "none"
    },
    "&:focus-within": __spreadProps(__spreadValues({
      borderColor: "$interactiveFocusInner"
    }, focusOutlineInner), {
      input: {
        "&:hover": {
          backgroundColor: "$inputBackgroundDefault"
        }
      }
    }),
    "&:focus-within:has(button:focus)": {
      outline: "none",
      boxShadow: "none"
    }
  })
};
var disabledInputStyles = {
  backgroundColor: "$inputBackgroundDisabled",
  color: "$onSurfaceTextSubdued",
  borderColor: "$onSurfaceTextSubdued"
};
var readOnlyInputStyles = {
  backgroundColor: "$inputBackgroundDisabled"
};

// src/components/forms/base-input/get-react-version.ts
import * as React65 from "react";
var getReactVersion = () => React65.version;

// src/components/forms/base-input/base-input.tsx
var Input = transformingStyled("input", __spreadProps(__spreadValues({}, inputStyles), {
  typography: "$bodyTwo",
  color: "$onSurfaceTextPrimary",
  backgroundColor: "$inputBackgroundDefault",
  transition: "box-shadow $default ease-in-out",
  flex: 1,
  "&:focus": {
    borderColor: "$interactiveFocusInner"
  },
  "&:placeholder": {
    typography: "$bodyTwo",
    color: "$onSurfaceTextSubdued"
  },
  "&:hover:not(:focus):not([disabled])": {
    borderColor: "$inputBorderHovered",
    backgroundColor: "$inputBackgroundHovered"
  },
  '&:read-only, &[aria-readonly="true"]': __spreadValues({}, readOnlyInputStyles),
  '&:disabled, &[aria-disabled="true"]': __spreadValues({}, disabledInputStyles),
  variants: {
    inputStatus: {
      success: {
        borderColor: "$inputBorderSuccess",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderSuccess"
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderWarning"
        }
      },
      error: {
        borderColor: "$inputBorderCritical",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderCritical"
        }
      }
    }
  }
}));
var BaseInputWrapper = transformingStyled("div", __spreadProps(__spreadValues({
  position: "relative",
  display: "inline-flex",
  alignItems: "stretch",
  width: "100%"
}, affixedBaseInputStyles), {
  "&.GDS-readonly-input": __spreadValues({}, readOnlyInputStyles),
  "&.GDS-disabled-input": __spreadValues({}, disabledInputStyles),
  ".GDS-clear-input-button": {
    border: "none",
    backgroundColor: "$inputBackgroundDefault"
  },
  '[class*="GDS"]:focus': __spreadValues({}, focusOutlineInner),
  "&:hover": {
    ".GDS-clear-input-button": {
      color: "$secondaryTextDefault",
      backgroundColor: "$inputBackgroundHovered"
    }
  }
}));
var getEnterKeyHintProp = (enterKeyHint) => {
  const reactVersion = parseFloat(getReactVersion());
  const enterKeyPropertyName = reactVersion >= 17 ? "enterKeyHint" : "enterkeyhint";
  return { [enterKeyPropertyName]: enterKeyHint };
};
var BaseInput = forwardRef40(
  (_a, ref) => {
    var _b = _a, {
      as: asElement,
      css: css2,
      id,
      name,
      autoComplete,
      required,
      type = "text",
      placeholder,
      inputStatus,
      disabled,
      "aria-disabled": ariaDisabled,
      value,
      ariaDescribedby,
      clearable,
      clearLabel,
      onClear,
      onClick,
      onChange,
      onBlur,
      onFocus,
      readOnly,
      maxLength,
      className,
      enterKeyHint
    } = _b, props = __objRest(_b, [
      "as",
      "css",
      "id",
      "name",
      "autoComplete",
      "required",
      "type",
      "placeholder",
      "inputStatus",
      "disabled",
      "aria-disabled",
      "value",
      "ariaDescribedby",
      "clearable",
      "clearLabel",
      "onClear",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "readOnly",
      "maxLength",
      "className",
      "enterKeyHint"
    ]);
    const stringsMap = useThemeStrings();
    const defaultType = !type && !asElement ? "text" : void 0;
    const enterKeyHintProp = getEnterKeyHintProp(enterKeyHint);
    return /* @__PURE__ */ React66.createElement(GenesisCoreInspector, { displayName: "BaseInput" }, /* @__PURE__ */ React66.createElement(
      BaseInputWrapper,
      {
        className: `GDS-base-input-wrapper
        ${clearable ? "GDS-affixed-base" : ""}
        ${disabled && clearable ? "GDS-disabled-input" : ""}
        ${readOnly && clearable ? "GDS-readonly-input" : ""}
        ${inputStatus && clearable ? `GDS-input-status-${inputStatus}` : ""}
        `,
        css: css2
      },
      /* @__PURE__ */ React66.createElement(
        Input,
        __spreadValues(__spreadValues(__spreadProps(__spreadValues({
          as: asElement,
          id,
          name,
          type: type || defaultType,
          className: `GDS-base-input ${className || ""}`,
          placeholder,
          required,
          readOnly,
          disabled,
          "aria-disabled": ariaDisabled,
          autoComplete,
          value
        }, inputStatus === "error" && { "aria-invalid": true }), {
          "aria-describedby": ariaDescribedby,
          inputStatus,
          onClick,
          onChange,
          onBlur,
          onFocus,
          maxLength,
          ref
        }), enterKeyHintProp), props)
      ),
      clearable && /* @__PURE__ */ React66.createElement(
        InputElements.AffixContent,
        {
          className: "GDS-clear-input",
          position: "trailing"
        },
        /* @__PURE__ */ React66.createElement(
          Button,
          {
            className: "GDS-clear-input-button",
            type: "button",
            icon: "tinyClear",
            hideLabel: true,
            quiet: true,
            priority: "secondary",
            size: "toolbar",
            disabled,
            onClick: onClear
          },
          clearLabel || stringsMap.clear
        )
      )
    ));
  }
);
BaseInput.displayName = "BaseInput";

// src/components/forms/text-input/text-input.tsx
import React67, { forwardRef as forwardRef41, useCallback as useCallback6, useRef as useRef9 } from "react";
var DISPLAY_NAME35 = "TextInput";
var TextInputGroup = transformingStyled("div", {
  display: "flex",
  '[class*="GDS"]:focus': __spreadValues({}, focusOutlineInner)
});
var TextInputWrapper = transformingStyled("div", __spreadProps(__spreadValues({
  position: "relative",
  display: "flex",
  alignItems: "stretch",
  flex: 1
}, affixedStyles), {
  "> .GDS-base-input-wrapper.GDS-affixed-base": {
    flex: 1
  },
  // Styles for input with add ons
  // Border style when input is not the first child, i.e. it has an AddOn at the start
  "&:where(.GDS-text-input-wrapper:not(:first-child)) > .GDS-base-input-wrapper > input": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0"
  },
  // Border style when input is not the last child, i.e. it has an AddOn at the end
  "&:where(.GDS-text-input-wrapper:not(:last-child)) > .GDS-base-input-wrapper > input": {
    borderStartStartRadius: "$medium",
    borderEndStartRadius: "$medium",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0"
  },
  // Border style when input is neither the first nor the last child, i.e. it has an AddOn on each end
  "&:where(.GDS-text-input-wrapper:not(:first-child):not(:last-child)) > .GDS-base-input-wrapper > input": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0"
  },
  // Border style when input has a affixed content and it is not the first child,
  // i.e. it has an AddOn at the start with trailing and/or leading content
  "&:is(.GDS-affixed:not(:first-child))": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0"
  },
  // Border style when input has a affixed content and it is not the last child,
  // i.e. it has an AddOn at the end with trailing and/or leading content
  "&:is(.GDS-affixed:not(:last-child))": {
    borderStartStartRadius: "$medium",
    borderEndStartRadius: "$medium",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0"
  },
  // Border style when input is neither the first nor the last child,
  // i.e. it has an AddOn on each end with trailing and/or leading content
  "&:is(.GDS-affixed:not(:first-child):not(:last-child))": {
    borderStartStartRadius: "0",
    borderEndStartRadius: "0",
    borderStartEndRadius: "0",
    borderEndEndRadius: "0",
    flex: 1
  },
  "&:is(.GDS-affixed.GDS-input-status-success)": {
    borderColor: "$inputBorderSuccess"
  },
  "&:is(.GDS-affixed.GDS-input-status-warning)": {
    borderColor: "$inputBorderWarning"
  },
  "&:is(.GDS-affixed.GDS-input-status-error)": {
    borderColor: "$inputBorderCritical"
  },
  "&.GDS-readonly-input": __spreadValues({}, readOnlyInputStyles),
  "&.GDS-disabled-input": __spreadProps(__spreadValues({}, disabledInputStyles), {
    // accounting for hover on disabled inputs when .GDS-disabled-input gets nested in TextInput from BaseInput
    "&:hover": {
      ".GDS-disabled-input": {
        backgroundColor: "$inputBackgroundHovered"
      }
    }
  }),
  "&:is(.GDS-affixed):has(input:disabled)": __spreadProps(__spreadValues({}, disabledInputStyles), {
    // accounting for hover on disabled inputs when .GDS-disabled-input gets nested in TextInput from BaseInput
    "&:hover": {
      backgroundColor: "$inputBackgroundHovered"
    }
  }),
  "&:is(.GDS-affixed):has(input:read-only)": __spreadProps(__spreadValues({}, readOnlyInputStyles), {
    // accounting for hover on disabled inputs when .GDS-disabled-input gets nested in TextInput from BaseInput
    "&:hover": {
      backgroundColor: "$inputBackgroundHovered"
    }
  })
}));
var TextInput = forwardRef41(
  (_a, ref) => {
    var _b = _a, {
      "data-testid": testId = `GDS-${DISPLAY_NAME35}`,
      addOnEnd,
      addOnEndIcon,
      addOnEndIconLabel,
      addOnStart,
      addOnStartIcon,
      addOnStartIconLabel,
      ariaDescribedby,
      autoComplete,
      clearable,
      clearLabel,
      css: css2,
      disabled,
      enterKeyHint,
      id,
      inputStatus,
      leadingContent,
      name,
      onClear,
      placeholder,
      readOnly,
      trailingContent,
      type = "text",
      value
    } = _b, props = __objRest(_b, [
      "data-testid",
      "addOnEnd",
      "addOnEndIcon",
      "addOnEndIconLabel",
      "addOnStart",
      "addOnStartIcon",
      "addOnStartIconLabel",
      "ariaDescribedby",
      "autoComplete",
      "clearable",
      "clearLabel",
      "css",
      "disabled",
      "enterKeyHint",
      "id",
      "inputStatus",
      "leadingContent",
      "name",
      "onClear",
      "placeholder",
      "readOnly",
      "trailingContent",
      "type",
      "value"
    ]);
    const textInputGroup = useRef9(null);
    const isAffixed = leadingContent || trailingContent || clearable;
    const setInputFocus = useCallback6(() => {
      var _a2, _b2;
      (_b2 = (_a2 = textInputGroup.current) == null ? void 0 : _a2.querySelector("input")) == null ? void 0 : _b2.focus();
    }, []);
    return /* @__PURE__ */ React67.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME35 }, /* @__PURE__ */ React67.createElement(
      TextInputGroup,
      {
        className: "GDS-text-input-group",
        css: css2,
        "data-testid": testId
      },
      typeof addOnStart === "string" ? /* @__PURE__ */ React67.createElement(InputElements.AddOn, { position: "start" }, addOnStart) : addOnStart,
      addOnStartIcon && /* @__PURE__ */ React67.createElement(
        InputElements.AddOn,
        {
          position: "start",
          icon: addOnStartIcon,
          iconLabel: addOnStartIconLabel
        }
      ),
      /* @__PURE__ */ React67.createElement(
        TextInputWrapper,
        {
          className: `GDS-text-input-wrapper
          ${isAffixed ? "GDS-affixed" : ""}
          ${disabled && clearable ? "GDS-disabled-input" : ""}
          ${readOnly && clearable ? "GDS-readonly-input" : ""}
          ${isAffixed && inputStatus ? `GDS-input-status-${inputStatus}` : ""}`,
          onClick: setInputFocus,
          ref: textInputGroup
        },
        leadingContent && /* @__PURE__ */ React67.createElement(InputElements.AffixContent, { position: "leading" }, leadingContent),
        /* @__PURE__ */ React67.createElement(
          BaseInput,
          __spreadValues({
            ariaDescribedby,
            autoComplete,
            clearable,
            clearLabel,
            disabled,
            enterKeyHint,
            id,
            inputStatus,
            name,
            onClear,
            placeholder,
            readOnly,
            ref,
            type,
            value
          }, props)
        ),
        trailingContent && /* @__PURE__ */ React67.createElement(InputElements.AffixContent, { position: "trailing" }, trailingContent)
      ),
      typeof addOnEnd === "string" ? /* @__PURE__ */ React67.createElement(InputElements.AddOn, { position: "end" }, addOnEnd) : addOnEnd,
      addOnEndIcon && /* @__PURE__ */ React67.createElement(
        InputElements.AddOn,
        {
          position: "end",
          icon: addOnEndIcon,
          iconLabel: addOnEndIconLabel
        }
      )
    ));
  }
);
TextInput.displayName = DISPLAY_NAME35;

// src/components/forms/form-field/form-field.tsx
import React74, {
  forwardRef as forwardRef43,
  Children as Children4,
  cloneElement as cloneElement2,
  isValidElement as isValidElement7
} from "react";

// src/components/forms/component-generators.tsx
import React73, {
  cloneElement,
  isValidElement as isValidElement6
} from "react";

// src/components/forms/form-field-elements/input-label.tsx
import React69, { forwardRef as forwardRef42, isValidElement as isValidElement4 } from "react";

// src/components/forms/form-field-elements/label-text.tsx
import React68 from "react";
var OptionalFlag = transformingStyled("span", {
  typography: "$caption",
  color: "$onSurfaceTextSubdued"
});
var StyledSpan = transformingStyled("span");
var LabelText = ({
  children,
  required
}) => {
  const { optional } = useThemeStrings();
  return /* @__PURE__ */ React68.createElement(React68.Fragment, null, /* @__PURE__ */ React68.createElement(StyledSpan, __spreadValues({}, !required && { css: { marginInlineEnd: "$quarter" } }), children), !required && /* @__PURE__ */ React68.createElement(OptionalFlag, null, `(${optional})`));
};

// src/components/forms/form-field-elements/input-label.tsx
var DISPLAY_NAME36 = "InputLabel";
var LabelBase = transformingStyled("label", __spreadProps(__spreadValues({}, labelLegendStyles), {
  display: "flex",
  flexWrap: "wrap"
}));
var InputLabel = forwardRef42(
  (_a, ref) => {
    var _b = _a, {
      htmlFor,
      hideLabel,
      children,
      required,
      tooltip,
      className,
      css: css2,
      "data-testid": testId = `GDS-${DISPLAY_NAME36}`
    } = _b, props = __objRest(_b, [
      "htmlFor",
      "hideLabel",
      "children",
      "required",
      "tooltip",
      "className",
      "css",
      "data-testid"
    ]);
    const responsiveHideLabel = useResponsiveProp(hideLabel);
    if (responsiveHideLabel)
      return /* @__PURE__ */ React69.createElement(VisuallyHidden, null, /* @__PURE__ */ React69.createElement("label", __spreadValues({ htmlFor, ref }, props), /* @__PURE__ */ React69.createElement(LabelText, { required }, children)));
    return /* @__PURE__ */ React69.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME36 }, /* @__PURE__ */ React69.createElement(
      LabelBase,
      __spreadValues({
        htmlFor,
        ref,
        className: ["GDS-input-label", className].join(" "),
        css: css2,
        "data-testid": testId
      }, props),
      /* @__PURE__ */ React69.createElement(LabelText, { required }, children),
      isValidElement4(tooltip) ? tooltip : null
    ));
  }
);
InputLabel.displayName = DISPLAY_NAME36;

// src/components/forms/form-field-elements/fieldset-legend.tsx
import React70, { isValidElement as isValidElement5 } from "react";
var DISPLAY_NAME37 = "FieldsetLegend";
var LegendBase = transformingStyled("legend", labelLegendStyles);
var FieldsetLegend = (_a) => {
  var _b = _a, {
    hideLegend,
    children,
    required,
    tooltip,
    className,
    css: css2,
    "data-testid": testId = `GDS-${DISPLAY_NAME37}`
  } = _b, props = __objRest(_b, [
    "hideLegend",
    "children",
    "required",
    "tooltip",
    "className",
    "css",
    "data-testid"
  ]);
  const responsiveHideLegend = useResponsiveProp(hideLegend);
  const { optional } = useThemeStrings();
  if (responsiveHideLegend)
    return /* @__PURE__ */ React70.createElement(VisuallyHidden, __spreadValues({ as: "legend" }, props), children, !required && `(${optional})`);
  return /* @__PURE__ */ React70.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME37 }, /* @__PURE__ */ React70.createElement(
    LegendBase,
    __spreadValues({
      className: ["GDS-fieldset-legend", className].join(" "),
      css: css2,
      "data-testid": testId
    }, props),
    /* @__PURE__ */ React70.createElement(LabelText, { required }, children),
    isValidElement5(tooltip) ? tooltip : null
  ));
};
FieldsetLegend.displayName = DISPLAY_NAME37;

// src/components/forms/form-field-elements/input-hint.tsx
import React71 from "react";
var DISPLAY_NAME38 = "InputHint";
var HintBase = transformingStyled("span", {
  display: "block",
  margin: 0,
  typography: "$caption",
  color: "$onSurfaceTextSubdued"
});
var InputHint = (_a) => {
  var _b = _a, {
    children,
    className,
    css: css2,
    id,
    "data-testid": testId = `GDS-${DISPLAY_NAME38}`
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "id",
    "data-testid"
  ]);
  return /* @__PURE__ */ React71.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME38 }, /* @__PURE__ */ React71.createElement(
    HintBase,
    __spreadValues({
      className: ["GDS-input-hint", className].join(" "),
      id,
      css: css2,
      "data-testid": testId
    }, props),
    children
  ));
};
InputHint.displayName = DISPLAY_NAME38;

// src/components/forms/form-field-elements/input-status-message.tsx
import React72 from "react";
var DISPLAY_NAME39 = "InputStatusMessage";
var StatusMessageWrapper = transformingStyled("div", {
  marginBlockStart: "$quarter",
  display: "flex",
  alignItems: "center"
});
var StatusMessageBase = transformingStyled("p", {
  margin: 0,
  typography: "$caption",
  variants: {
    status: {
      success: { color: "$onSurfaceTextSuccess" },
      warning: { color: "$onSurfaceTextWarning" },
      error: { color: "$onSurfaceTextCritical" }
    }
  }
});
var icons = {
  success: "tinyValidationCheck",
  warning: "tinyAlert",
  error: "tinyClear"
};
var tints = {
  success: "$inputBorderSuccess",
  warning: "$inputBorderWarning",
  error: "$inputBorderCritical"
};
var InputStatusMessage = (_a) => {
  var _b = _a, {
    children,
    className,
    css: css2,
    hideIcon = false,
    inputStatus,
    statusIconLabel,
    "data-testid": testId = `GDS-${DISPLAY_NAME39}`
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "hideIcon",
    "inputStatus",
    "statusIconLabel",
    "data-testid"
  ]);
  return /* @__PURE__ */ React72.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME39 }, /* @__PURE__ */ React72.createElement(
    StatusMessageWrapper,
    __spreadValues({
      className: ["GDS-input-status-message-wrapper", className].join(" "),
      css: css2,
      "data-testid": testId
    }, props),
    !hideIcon && inputStatus && /* @__PURE__ */ React72.createElement(
      Icon,
      {
        icon: icons[inputStatus],
        tint: tints[inputStatus],
        size: 10,
        label: statusIconLabel,
        css: { marginInlineEnd: "$quarter" }
      }
    ),
    /* @__PURE__ */ React72.createElement(
      StatusMessageBase,
      {
        className: ["GDS-input-status-message", className].join(" "),
        status: inputStatus
      },
      children
    )
  ));
};
InputStatusMessage.displayName = DISPLAY_NAME39;

// src/components/forms/component-generators.tsx
var generateInputLabel = ({
  label,
  htmlFor,
  required,
  hideLabel,
  tooltip
}) => {
  if (isReactElement(label)) {
    return cloneElement(label, {
      htmlFor,
      required,
      hideLabel,
      as: "label"
    });
  }
  return /* @__PURE__ */ React73.createElement(
    InputLabel,
    {
      htmlFor,
      required,
      hideLabel,
      tooltip
    },
    label
  );
};
var generateInputHint = ({
  hint,
  hintId,
  css: css2
}) => {
  if (isReactElement(hint)) {
    return cloneElement(hint, {
      id: hintId
    });
  }
  return /* @__PURE__ */ React73.createElement(InputHint, { id: hintId, css: css2 }, hint);
};
var generateLegend = ({
  legend,
  required,
  hideLegend,
  tooltip
}) => {
  if (isReactElement(legend)) {
    return cloneElement(legend, {
      required,
      hideLegend,
      as: "legend"
    });
  }
  return /* @__PURE__ */ React73.createElement(
    FieldsetLegend,
    {
      required,
      hideLegend,
      tooltip
    },
    legend
  );
};
var generateInputStatusMessage = ({
  css: css2,
  id,
  inputStatus,
  statusIconLabel,
  statusMessage
}) => {
  if (isValidElement6(statusMessage)) {
    if (statusMessage.type === InputStatusMessage) {
      return cloneElement(statusMessage, {
        css: css2,
        id,
        inputStatus,
        statusIconLabel
      });
    }
    return cloneElement(statusMessage, {
      css: css2,
      id
    });
  }
  return /* @__PURE__ */ React73.createElement(
    InputStatusMessage,
    {
      id,
      inputStatus,
      statusIconLabel,
      css: css2
    },
    statusMessage
  );
};

// src/components/forms/form-field/form-field.tsx
var DISPLAY_NAME40 = "FormField";
var FormFieldBase = transformingStyled("div", { width: "100%" });
var FormField = forwardRef43(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      hideLabel = false,
      hint,
      id,
      inputStatus,
      label,
      name,
      required = true,
      statusIconLabel,
      statusMessage,
      tooltip,
      autoComplete,
      "data-testid": testId = `GDS-${DISPLAY_NAME40}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "hideLabel",
      "hint",
      "id",
      "inputStatus",
      "label",
      "name",
      "required",
      "statusIconLabel",
      "statusMessage",
      "tooltip",
      "autoComplete",
      "data-testid"
    ]);
    const statusMessageId = `${id}-status-message`;
    const hintId = `${id}-hint`;
    const ariaDescribedBy = [];
    if (statusMessage)
      ariaDescribedBy.push(statusMessageId);
    if (hint)
      ariaDescribedBy.push(hintId);
    if (Children4.count(children) > 1)
      console.warn(
        "More than one child detected. FormField is a wrapper for a single input. For multiple inputs, use Fieldset."
      );
    return /* @__PURE__ */ React74.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME40 }, /* @__PURE__ */ React74.createElement(
      FormFieldBase,
      __spreadValues({
        className: ["GDS-form-field", className].join(" "),
        css: css2,
        ref,
        "data-testid": testId
      }, props),
      label && generateInputLabel({
        label,
        htmlFor: id,
        required,
        hideLabel,
        tooltip
      }),
      hint && generateInputHint({
        hint,
        hintId,
        css: { marginBlockEnd: "$quarter" }
      }),
      /* @__PURE__ */ React74.createElement("div", { className: "GDS-input-wrapper" }, Children4.map(children, (child) => {
        var _a2;
        if (isValidElement7(child)) {
          if ((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2["aria-describedby"])
            ariaDescribedBy.push(child.props["aria-describedby"]);
          return cloneElement2(child, __spreadValues(__spreadValues({
            id,
            name
          }, ariaDescribedBy.length > 0 && {
            "aria-describedby": ariaDescribedBy.join(" ")
          }), isReactElement(child) && { inputStatus, autoComplete }));
        }
        return child;
      })),
      /* @__PURE__ */ React74.createElement("div", { "aria-live": "polite" }, inputStatus && statusMessage && generateInputStatusMessage({
        id: statusMessageId,
        inputStatus,
        statusIconLabel,
        statusMessage
      }))
    ));
  }
);
FormField.displayName = DISPLAY_NAME40;

// src/components/forms/field-set/field-set.tsx
import React75, {
  forwardRef as forwardRef44
} from "react";
var DISPLAY_NAME41 = "Fieldset";
var FieldsetBase = transformingStyled("fieldset", {
  border: 0,
  margin: 0,
  padding: 0,
  width: "100%"
});
var Fieldset = forwardRef44(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      css: css2,
      hideLegend = false,
      hint,
      id,
      inputStatus,
      legend,
      required = true,
      statusMessage,
      tooltip,
      "data-testid": testId = `GDS-${DISPLAY_NAME41}`
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "css",
      "hideLegend",
      "hint",
      "id",
      "inputStatus",
      "legend",
      "required",
      "statusMessage",
      "tooltip",
      "data-testid"
    ]);
    const statusMessageId = id && inputStatus && statusMessage ? `${id}-status-message` : "";
    const hintId = id && hint ? `${id}-hint` : "";
    const composedAriaDescribedBy = [statusMessageId, hintId].filter(Boolean).join(" ");
    if ((hint || statusMessage) && !id)
      console.warn(
        "To use hint or statusMessage, you must also pass the id to Fieldset."
      );
    return /* @__PURE__ */ React75.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME41 }, /* @__PURE__ */ React75.createElement(
      FieldsetBase,
      __spreadValues(__spreadValues({
        ref,
        className: ["GDS-fieldset", className].join(" "),
        css: css2,
        "data-testid": testId
      }, composedAriaDescribedBy && {
        "aria-describedby": composedAriaDescribedBy
      }), props),
      legend && generateLegend({
        legend,
        hideLegend,
        required,
        tooltip
      }),
      hint && id && generateInputHint({
        hint,
        hintId,
        css: { marginBlockEnd: "$quarter" }
      }),
      children,
      inputStatus && statusMessage && id && /* @__PURE__ */ React75.createElement(InputStatusMessage, { id: statusMessageId, inputStatus }, statusMessage)
    ));
  }
);
Fieldset.displayName = DISPLAY_NAME41;

// src/components/forms/selectable/checkbox/checkbox.tsx
import React78, { forwardRef as forwardRef46, isValidElement as isValidElement8 } from "react";

// src/components/forms/selectable/checkbox/checkbox-indicator.tsx
import React77, { forwardRef as forwardRef45, useRef as useRef10, useEffect as useEffect7 } from "react";

// src/components/forms/selectable/selectable-loader.tsx
import React76 from "react";
var BaseSelectableLoader = transformingStyled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$onSurfaceBorderDefault",
  backgroundColor: "$inputBackgroundDefault",
  width: "$oneAndHalf",
  height: "$oneAndHalf",
  position: "absolute",
  top: "0",
  bottom: "0",
  insetInlineEnd: "0",
  pointerEvents: "none"
});
var SelectableLoaderWrapper = transformingStyled("span", {
  display: "flex",
  position: "relative"
});
var SelectableLoader = (_a) => {
  var _b = _a, {
    inputType,
    loading,
    css: css2
  } = _b, props = __objRest(_b, [
    "inputType",
    "loading",
    "css"
  ]);
  return /* @__PURE__ */ React76.createElement(
    BaseSelectableLoader,
    __spreadValues({
      className: "GDS-selectable-loader",
      css: {
        borderRadius: inputType === "radio" ? "$circle" : "$medium"
      }
    }, props),
    /* @__PURE__ */ React76.createElement(Spinner, { loading, size: "$one" })
  );
};

// src/components/forms/selectable/checkbox/checkbox-indicator.tsx
var DISPLAY_NAME42 = "CheckboxIndicator";
var getCheckmarkUri = (color) => `"data:image/svg+xml;charset=UTF-8,%3csvg id='interfaceCheckmark' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='${encodeURIComponent(
  color
)}' fill-rule='evenodd' d='M19.507 6.448a.75.75 0 0 1 .045 1.06l-9.187 10a.75.75 0 0 1-1.105 0l-4.812-5.239a.75.75 0 1 1 1.104-1.014l4.26 4.636 8.636-9.398a.75.75 0 0 1 1.06-.045Z' clip-rule='evenodd'/%3e%3c/svg%3e"`;
var getDashUri = (color) => `"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 2'%3e%3cpath fill='${encodeURIComponent(
  color
)}' fill-rule='evenodd' d='M0 .75A.75.75 0 0 1 .75 0h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 .75Z' clip-rule='evenodd'/%3e%3c/svg%3e"`;
var disabledStyles = {
  borderWidth: "$thin",
  borderStyle: "solid",
  borderColor: "$inputBorderDisabled",
  backgroundColor: "$inputBackgroundDisabled"
};
var CheckboxBase = transformingStyled("input", {
  appearance: "none",
  margin: 0,
  height: "$oneAndHalf",
  width: "$oneAndHalf",
  minWidth: "$oneAndHalf",
  backgroundColor: "$inputBackgroundDefault",
  borderColor: "$onSurfaceBorderDefault",
  borderStyle: "solid",
  borderWidth: "$thin",
  borderRadius: "$medium",
  transition: "background $defaultTime ease-in-out, border $defaultTime ease-in-out",
  "&:checked, &:indeterminate": {
    borderColor: "$interactiveActionPrimary",
    backgroundColor: "$interactiveActionPrimary",
    "&:before": {
      content: "",
      height: "100%"
    }
  },
  "&:indeterminate": {
    paddingInlineStart: "3px",
    paddingInlineEnd: "3px"
  },
  '&:disabled,&[aria-disabled="true"]': __spreadProps(__spreadValues({}, disabledStyles), {
    pointerEvents: "none"
  }),
  ' &[aria-readonly="true"]': disabledStyles,
  "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
    borderColor: "$interactiveActionPrimary",
    backgroundColor: "$interactiveActionPrimary",
    "& svg": {
      color: "$onSurfaceTextReversed"
    }
  },
  variants: {
    inputStatus: {
      error: {
        borderColor: "$inputBorderCritical",
        "&:checked:not([disabled]), &:indeterminate:not([disabled])": {
          backgroundColor: "$inputBorderCritical",
          borderColor: "$inputBorderCritical"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          "& svg": {
            color: "$inputBorderCritical"
          }
        },
        "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          backgroundColor: "$inputBorderCritical",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:checked:not([disabled]), &:indeterminate:not([disabled])": {
          backgroundColor: "$inputBorderWarning",
          borderColor: "$inputBorderWarning"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          "& svg": {
            color: "$inputBorderWarning"
          }
        },
        "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          backgroundColor: "$inputBorderWarning",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      success: {
        borderColor: "$inputBorderSuccess",
        "&:checked:not([disabled]), &:indeterminate:not([disabled])": {
          borderColor: "$inputBorderSuccess",
          backgroundColor: "$inputBorderSuccess"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          "& svg": {
            color: "$inputBorderSuccess"
          }
        },
        "&:checked ~ .GDS-selectable-loader, &:indeterminate ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          backgroundColor: "$inputBorderSuccess",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      }
    }
  }
});
var CheckboxIndicator = forwardRef45(
  (_a, ref) => {
    var _b = _a, {
      id,
      name,
      indeterminate = false,
      inputStatus,
      loading,
      value,
      checked,
      disabled,
      required,
      "aria-required": ariaRequired,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "aria-readonly": ariaReadonly,
      "data-testid": testId = `GDS-${DISPLAY_NAME42}`,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className = "",
      css: css2
    } = _b, props = __objRest(_b, [
      "id",
      "name",
      "indeterminate",
      "inputStatus",
      "loading",
      "value",
      "checked",
      "disabled",
      "required",
      "aria-required",
      "aria-disabled",
      "aria-describedby",
      "aria-readonly",
      "data-testid",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "css"
    ]);
    const inputRef = useRef10(null);
    useEffect7(() => {
      if (inputRef.current) {
        inputRef.current.indeterminate = indeterminate;
      }
    }, [inputRef, indeterminate]);
    const theme2 = useTheme();
    return /* @__PURE__ */ React77.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME42 }, /* @__PURE__ */ React77.createElement(SelectableLoaderWrapper, null, /* @__PURE__ */ React77.createElement(
      CheckboxBase,
      __spreadValues(__spreadProps(__spreadValues({
        type: "checkbox",
        id,
        value,
        name,
        checked,
        className: ["GDS-checkbox-input", className].join(" "),
        inputStatus
      }, inputStatus === "error" && { "aria-invalid": true }), {
        disabled,
        required,
        "aria-required": ariaRequired,
        "aria-disabled": ariaDisabled,
        "aria-describedby": ariaDescribedby,
        "aria-readonly": ariaReadonly,
        "data-testid": testId,
        onClick,
        onChange,
        onBlur,
        onFocus,
        ref: ref || inputRef,
        css: __spreadProps(__spreadValues({}, css2), {
          "&:checked": {
            "&:before": {
              content: `url(${getCheckmarkUri(
                theme2.colors.interactiveIconDefault.value
              )})`
            }
          },
          '&:checked:disabled, &:checked[aria-disabled="true"]': {
            "&:before": {
              content: `url(${getCheckmarkUri(
                theme2.colors.onSurfaceTextSubdued.value
              )})`
            }
          },
          '&:checked[aria-readonly="true"]': {
            "&:before": {
              content: `url(${getCheckmarkUri(
                theme2.colors.onSurfaceTextPrimary.value
              )})`
            }
          },
          "&:indeterminate": {
            "&:before": {
              content: `url(${getDashUri(
                theme2.colors.interactiveIconDefault.value
              )})`
            }
          },
          '&:indeterminate:disabled, &:indeterminate[aria-disabled="true"]': {
            "&:before": {
              content: `url(${getDashUri(
                theme2.colors.onSurfaceTextSubdued.value
              )})`
            }
          },
          '&:indeterminate[aria-readonly="true"]': {
            "&:before": {
              content: `url(${getDashUri(
                theme2.colors.onSurfaceTextPrimary.value
              )})`
            }
          }
        })
      }), props)
    ), loading && /* @__PURE__ */ React77.createElement(SelectableLoader, { inputType: "checkbox", loading })));
  }
);
CheckboxIndicator.displayName = DISPLAY_NAME42;

// src/components/forms/selectable/checkbox/checkbox.tsx
var DISPLAY_NAME43 = "Checkbox";
var LabelText2 = transformingStyled("span", {
  typography: "$bodyOne",
  variants: {
    disabled: {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    },
    "aria-disabled": {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    }
  }
});
var labelPadding = "$half";
var CheckboxLabel = transformingStyled("label", {
  gap: "$half",
  borderRadius: "$medium",
  padding: labelPadding,
  "&:hover": {
    backgroundColor: "$inputBackgroundHovered"
  },
  "&:active": {
    backgroundColor: "$inputBackgroundPressed"
  },
  variants: {
    layout: {
      inline: {
        display: "inline-flex",
        "&:focus-within": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      },
      row: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        "&:focus-within:has(input:focus)": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      }
    },
    disabled: {
      false: {},
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    "aria-disabled": {
      false: {},
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  }
});
var Wrapper = transformingStyled("div");
var Checkbox = forwardRef46(
  (_a, ref) => {
    var _b = _a, {
      label,
      layout = "inline",
      css: css2,
      id,
      name,
      required,
      hint,
      checked,
      inputStatus,
      disabled,
      "aria-required": ariaRequired,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "data-testid": testId = `GDS-${DISPLAY_NAME43}`,
      value,
      indeterminate,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className,
      loading
    } = _b, props = __objRest(_b, [
      "label",
      "layout",
      "css",
      "id",
      "name",
      "required",
      "hint",
      "checked",
      "inputStatus",
      "disabled",
      "aria-required",
      "aria-disabled",
      "aria-describedby",
      "data-testid",
      "value",
      "indeterminate",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "loading"
    ]);
    const hintId = `${id}-hint`;
    return layout === "row" ? /* @__PURE__ */ React78.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME43 }, /* @__PURE__ */ React78.createElement(
      Wrapper,
      {
        className: "GDS-checkbox-row",
        css: __spreadProps(__spreadValues({}, css2), { width: "100%" }),
        "data-testid": testId
      },
      /* @__PURE__ */ React78.createElement(
        CheckboxLabel,
        {
          className: "GDS-checkbox-label",
          layout,
          htmlFor: id,
          disabled,
          "aria-disabled": ariaDisabled
        },
        /* @__PURE__ */ React78.createElement("span", null, /* @__PURE__ */ React78.createElement(
          LabelText2,
          {
            disabled,
            "aria-disabled": ariaDisabled,
            className: "GDS-checkbox-label-text"
          },
          label
        ), /* @__PURE__ */ React78.createElement("span", { className: "GDS-checkbox-hint" }, hint && generateInputHint({
          hintId,
          hint,
          css: { marginBlockStart: "$quarter" }
        }))),
        /* @__PURE__ */ React78.createElement(
          CheckboxIndicator,
          __spreadValues({
            id,
            name,
            indeterminate,
            inputStatus,
            loading,
            value,
            checked,
            disabled,
            required,
            "aria-required": ariaRequired,
            "aria-disabled": ariaDisabled,
            "aria-describedby": ariaDescribedby,
            onClick,
            onChange,
            onBlur,
            onFocus,
            className,
            ref,
            css: {
              marginInlineStart: "$half"
            }
          }, props)
        )
      )
    )) : /* @__PURE__ */ React78.createElement(GenesisCoreInspector, { displayName: "Checkbox" }, /* @__PURE__ */ React78.createElement(Wrapper, { className: "GDS-checkbox-inline", css: css2 }, /* @__PURE__ */ React78.createElement(
      CheckboxLabel,
      {
        className: "GDS-checkbox-label",
        layout,
        htmlFor: id,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React78.createElement(
        CheckboxIndicator,
        __spreadValues({
          id,
          name,
          indeterminate,
          inputStatus,
          loading,
          value,
          checked,
          disabled,
          required,
          "aria-required": ariaRequired,
          "aria-disabled": ariaDisabled,
          "aria-describedby": `${hintId}${ariaDescribedby ? ` ${ariaDescribedby}` : ""}`,
          onClick,
          onChange,
          onBlur,
          onFocus,
          className,
          ref
        }, props)
      ),
      isValidElement8(label) ? label : /* @__PURE__ */ React78.createElement(
        LabelText2,
        {
          disabled,
          "aria-disabled": ariaDisabled,
          className: "GDS-checkbox-label-text"
        },
        label
      )
    ), hint && /* @__PURE__ */ React78.createElement(
      Wrapper,
      {
        className: "GDS-checkbox-hint",
        css: {
          // CheckboxIndicator width + labelPadding + spacing margin CheckboxIndicator and label
          marginInlineStart: `calc($oneAndHalf + ${labelPadding} + $half)`
        }
      },
      generateInputHint({ hint, hintId })
    )));
  }
);
Checkbox.displayName = DISPLAY_NAME43;

// src/components/forms/selectable/radio/radio.tsx
import React80, { forwardRef as forwardRef48, isValidElement as isValidElement9 } from "react";

// src/components/forms/selectable/radio/radio-indicator.tsx
import React79, { forwardRef as forwardRef47 } from "react";
var DISPLAY_NAME44 = "RadioIndicator";
var RadioBase = transformingStyled("input", {
  appearance: "none",
  borderRadius: "$circle",
  borderWidth: "$thin",
  borderColor: "$onSurfaceBorderDefault",
  borderStyle: "solid",
  backgroundColor: "$inputBackgroundDefault",
  margin: 0,
  width: "$oneAndHalf",
  height: "$oneAndHalf",
  display: "inline-block",
  "vertical-align": "text-bottom",
  position: "relative",
  transition: "box-shadow $defaultTime ease-in-out",
  "&::before": {
    content: "",
    position: "absolute",
    margin: "auto",
    height: 0,
    width: 0,
    insetInlineStart: 0,
    insetInlineEnd: 0,
    bottom: 0,
    overflow: "hidden",
    top: 0,
    transition: "opacity $defaultTime ease-in-out",
    opacity: 0
  },
  "&:checked": {
    borderColor: "$interactiveActionPrimary",
    background: "$interactiveActionPrimary"
  },
  "&:checked::before": {
    border: "4px solid transparent",
    "border-radius": "$circle",
    "outline-offset": "-6px",
    background: "$inputBackgroundDefault",
    opacity: 1
  },
  "&:checked ~ .GDS-selectable-loader": {
    borderColor: "$interactiveActionPrimary",
    backgroundColor: "$interactiveActionPrimary",
    "& svg": {
      color: "$onSurfaceTextReversed"
    }
  },
  '&:disabled, &[aria-disabled="true"], &[aria-readonly="true"]': {
    backgroundColor: "$inputBackgroundDisabled",
    borderColor: "$inputBorderDisabled"
  },
  '&:disabled:checked::before, &[aria-disabled="true"]:checked::before': {
    background: "$onSurfaceTextSubdued"
  },
  '&[aria-readonly="true"]:checked:before': {
    background: "$onSurfaceTextPrimary"
  },
  variants: {
    inputStatus: {
      success: {
        borderColor: "$inputBorderSuccess",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderSuccess"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          "& svg": {
            color: "$inputBorderSuccess"
          }
        },
        "&:checked": {
          borderColor: "$inputBorderSuccess",
          background: "$inputBorderSuccess"
        },
        "&:checked ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderSuccess",
          backgroundColor: "$inputBorderSuccess",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderWarning"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          "& svg": {
            color: "$inputBorderWarning"
          }
        },
        "&:checked": {
          borderColor: "$inputBorderWarning",
          background: "$inputBorderWarning"
        },
        "&:checked ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderWarning",
          backgroundColor: "$inputBorderWarning",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      },
      error: {
        borderColor: "$inputBorderCritical",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderCritical"
        },
        "& ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          "& svg": {
            color: "$inputBorderCritical"
          }
        },
        "&:checked": {
          borderColor: "$inputBorderCritical",
          background: "$inputBorderCritical"
        },
        "&:checked ~ .GDS-selectable-loader": {
          borderColor: "$inputBorderCritical",
          backgroundColor: "$inputBorderCritical",
          "& svg": {
            color: "$onSurfaceTextReversed"
          }
        }
      }
    }
  }
});
var RadioIndicator = forwardRef47(
  (_a, ref) => {
    var _b = _a, {
      id,
      name,
      value,
      required,
      checked,
      inputStatus,
      loading,
      disabled,
      "aria-required": ariaRequired,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "aria-readonly": ariaReadonly,
      "data-testid": testId = `GDS-${DISPLAY_NAME44}`,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className = "",
      css: css2
    } = _b, props = __objRest(_b, [
      "id",
      "name",
      "value",
      "required",
      "checked",
      "inputStatus",
      "loading",
      "disabled",
      "aria-required",
      "aria-disabled",
      "aria-describedby",
      "aria-readonly",
      "data-testid",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "css"
    ]);
    return /* @__PURE__ */ React79.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME44 }, /* @__PURE__ */ React79.createElement(SelectableLoaderWrapper, null, /* @__PURE__ */ React79.createElement(
      RadioBase,
      __spreadValues(__spreadProps(__spreadValues({
        type: "radio",
        id,
        value,
        name,
        checked,
        className: ["GDS-radio", className].join(" "),
        inputStatus
      }, inputStatus === "error" && { "aria-invalid": true }), {
        required,
        disabled,
        "aria-required": ariaRequired,
        "aria-disabled": ariaDisabled,
        "aria-describedby": ariaDescribedby,
        "aria-readonly": ariaReadonly,
        "data-testid": testId,
        onClick,
        onChange,
        onBlur,
        onFocus,
        css: css2,
        ref
      }), props)
    ), loading && /* @__PURE__ */ React79.createElement(SelectableLoader, { inputType: "radio", loading })));
  }
);
RadioIndicator.displayName = DISPLAY_NAME44;

// src/components/forms/selectable/radio/radio.tsx
var DISPLAY_NAME45 = "Radio";
var SelectableInputLabel = transformingStyled("label", {
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary",
  gap: "$one",
  borderRadius: "$medium",
  padding: "$half",
  "&:hover": {
    backgroundColor: "$inputBackgroundHovered"
  },
  "&:active": {
    backgroundColor: "$inputBackgroundPressed"
  },
  variants: {
    layout: {
      inline: {
        display: "inline-flex",
        "&:focus-within": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      },
      row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "&:focus-within:has(input:focus)": __spreadProps(__spreadValues({}, focusOutlineInner), {
          input: {
            '&[class*="GDS"]': {
              outline: "none"
            }
          }
        })
      }
    },
    disabled: {
      false: {},
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    "aria-disabled": {
      false: {},
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  }
});
var RadioLabelText = transformingStyled("span", {
  variants: {
    disabled: {
      false: {},
      true: { color: "$onSurfaceTextSubdued" }
    },
    "aria-disabled": {
      false: {},
      true: { color: "$onSurfaceTextSubdued" }
    }
  }
});
var RadioWrapper = transformingStyled("div");
var StyledRadioHint = transformingStyled("span", { display: "block" });
var Radio = forwardRef48(
  (_a, ref) => {
    var _b = _a, {
      label,
      layout = "inline",
      css: css2,
      id,
      name,
      required,
      hint,
      checked,
      inputStatus,
      disabled,
      "aria-required": ariaRequired,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "aria-readonly": ariaReadonly,
      "data-testid": testId = `GDS-${DISPLAY_NAME45}`,
      value,
      onClick,
      onChange,
      onBlur,
      onFocus,
      className,
      loading
    } = _b, props = __objRest(_b, [
      "label",
      "layout",
      "css",
      "id",
      "name",
      "required",
      "hint",
      "checked",
      "inputStatus",
      "disabled",
      "aria-required",
      "aria-disabled",
      "aria-describedby",
      "aria-readonly",
      "data-testid",
      "value",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "className",
      "loading"
    ]);
    const hintId = `${id}-hint`;
    return layout === "inline" ? /* @__PURE__ */ React80.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME45 }, /* @__PURE__ */ React80.createElement(RadioWrapper, { className: "GDS-radio-inline", css: css2 }, /* @__PURE__ */ React80.createElement(
      SelectableInputLabel,
      {
        htmlFor: id,
        className: "GDS-radio-label",
        layout,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React80.createElement(
        RadioIndicator,
        __spreadValues({
          value,
          name,
          id,
          inputStatus,
          checked,
          loading,
          disabled,
          required,
          "aria-required": ariaRequired,
          "aria-disabled": ariaDisabled,
          "aria-describedby": `${hintId}${ariaDescribedby ? ` ${ariaDescribedby}` : ""}`,
          "aria-readonly": ariaReadonly,
          "data-testid": testId,
          onClick,
          onChange,
          onBlur,
          onFocus,
          ref
        }, props)
      ),
      isValidElement9(label) ? label : /* @__PURE__ */ React80.createElement(RadioLabelText, { disabled, "aria-disabled": ariaDisabled }, label)
    ), hint && /* @__PURE__ */ React80.createElement(
      StyledRadioHint,
      {
        className: "GDS-radio-hint",
        css: {
          // calc hint margin to include input size, padding and spacing values
          marginInlineStart: `calc($one + $oneAndHalf + $half)`
        }
      },
      generateInputHint({ hint, hintId })
    ))) : /* @__PURE__ */ React80.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME45 }, /* @__PURE__ */ React80.createElement(RadioWrapper, { className: "GDS-radio-row", css: css2 }, /* @__PURE__ */ React80.createElement(
      SelectableInputLabel,
      {
        htmlFor: id,
        className: "GDS-radio-label-hint",
        layout,
        disabled,
        "aria-disabled": ariaDisabled
      },
      /* @__PURE__ */ React80.createElement("span", null, isValidElement9(label) ? label : /* @__PURE__ */ React80.createElement(
        RadioLabelText,
        {
          disabled,
          "aria-disabled": ariaDisabled,
          className: "GDS-radio-label"
        },
        label
      ), hint && /* @__PURE__ */ React80.createElement(
        StyledRadioHint,
        {
          className: "GDS-radio-hint",
          css: { marginBlockStart: "$quarter" }
        },
        generateInputHint({ hint, hintId })
      )),
      /* @__PURE__ */ React80.createElement(
        RadioIndicator,
        __spreadValues({
          value,
          name,
          id,
          inputStatus,
          checked,
          loading,
          required,
          disabled,
          "aria-required": ariaRequired,
          "aria-disabled": ariaDisabled,
          "aria-describedby": ariaDescribedby,
          "aria-readonly": ariaReadonly,
          "data-testid": testId,
          onClick,
          onChange,
          onBlur,
          onFocus,
          ref
        }, props)
      )
    )));
  }
);
Radio.displayName = DISPLAY_NAME45;

// src/components/forms/select/select.tsx
import React81, { forwardRef as forwardRef49, useState as useState8 } from "react";
var DISPLAY_NAME46 = "Select";
var BaseSelect = transformingStyled("select", __spreadProps(__spreadValues({
  appearance: "none"
}, inputBorderStyles), {
  typography: "$bodyTwo",
  width: "100%",
  paddingBlockStart: "$threeQuarters",
  paddingBlockEnd: "$threeQuarters",
  paddingInlineEnd: "calc($one + $oneAndHalf)",
  backgroundColor: "$inputBackgroundDefault",
  "&:hover": {
    borderColor: "$inputBorderHovered",
    backgroundColor: "$inputBackgroundHovered"
  },
  '&[class*="GDS"]:focus, &:active': __spreadValues({
    borderColor: "transparent"
  }, focusOutlineInner),
  '&:disabled, &[aria-disabled="true"]': __spreadValues({}, disabledInputStyles),
  variants: {
    inputStatus: {
      success: {
        borderColor: "$inputBorderSuccess",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderSuccess"
        }
      },
      warning: {
        borderColor: "$inputBorderWarning",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderWarning"
        }
      },
      error: {
        borderColor: "$inputBorderCritical",
        "&:hover:not(:focus)": {
          borderColor: "$inputBorderCritical"
        }
      }
    }
  }
}));
var SelectWrapper = transformingStyled("div", {
  position: "relative"
});
var sharedIconWrapperStyles = {
  display: "flex",
  position: "absolute",
  pointerEvents: "none",
  transformOrigin: "center",
  transform: "translateY(-50%)",
  top: "50%",
  insetBlockStart: "50%"
};
var LeadingIconWrapper = transformingStyled("div", __spreadProps(__spreadValues({}, sharedIconWrapperStyles), {
  insetInlineStart: "$one"
}));
var TrailingIconWrapper = transformingStyled("div", __spreadProps(__spreadValues({}, sharedIconWrapperStyles), {
  insetInlineEnd: "$one"
}));
var generateOptionElement = ({
  key,
  value,
  label,
  disabled
}) => /* @__PURE__ */ React81.createElement("option", { key: key || value, value, disabled }, label || value);
var LeadingIcon = ({ icon }) => {
  const { isGDSIconToken } = useGDSIcon();
  if (isGDSIconToken(icon))
    return /* @__PURE__ */ React81.createElement(Icon, { icon, tint: "$onSurfaceIconPrimary" });
  if (React81.isValidElement(icon)) {
    if (isIcon(icon)) {
      return icon;
    }
  }
  return null;
};
var Select = forwardRef49(
  (_a, ref) => {
    var _b = _a, {
      id,
      value,
      defaultValue,
      className,
      leadingIcon,
      loading,
      disabled,
      placeholder,
      options: options2,
      children,
      inputStatus,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "data-testid": testId = `GDS-${DISPLAY_NAME46}`,
      autoComplete,
      css: css2,
      onClick,
      onChange: onChangeProp = (e) => e,
      onBlur,
      onFocus
    } = _b, props = __objRest(_b, [
      "id",
      "value",
      "defaultValue",
      "className",
      "leadingIcon",
      "loading",
      "disabled",
      "placeholder",
      "options",
      "children",
      "inputStatus",
      "aria-disabled",
      "aria-describedby",
      "data-testid",
      "autoComplete",
      "css",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus"
    ]);
    const [hasValue, setHasValue] = useState8(Boolean(value || defaultValue));
    const onChange = (evt) => {
      var _a2;
      const eventValue = (_a2 = evt == null ? void 0 : evt.currentTarget) == null ? void 0 : _a2.value;
      setHasValue(Boolean(eventValue));
      onChangeProp(evt);
    };
    if (options2 && children) {
      console.warn(
        "The Select component accepts either the options props or child option elements, not both."
      );
    }
    return /* @__PURE__ */ React81.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME46 }, /* @__PURE__ */ React81.createElement(
      SelectWrapper,
      {
        className: ["GDS-select", className].join(" "),
        css: css2
      },
      leadingIcon && /* @__PURE__ */ React81.createElement(LeadingIconWrapper, { className: "GDS-select-leading-icon" }, /* @__PURE__ */ React81.createElement(LeadingIcon, { icon: leadingIcon })),
      /* @__PURE__ */ React81.createElement(
        BaseSelect,
        __spreadValues(__spreadProps(__spreadValues({
          id,
          value,
          defaultValue,
          className: "GDS-select-menu",
          disabled,
          autoComplete,
          inputStatus
        }, inputStatus === "error" && { "aria-invalid": true }), {
          "aria-disabled": ariaDisabled,
          "aria-describedby": ariaDescribedby,
          "data-testid": testId,
          css: __spreadValues(__spreadValues({}, leadingIcon ? { paddingInlineStart: "calc($one + $oneAndHalf + $half)" } : { paddingInlineStart: "$one" }), hasValue ? { color: "$onSurfaceTextPrimary" } : { color: "$onSurfaceTextSubdued" }),
          ref,
          onClick,
          onChange,
          onBlur,
          onFocus
        }), props),
        placeholder && /* @__PURE__ */ React81.createElement("option", { value: "", disabled: true }, placeholder),
        (options2 == null ? void 0 : options2.length) ? options2.map((option) => {
          if ("value" in option)
            return generateOptionElement(option);
          if ("options" in option)
            return /* @__PURE__ */ React81.createElement(
              "optgroup",
              {
                key: option.key || option.label,
                label: option.label,
                disabled: option.disabled
              },
              option.options.map(
                (element) => generateOptionElement(element)
              )
            );
          console.warn(
            "Incorrectly formatted options array. Please refer to Genesis Core Select documentation for correct formatting."
          );
          return null;
        }) : children
      ),
      /* @__PURE__ */ React81.createElement(TrailingIconWrapper, { className: "GDS-select-trailing-icon" }, loading ? /* @__PURE__ */ React81.createElement(Spinner, { loading }) : /* @__PURE__ */ React81.createElement(Icon, { icon: "interfaceChevronDown", tint: "$onSurfaceIconPrimary" }))
    ));
  }
);
Select.displayName = DISPLAY_NAME46;

// src/components/forms/selectable/choice-button/choice-button.tsx
import React82, { forwardRef as forwardRef50, isValidElement as isValidElement10 } from "react";
var DISPLAY_NAME47 = "ChoiceButton";
var ChoiceButtonWrapper = transformingStyled("div");
var getStatusCheckedStyle = (token) => ({
  "&:checked + label": {
    backgroundColor: token,
    borderColor: "transparent",
    transition: "all $defaultTime ease-in-out, border $defaultTime ease-in-out",
    "&:hover": { backgroundColor: token },
    "&:active": { backgroundColor: token }
  }
});
var disabledStyle2 = {
  backgroundColor: "$interactiveActionDisabled",
  border: "transparent",
  color: "$onSurfaceTextSubdued",
  pointerEvents: "none"
};
var InvisibleInput = transformingStyled("input", __spreadProps(__spreadValues({}, visuallyHiddenStyle), {
  // Style the label and Icon as siblings of input
  "&:checked + label": {
    color: "$onSurfaceTextReversed",
    backgroundColor: "$interactiveActionPrimary",
    borderColor: "transparent",
    transition: "all $defaultTime ease-in-out, border $defaultTime ease-in-out",
    "&:hover": { backgroundColor: "$interactiveActionHovered" },
    "&:active": { backgroundColor: "$interactiveActionPressed" },
    ".internal-icon": {
      opacity: 1,
      transition: "opacity $defaultTime ease-in-out, border $defaultTime ease-in-out"
    }
  },
  "&:disabled + label": disabledStyle2,
  '&[aria-disabled="true"] + label': disabledStyle2,
  '&[aria-readonly="true"] + label': {
    backgroundColor: "$interactiveActionDisabled",
    border: "transparent",
    color: "$onSurfaceTextReversed"
  },
  "&:focus + label": __spreadValues({
    borderColor: "transparent"
  }, focusOutlineInner),
  "&:checked:focus + label": __spreadProps(__spreadValues({
    borderColor: "transparent"
  }, focusOutlineOuter), {
    boxShadow: "none"
  }),
  variants: {
    inputStatus: {
      success: getStatusCheckedStyle("$successIcon"),
      warning: getStatusCheckedStyle("$warningIcon"),
      error: getStatusCheckedStyle("$criticalIcon")
    }
  }
}));
var Label = transformingStyled("label", {
  tabIndex: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingBlockStart: "$threeQuarters",
  paddingBlockEnd: "$threeQuarters",
  paddingInlineEnd: "$one",
  paddingInlineStart: "$one",
  borderRadius: "$inputField",
  border: "$borderWidths$thin solid $inputBorderDefault",
  backgroundColor: "$inputBackgroundDefault",
  color: "$onSurfaceTextPrimary",
  "&:hover": { backgroundColor: "$inputBackgroundHovered" },
  "&:active": { backgroundColor: "$inputBackgroundPressed" },
  variants: {
    inputStatus: {
      success: { borderColor: "$inputBorderSuccess" },
      warning: { borderColor: "$inputBorderWarning" },
      error: { borderColor: "$inputBorderCritical" }
    },
    disabled: {
      false: {},
      true: disabledStyle2
    },
    "aria-disabled": {
      false: {},
      true: disabledStyle2
    }
  }
});
var LabelText3 = transformingStyled("span", {
  typography: "$buttonTwo"
});
var ChoiceButton = forwardRef50(
  (_a, ref) => {
    var _b = _a, {
      label,
      id,
      name,
      inputType,
      checked,
      required,
      hint,
      inputStatus,
      disabled,
      "aria-required": ariaRequired,
      "aria-disabled": ariaDisabled,
      "aria-describedby": ariaDescribedby,
      "data-testid": testId = `GDS-${DISPLAY_NAME47}`,
      value,
      onClick,
      onChange,
      onBlur,
      onFocus,
      loading,
      css: css2
    } = _b, props = __objRest(_b, [
      "label",
      "id",
      "name",
      "inputType",
      "checked",
      "required",
      "hint",
      "inputStatus",
      "disabled",
      "aria-required",
      "aria-disabled",
      "aria-describedby",
      "data-testid",
      "value",
      "onClick",
      "onChange",
      "onBlur",
      "onFocus",
      "loading",
      "css"
    ]);
    if (!inputType) {
      console.warn(
        'No "inputType" prop detected. Please pass either "checkbox" or "radio".'
      );
      return null;
    }
    const hintId = `${id}-hint`;
    const ariaDescribedbyArray = [];
    if (hint)
      ariaDescribedbyArray.push(hintId);
    if (ariaDescribedby)
      ariaDescribedbyArray.push(ariaDescribedby);
    return /* @__PURE__ */ React82.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME47 }, /* @__PURE__ */ React82.createElement(ChoiceButtonWrapper, { className: "GDS-choicebutton", css: css2 }, /* @__PURE__ */ React82.createElement(
      InvisibleInput,
      __spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({
        type: inputType,
        id,
        name,
        checked,
        disabled,
        required,
        "aria-required": ariaRequired,
        "aria-disabled": ariaDisabled
      }, ariaDescribedbyArray.length > 0 && {
        "aria-describedby": ariaDescribedbyArray.join(" ")
      }), {
        "data-testid": testId,
        inputStatus,
        value
      }), inputStatus === "error" && { "aria-invalid": true }), {
        ref,
        onClick,
        onChange,
        onBlur,
        onFocus
      }), props)
    ), /* @__PURE__ */ React82.createElement(
      Label,
      {
        className: "GDS-choicebutton-label",
        htmlFor: id,
        disabled,
        "aria-disabled": ariaDisabled,
        inputStatus
      },
      isValidElement10(label) ? label : /* @__PURE__ */ React82.createElement(LabelText3, { className: "GDS-choicebutton-label-text" }, label),
      loading ? /* @__PURE__ */ React82.createElement(Spinner, { loading, css: { marginInlineStart: "$one" } }) : /* @__PURE__ */ React82.createElement(
        Icon,
        {
          className: "internal-icon",
          icon: "interfaceCheckmark",
          size: 20,
          css: { opacity: 0, marginInlineStart: "$half", minWidth: 20 }
        }
      )
    ), hint && generateInputHint({
      hint,
      css: { marginBlockStart: "$half" },
      hintId
    })));
  }
);
ChoiceButton.displayName = DISPLAY_NAME47;
export {
  BaseInput,
  Box,
  Button,
  ButtonIndicator,
  Card,
  Checkbox,
  CheckboxIndicator,
  ChoiceButton,
  Column,
  ColumnLayout,
  ComposableCard,
  Divider,
  Fieldset,
  FieldsetLegend,
  FormField,
  GDSModalPrimitive,
  GDSPopoverPrimitive,
  GDSTabsPrimitive,
  GDSThemeProvider,
  GDSTooltipPrimitive,
  GenesisCoreInspector,
  HeadingBar,
  HeadingText,
  HtmlToReact,
  Icon,
  Image,
  ImageMessage,
  InputElements,
  InputHint,
  InputLabel,
  InputStatusMessage,
  Modal,
  NavList,
  ParagraphText,
  Popover,
  Portal,
  Radio,
  RadioIndicator,
  Responsive,
  Scrollable,
  Select,
  SkeletonCircle,
  SkeletonRectangle,
  SkeletonText,
  Spinner,
  StackItem,
  StackLayout,
  StatusBadge,
  StatusBanner,
  StatusBannerEmoji,
  Tabs,
  TextAction,
  TextInput,
  Tooltip,
  UtilityText,
  VisuallyHidden,
  archetypeDarkTheme,
  archetypeLightTheme,
  borderWidthTokenMap,
  checkIsTextAction,
  colorTokenMap,
  css,
  focusOutlineInner,
  focusOutlineOuter,
  getFallbackValues,
  getFontWeightNumberByName,
  getFontWeightTokenByNumber,
  getNegativeSpacing,
  getThemeIcons,
  globalCss,
  keyframes,
  leagueTheme,
  loadTheme,
  mediaQueryMap,
  pseudolocalize,
  queryHelpers,
  shouldPseudolocalize,
  spacingTokenMap,
  startsWithBlockLevelTag,
  storybookArchetypeDarkTheme,
  storybookArchetypeLightTheme,
  storybookLeagueTheme,
  transformingStyled as styled,
  toPx,
  toRem,
  useClickableCard,
  useGenesisCoreInspector,
  useMediaQuery,
  useResponsiveProp,
  useTextDirectionality,
  useTheme,
  useThemeIcons,
  useThemeRawValues,
  useThemeStrings
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/genesis-core'] = window.leagueSDKsPresent['@leagueplatform/genesis-core'] || [];
    window.leagueSDKsPresent['@leagueplatform/genesis-core'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/genesis-core'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/genesis-core module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map